import {
  Instant as Instant,
  Clock as Clock,
  LocalDate as LocalDate,
  LocalDateTime as LocalDateTime,
  LocalTime as LocalTime,
  ZoneOffset as ZoneOffset,
  ZoneId as ZoneId,
  ChronoField as ChronoField,
  DateTimeFormatterBuilder as DateTimeFormatterBuilder,
  ResolverStyle as ResolverStyle,
} from '@js-joda/core';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Long2qws0ah9gnpki as Long,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
  Unit_instance104q5opgivhr8 as Unit_instance,
  toLongw1zpgk99d84b as toLong,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  IllegalArgumentException_init_$Init$1elycfkdq8or6 as IllegalArgumentException_init_$Init$,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  captureStack1fzi4aczwc4hg as captureStack,
  IllegalArgumentException_init_$Init$1ihrezc0xr9m4 as IllegalArgumentException_init_$Init$_0,
  IllegalArgumentException_init_$Init$2smot2h1gg2y1 as IllegalArgumentException_init_$Init$_1,
  IllegalArgumentException_init_$Init$l84p0lagzo4a as IllegalArgumentException_init_$Init$_2,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  RuntimeException_init_$Init$2tsgo0d0zc4ff as RuntimeException_init_$Init$,
  RuntimeException_init_$Init$3vk5xtzccwh2x as RuntimeException_init_$Init$_0,
  RuntimeException_init_$Init$pie20kq3b0k5 as RuntimeException_init_$Init$_1,
  RuntimeException1r3t0zl97011n as RuntimeException,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  _Char___init__impl__6a9atx281r2pd9o601g as _Char___init__impl__6a9atx,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  StringBuilder_init_$Create$2mwec1027v00x as StringBuilder_init_$Create$,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString35i91qxh73cps as toString_0,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  hashCodeq5arwsb9dgti as hashCode,
  listOf1jh22dvmctj1r as listOf,
  get_indices3txodfl5wuu5j as get_indices,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  joinToString1cxrrlmo0chqs as joinToString,
  equals2au1ep9vhcato as equals,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  KProperty02ce7r476m8633 as KProperty0,
  lazy2hsh8ze7j6ikd as lazy,
  padStart36w1507hs626a as padStart,
  abs1kdzbjes1idip as abs,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$_0,
  getOrNull1go7ef9ldk0df as getOrNull,
  listOfvhqybd2zx248 as listOf_0,
  emptyList1g2z5xcrvp2zy as emptyList,
  toString30pk9tzaqopn as toString_1,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  toSet2orjxp16sotqu as toSet,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  distinct10qe1scfdvu5k as distinct,
  to2cs3ny02qtbcb as to,
  singleo93pzdgfc557 as single,
  Collection1k04j3hzsbod0 as Collection,
  Char19o2r8palgjof as Char,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  mutableListOf6oorvk2mtdmp as mutableListOf,
  removeLastOrNull3odnlbetbttd4 as removeLastOrNull,
  sortWith4fnm6b3vw03s as sortWith,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$32vb8wlewqrmh as Exception_init_$Init$,
  StringBuilder_init_$Create$23o1ixl6cos5l as StringBuilder_init_$Create$_0,
  joinTo3lkanfaxbzac2 as joinTo,
  plus310ted5e4i90h as plus,
  toMutableList20rdgwi7d3cwi as toMutableList,
  addAll1k27qatfgp3k5 as addAll,
  firstOrNull1982767dljvdy as firstOrNull,
  drop3na99dw9feawf as drop,
  repeat2w4c6j8zoq09o as repeat,
  sortedWith2csnbbb21k0lg as sortedWith,
  binarySearchyyczvdessj07 as binarySearch,
  startsWith641pyr7vf687 as startsWith,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  compareTo3ankvs086tmwq as compareTo,
  removePrefix279df90bhrqqg as removePrefix,
  UnsupportedOperationException_init_$Create$1j11kynu3hen2 as UnsupportedOperationException_init_$Create$,
  Comparable198qfk8pnblz0 as Comparable,
  Char__minus_impl_a2frrhem8aw2sny2of as Char__minus_impl_a2frrh,
  contains2el4s70rdq4ld as contains,
  indexOf1xbs558u7wr52 as indexOf,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  removeRange2614yh20qvds6 as removeRange,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  LazyThreadSafetyMode_PUBLICATION_getInstance2x9bac6dffafm as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
  PrimitiveClasses_getInstance28ukyr6i8fs0q as PrimitiveClasses_getInstance,
  KProperty1ca4yb4wlo496 as KProperty1,
  enumEntries20mr21zbe3az4 as enumEntries,
  numberToLong1a4cndvg6c52s as numberToLong,
  _Duration___get_inWholeSeconds__impl__hpy7b328tt6xo432gi4 as _Duration___get_inWholeSeconds__impl__hpy7b3,
  _Duration___get_nanosecondsComponent__impl__nh19kq2hgm6wtvnt8oj as _Duration___get_nanosecondsComponent__impl__nh19kq,
  Duration__isPositive_impl_tvkkt210kq31702887c as Duration__isPositive_impl_tvkkt2,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  IllegalArgumentException_init_$Create$2yr33wm31g9rk as IllegalArgumentException_init_$Create$_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  numberToDouble210hrknaofnhf as numberToDouble,
  ArithmeticException_init_$Create$d5cjkdy3iwzp as ArithmeticException_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
import {
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  MissingFieldException_init_$Create$drk9dj4n2hab as MissingFieldException_init_$Create$,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
  SerializationException_init_$Create$1byppqmdb64jn as SerializationException_init_$Create$,
  STRING_getInstance2gbamclnmtzqa as STRING_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForObject(System, 'System');
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForCompanion(Companion_1);
initMetadataForCompanion(Companion_2);
initMetadataForClass(DateTimeUnit, 'DateTimeUnit', VOID, VOID, VOID, VOID, VOID, {0: DateTimeUnitSerializer_getInstance});
initMetadataForClass(TimeBased, 'TimeBased', VOID, DateTimeUnit, VOID, VOID, VOID, {0: TimeBasedDateTimeUnitSerializer_getInstance});
initMetadataForClass(DateBased, 'DateBased', VOID, DateTimeUnit, VOID, VOID, VOID, {0: DateBasedDateTimeUnitSerializer_getInstance});
initMetadataForClass(DayBased, 'DayBased', VOID, DateBased, VOID, VOID, VOID, {0: DayBasedDateTimeUnitSerializer_getInstance});
initMetadataForClass(MonthBased, 'MonthBased', VOID, DateBased, VOID, VOID, VOID, {0: MonthBasedDateTimeUnitSerializer_getInstance});
initMetadataForCompanion(Companion_3);
initMetadataForClass(DateTimeFormatException, 'DateTimeFormatException', DateTimeFormatException_init_$Create$, IllegalArgumentException);
initMetadataForClass(DateTimeArithmeticException, 'DateTimeArithmeticException', DateTimeArithmeticException_init_$Create$, RuntimeException);
initMetadataForClass(IllegalTimeZoneException, 'IllegalTimeZoneException', IllegalTimeZoneException_init_$Create$, IllegalArgumentException);
function set_fractionOfSecond(value) {
  this.i2e(value == null ? null : value.b2l(9));
}
function get_fractionOfSecond() {
  var tmp0_safe_receiver = this.j2e();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new DecimalFraction(tmp0_safe_receiver, 9);
  }
  return tmp;
}
initMetadataForInterface(TimeFieldContainer, 'TimeFieldContainer');
initMetadataForInterface(UtcOffsetFieldContainer, 'UtcOffsetFieldContainer');
initMetadataForClass(DateTimeComponentsContents, 'DateTimeComponentsContents', VOID, VOID, [TimeFieldContainer, UtcOffsetFieldContainer]);
initMetadataForCompanion(Companion_4);
initMetadataForObject(Formats, 'Formats');
initMetadataForClass(DateTimeComponents, 'DateTimeComponents');
function appendAlternativeParsingImpl(otherFormats, mainFormat) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(otherFormats.length);
  var inductionVariable = 0;
  var last = otherFormats.length;
  while (inductionVariable < last) {
    var item = otherFormats[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.also' call
    var this_0 = this.c2h();
    item(this_0);
    var tmp$ret$2 = this_0.x2g().r2f();
    destination.e(tmp$ret$2);
  }
  var others = destination;
  // Inline function 'kotlin.also' call
  var this_1 = this.c2h();
  mainFormat(this_1);
  var main = this_1.x2g().r2f();
  this.x2g().a2h(new AlternativesParsingFormatStructure(main, others));
}
function appendOptionalImpl(onZero, format) {
  var tmp = this.x2g();
  // Inline function 'kotlin.also' call
  var this_0 = this.c2h();
  format(this_0);
  tmp.a2h(new OptionalFormatStructure(onZero, this_0.x2g().r2f()));
}
function chars(value) {
  return this.x2g().a2h(new ConstantFormatStructure(value));
}
function build() {
  return new CachedFormatStructure(this.x2g().r2f().k2i_1);
}
initMetadataForInterface(AbstractDateTimeFormatBuilder, 'AbstractDateTimeFormatBuilder');
function year$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.h2h(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.h2h.call(this, padding);
  }
  return tmp;
}
function monthNumber$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.i2h(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.i2h.call(this, padding);
  }
  return tmp;
}
function dayOfMonth$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.g2f(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.g2f.call(this, padding);
  }
  return tmp;
}
initMetadataForInterface(WithDate, 'WithDate');
function year(padding) {
  return this.f2h(new BasicFormatStructure(new YearDirective(padding)));
}
function monthNumber(padding) {
  return this.f2h(new BasicFormatStructure(new MonthDirective(padding)));
}
function monthName(names) {
  return this.f2h(new BasicFormatStructure(new MonthNameDirective(names)));
}
function dayOfMonth(padding) {
  return this.f2h(new BasicFormatStructure(new DayDirective(padding)));
}
function dayOfWeek(names) {
  return this.f2h(new BasicFormatStructure(new DayOfWeekDirective(names)));
}
function date(format) {
  var tmp;
  if (format instanceof LocalDateFormat) {
    this.f2h(format.s2i_1);
    tmp = Unit_instance;
  }
  return tmp;
}
initMetadataForInterface(AbstractWithDateBuilder, 'AbstractWithDateBuilder', VOID, VOID, [WithDate]);
function hour$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.l2h(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.l2h.call(this, padding);
  }
  return tmp;
}
function minute$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.m2h(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.m2h.call(this, padding);
  }
  return tmp;
}
function second$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.n2h(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.n2h.call(this, padding);
  }
  return tmp;
}
initMetadataForInterface(WithTime, 'WithTime');
function hour(padding) {
  return this.g2h(new BasicFormatStructure(new HourDirective(padding)));
}
function minute(padding) {
  return this.g2h(new BasicFormatStructure(new MinuteDirective(padding)));
}
function second(padding) {
  return this.g2h(new BasicFormatStructure(new SecondDirective(padding)));
}
function secondFraction(minLength, maxLength) {
  return this.g2h(new BasicFormatStructure(new FractionalSecondDirective(minLength, maxLength)));
}
function time(format) {
  var tmp;
  if (format instanceof LocalTimeFormat) {
    this.g2h(format.e2l_1);
    tmp = Unit_instance;
  }
  return tmp;
}
initMetadataForInterface(AbstractWithTimeBuilder, 'AbstractWithTimeBuilder', VOID, VOID, [WithTime]);
function addFormatStructureForDate(structure) {
  this.y2g(structure);
}
function addFormatStructureForTime(structure) {
  this.y2g(structure);
}
initMetadataForInterface(AbstractWithDateTimeBuilder, 'AbstractWithDateTimeBuilder', VOID, VOID, [AbstractWithDateBuilder, AbstractWithTimeBuilder, WithDate, WithTime]);
function offsetHours$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.p2h(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.p2h.call(this, padding);
  }
  return tmp;
}
function offsetMinutesOfHour$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.q2h(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.q2h.call(this, padding);
  }
  return tmp;
}
function offsetSecondsOfMinute$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.s2h(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.s2h.call(this, padding);
  }
  return tmp;
}
initMetadataForInterface(WithUtcOffset, 'WithUtcOffset');
function offsetHours(padding) {
  return this.b2h(new SignedFormatStructure(new BasicFormatStructure(new UtcOffsetWholeHoursDirective(padding)), true));
}
function offsetMinutesOfHour(padding) {
  return this.b2h(new BasicFormatStructure(new UtcOffsetMinuteOfHourDirective(padding)));
}
function offsetSecondsOfMinute(padding) {
  return this.b2h(new BasicFormatStructure(new UtcOffsetSecondOfMinuteDirective(padding)));
}
function offset(format) {
  var tmp;
  if (format instanceof UtcOffsetFormat) {
    this.b2h(format.a2n_1);
    tmp = Unit_instance;
  }
  return tmp;
}
initMetadataForInterface(AbstractWithOffsetBuilder, 'AbstractWithOffsetBuilder', VOID, VOID, [WithUtcOffset]);
initMetadataForClass(Builder, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithDateTimeBuilder, AbstractWithOffsetBuilder, WithTime, WithDate, WithUtcOffset]);
initMetadataForClass(AbstractDateTimeFormat, 'AbstractDateTimeFormat');
initMetadataForClass(DateTimeComponentsFormat, 'DateTimeComponentsFormat', VOID, AbstractDateTimeFormat);
initMetadataForClass(TwoDigitNumber, 'TwoDigitNumber');
initMetadataForClass(ThreeDigitNumber, 'ThreeDigitNumber');
initMetadataForClass(Padding, 'Padding', VOID, Enum);
initMetadataForClass(IncompleteLocalDate, 'IncompleteLocalDate', IncompleteLocalDate);
initMetadataForCompanion(Companion_5);
initMetadataForClass(MonthNames, 'MonthNames');
initMetadataForCompanion(Companion_6);
initMetadataForClass(DayOfWeekNames, 'DayOfWeekNames');
initMetadataForCompanion(Companion_7);
initMetadataForClass(Builder_0, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithDateBuilder]);
initMetadataForClass(LocalDateFormat, 'LocalDateFormat', VOID, AbstractDateTimeFormat);
initMetadataForClass(SignedIntFieldFormatDirective, 'SignedIntFieldFormatDirective');
initMetadataForClass(YearDirective, 'YearDirective', VOID, SignedIntFieldFormatDirective);
initMetadataForClass(UnsignedIntFieldFormatDirective, 'UnsignedIntFieldFormatDirective');
initMetadataForClass(MonthDirective, 'MonthDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForClass(NamedUnsignedIntFieldFormatDirective, 'NamedUnsignedIntFieldFormatDirective');
initMetadataForClass(MonthNameDirective, 'MonthNameDirective', VOID, NamedUnsignedIntFieldFormatDirective);
initMetadataForClass(DayDirective, 'DayDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForClass(DayOfWeekDirective, 'DayOfWeekDirective', VOID, NamedUnsignedIntFieldFormatDirective);
initMetadataForObject(DateFields, 'DateFields');
initMetadataForCompanion(Companion_8);
initMetadataForClass(Builder_1, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithDateTimeBuilder]);
initMetadataForClass(LocalDateTimeFormat, 'LocalDateTimeFormat', VOID, AbstractDateTimeFormat);
initMetadataForClass(IncompleteLocalDateTime, 'IncompleteLocalDateTime', IncompleteLocalDateTime, VOID, [TimeFieldContainer]);
initMetadataForClass(IncompleteLocalTime, 'IncompleteLocalTime', IncompleteLocalTime, VOID, [TimeFieldContainer]);
initMetadataForClass(AmPmMarker, 'AmPmMarker', VOID, Enum);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Builder_2, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithTimeBuilder]);
initMetadataForClass(LocalTimeFormat, 'LocalTimeFormat', VOID, AbstractDateTimeFormat);
initMetadataForClass(HourDirective, 'HourDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForClass(MinuteDirective, 'MinuteDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForClass(SecondDirective, 'SecondDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForCompanion(Companion_10);
initMetadataForClass(DecimalFractionFieldFormatDirective, 'DecimalFractionFieldFormatDirective');
initMetadataForClass(FractionalSecondDirective, 'FractionalSecondDirective', VOID, DecimalFractionFieldFormatDirective);
initMetadataForObject(TimeFields, 'TimeFields');
initMetadataForClass(IncompleteUtcOffset, 'IncompleteUtcOffset', IncompleteUtcOffset, VOID, [UtcOffsetFieldContainer]);
initMetadataForClass(UtcOffsetWholeHoursDirective, 'UtcOffsetWholeHoursDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForCompanion(Companion_11);
initMetadataForClass(Builder_3, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithOffsetBuilder]);
initMetadataForClass(UtcOffsetFormat, 'UtcOffsetFormat', VOID, AbstractDateTimeFormat);
initMetadataForClass(OffsetFields$sign$1);
initMetadataForObject(OffsetFields, 'OffsetFields');
initMetadataForClass(UtcOffsetMinuteOfHourDirective, 'UtcOffsetMinuteOfHourDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForClass(UtcOffsetSecondOfMinuteDirective, 'UtcOffsetSecondOfMinuteDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForClass(AppendableFormatStructure, 'AppendableFormatStructure', AppendableFormatStructure);
initMetadataForClass(AssignableString, 'AssignableString');
initMetadataForClass(AbstractFieldSpec, 'AbstractFieldSpec');
initMetadataForClass(GenericFieldSpec, 'GenericFieldSpec', VOID, AbstractFieldSpec);
function getterNotNull(container) {
  var tmp0_elvis_lhs = this.k2o(container);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('Field ' + this.m1d() + ' is not set');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
initMetadataForInterface(Accessor, 'Accessor');
initMetadataForClass(PropertyAccessor, 'PropertyAccessor', VOID, VOID, [Accessor]);
initMetadataForClass(UnsignedFieldSpec, 'UnsignedFieldSpec', VOID, AbstractFieldSpec);
initMetadataForClass(ConcatenatedFormatStructure, 'ConcatenatedFormatStructure');
initMetadataForClass(CachedFormatStructure, 'CachedFormatStructure', VOID, ConcatenatedFormatStructure);
initMetadataForInterface(NonConcatenatedFormatStructure, 'NonConcatenatedFormatStructure');
initMetadataForClass(BasicFormatStructure, 'BasicFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
initMetadataForClass(ConstantFormatStructure, 'ConstantFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
initMetadataForClass(SignedFormatStructure, 'SignedFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(PropertyWithDefault, 'PropertyWithDefault');
initMetadataForClass(OptionalFormatStructure, 'OptionalFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
initMetadataForClass(AlternativesParsingFormatStructure, 'AlternativesParsingFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
initMetadataForClass(ComparisonPredicate, 'ComparisonPredicate');
initMetadataForObject(Truth, 'Truth');
initMetadataForClass(ConjunctionPredicate, 'ConjunctionPredicate');
function format$default(obj, builder, minusNotRequired, $super) {
  minusNotRequired = minusNotRequired === VOID ? false : minusNotRequired;
  var tmp;
  if ($super === VOID) {
    this.d2p(obj, builder, minusNotRequired);
    tmp = Unit_instance;
  } else {
    tmp = $super.d2p.call(this, obj, builder, minusNotRequired);
  }
  return tmp;
}
initMetadataForInterface(FormatterStructure, 'FormatterStructure');
initMetadataForClass(SpacePaddedFormatter, 'SpacePaddedFormatter', VOID, VOID, [FormatterStructure]);
initMetadataForClass(SignedFormatter, 'SignedFormatter', VOID, VOID, [FormatterStructure]);
initMetadataForClass(ConditionalFormatter, 'ConditionalFormatter', VOID, VOID, [FormatterStructure]);
initMetadataForClass(ConcatenatedFormatter, 'ConcatenatedFormatter', VOID, VOID, [FormatterStructure]);
initMetadataForClass(SignedIntFormatterStructure, 'SignedIntFormatterStructure', VOID, VOID, [FormatterStructure]);
initMetadataForClass(UnsignedIntFormatterStructure, 'UnsignedIntFormatterStructure', VOID, VOID, [FormatterStructure]);
initMetadataForClass(StringFormatterStructure, 'StringFormatterStructure', VOID, VOID, [FormatterStructure]);
initMetadataForClass(DecimalFractionFormatterStructure, 'DecimalFractionFormatterStructure', VOID, VOID, [FormatterStructure]);
initMetadataForClass(ConstantStringFormatterStructure, 'ConstantStringFormatterStructure', VOID, VOID, [FormatterStructure]);
initMetadataForClass(NumberConsumer, 'NumberConsumer');
initMetadataForClass(FractionPartConsumer, 'FractionPartConsumer', VOID, NumberConsumer);
initMetadataForClass(ConstantNumberConsumer, 'ConstantNumberConsumer', VOID, NumberConsumer);
initMetadataForObject(ExpectedInt, 'ExpectedInt');
initMetadataForClass(TooManyDigits, 'TooManyDigits');
initMetadataForClass(TooFewDigits, 'TooFewDigits');
initMetadataForClass(WrongConstant, 'WrongConstant');
initMetadataForClass(Conflicting, 'Conflicting');
initMetadataForClass(UnsignedIntConsumer, 'UnsignedIntConsumer', VOID, NumberConsumer);
initMetadataForClass(ParseError, 'ParseError');
initMetadataForCompanion(Companion_13);
initMetadataForClass(ParserState, 'ParserState');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(Parser, 'Parser');
initMetadataForClass(ParserStructure, 'ParserStructure');
initMetadataForClass(ParseException, 'ParseException', VOID, Exception);
initMetadataForClass(TrieNode, 'TrieNode', TrieNode);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(StringSetParserOperation, 'StringSetParserOperation');
initMetadataForClass(NumberSpanParserOperation, 'NumberSpanParserOperation');
initMetadataForClass(PlainStringParserOperation, 'PlainStringParserOperation');
initMetadataForClass(SignParser, 'SignParser');
initMetadataForClass(UnconditionalModification, 'UnconditionalModification');
initMetadataForClass(DecimalFraction, 'DecimalFraction', VOID, VOID, [Comparable]);
initMetadataForObject(TimeBasedDateTimeUnitSerializer, 'TimeBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DateBasedDateTimeUnitSerializer, 'DateBasedDateTimeUnitSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForObject(DayBasedDateTimeUnitSerializer, 'DayBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(MonthBasedDateTimeUnitSerializer, 'MonthBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DateTimeUnitSerializer, 'DateTimeUnitSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForObject(InstantIso8601Serializer, 'InstantIso8601Serializer', VOID, VOID, [KSerializer]);
initMetadataForObject(LocalDateIso8601Serializer, 'LocalDateIso8601Serializer', VOID, VOID, [KSerializer]);
initMetadataForObject(LocalDateTimeIso8601Serializer, 'LocalDateTimeIso8601Serializer', VOID, VOID, [KSerializer]);
initMetadataForObject(LocalTimeIso8601Serializer, 'LocalTimeIso8601Serializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UtcOffsetSerializer, 'UtcOffsetSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(TimeZoneSerializer, 'TimeZoneSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(FixedOffsetTimeZoneSerializer, 'FixedOffsetTimeZoneSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(DayOfWeek_0, 'DayOfWeek', VOID, Enum);
initMetadataForCompanion(Companion_14);
initMetadataForClass(Instant_0, 'Instant', VOID, VOID, [Comparable], VOID, VOID, {0: InstantIso8601Serializer_getInstance});
initMetadataForCompanion(Companion_15);
initMetadataForObject(Formats_0, 'Formats');
initMetadataForClass(LocalDate_0, 'LocalDate', VOID, VOID, [Comparable], VOID, VOID, {0: LocalDateIso8601Serializer_getInstance});
initMetadataForCompanion(Companion_16);
initMetadataForObject(Formats_1, 'Formats');
initMetadataForClass(LocalDateTime_0, 'LocalDateTime', VOID, VOID, [Comparable], VOID, VOID, {0: LocalDateTimeIso8601Serializer_getInstance});
initMetadataForCompanion(Companion_17);
initMetadataForObject(Formats_2, 'Formats');
initMetadataForClass(LocalTime_0, 'LocalTime', VOID, VOID, [Comparable], VOID, VOID, {0: LocalTimeIso8601Serializer_getInstance});
initMetadataForClass(Month_0, 'Month', VOID, Enum);
initMetadataForCompanion(Companion_18);
initMetadataForClass(TimeZone, 'TimeZone', VOID, VOID, VOID, VOID, VOID, {0: TimeZoneSerializer_getInstance});
initMetadataForCompanion(Companion_19);
initMetadataForClass(FixedOffsetTimeZone, 'FixedOffsetTimeZone', VOID, TimeZone, VOID, VOID, VOID, {0: FixedOffsetTimeZoneSerializer_getInstance});
initMetadataForCompanion(Companion_20);
initMetadataForObject(Formats_3, 'Formats');
initMetadataForClass(UtcOffset, 'UtcOffset', VOID, VOID, VOID, VOID, VOID, {0: UtcOffsetSerializer_getInstance});
//endregion
function System() {
}
protoOf(System).w2b = function () {
  return Companion_getInstance_14().w2b();
};
var System_instance;
function System_getInstance() {
  return System_instance;
}
function Companion() {
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function Companion_0() {
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function Companion_1() {
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function Companion_2() {
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function TimeBased(nanoseconds) {
  DateTimeUnit.call(this);
  this.b2c_1 = nanoseconds;
  // Inline function 'kotlin.require' call
  if (!(this.b2c_1.b1(new Long(0, 0)) > 0)) {
    var message = 'Unit duration must be positive, but was ' + this.b2c_1.toString() + ' ns.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (this.b2c_1.v2(new Long(817405952, 838)).equals(new Long(0, 0))) {
    this.c2c_1 = 'HOUR';
    this.d2c_1 = this.b2c_1.u2(new Long(817405952, 838));
  } else {
    if (this.b2c_1.v2(new Long(-129542144, 13)).equals(new Long(0, 0))) {
      this.c2c_1 = 'MINUTE';
      this.d2c_1 = this.b2c_1.u2(new Long(-129542144, 13));
    } else {
      var tmp1 = this.b2c_1;
      // Inline function 'kotlin.Long.rem' call
      var other = 1000000000;
      if (tmp1.v2(toLong(other)).equals(new Long(0, 0))) {
        this.c2c_1 = 'SECOND';
        var tmp = this;
        var tmp3 = this.b2c_1;
        // Inline function 'kotlin.Long.div' call
        var other_0 = 1000000000;
        tmp.d2c_1 = tmp3.u2(toLong(other_0));
      } else {
        // Inline function 'kotlin.Long.rem' call
        if (this.b2c_1.v2(toLong(1000000)).equals(new Long(0, 0))) {
          this.c2c_1 = 'MILLISECOND';
          var tmp_0 = this;
          // Inline function 'kotlin.Long.div' call
          tmp_0.d2c_1 = this.b2c_1.u2(toLong(1000000));
        } else {
          // Inline function 'kotlin.Long.rem' call
          if (this.b2c_1.v2(toLong(1000)).equals(new Long(0, 0))) {
            this.c2c_1 = 'MICROSECOND';
            var tmp_1 = this;
            // Inline function 'kotlin.Long.div' call
            tmp_1.d2c_1 = this.b2c_1.u2(toLong(1000));
          } else {
            this.c2c_1 = 'NANOSECOND';
            this.d2c_1 = this.b2c_1;
          }
        }
      }
    }
  }
}
protoOf(TimeBased).e2c = function (scalar) {
  return new TimeBased(safeMultiply(this.b2c_1, toLong(scalar)));
};
protoOf(TimeBased).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof TimeBased) {
      tmp_0 = this.b2c_1.equals(other.b2c_1);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(TimeBased).hashCode = function () {
  return this.b2c_1.d1() ^ this.b2c_1.c3(32).d1();
};
protoOf(TimeBased).toString = function () {
  return this.f2c(this.d2c_1, this.c2c_1);
};
function DateBased() {
  DateTimeUnit.call(this);
}
function DayBased(days) {
  DateBased.call(this);
  this.h2c_1 = days;
  // Inline function 'kotlin.require' call
  if (!(this.h2c_1 > 0)) {
    var message = 'Unit duration must be positive, but was ' + this.h2c_1 + ' days.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(DayBased).e2c = function (scalar) {
  return new DayBased(safeMultiply_0(this.h2c_1, scalar));
};
protoOf(DayBased).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof DayBased) {
      tmp_0 = this.h2c_1 === other.h2c_1;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(DayBased).hashCode = function () {
  return this.h2c_1 ^ 65536;
};
protoOf(DayBased).toString = function () {
  return (this.h2c_1 % 7 | 0) === 0 ? this.g2c(this.h2c_1 / 7 | 0, 'WEEK') : this.g2c(this.h2c_1, 'DAY');
};
function MonthBased(months) {
  DateBased.call(this);
  this.i2c_1 = months;
  // Inline function 'kotlin.require' call
  if (!(this.i2c_1 > 0)) {
    var message = 'Unit duration must be positive, but was ' + this.i2c_1 + ' months.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(MonthBased).e2c = function (scalar) {
  return new MonthBased(safeMultiply_0(this.i2c_1, scalar));
};
protoOf(MonthBased).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof MonthBased) {
      tmp_0 = this.i2c_1 === other.i2c_1;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(MonthBased).hashCode = function () {
  return this.i2c_1 ^ 131072;
};
protoOf(MonthBased).toString = function () {
  return (this.i2c_1 % 1200 | 0) === 0 ? this.g2c(this.i2c_1 / 1200 | 0, 'CENTURY') : (this.i2c_1 % 12 | 0) === 0 ? this.g2c(this.i2c_1 / 12 | 0, 'YEAR') : (this.i2c_1 % 3 | 0) === 0 ? this.g2c(this.i2c_1 / 3 | 0, 'QUARTER') : this.g2c(this.i2c_1, 'MONTH');
};
function Companion_3() {
  Companion_instance_3 = this;
  this.j2c_1 = new TimeBased(new Long(1, 0));
  this.k2c_1 = this.j2c_1.e2c(1000);
  this.l2c_1 = this.k2c_1.e2c(1000);
  this.m2c_1 = this.l2c_1.e2c(1000);
  this.n2c_1 = this.m2c_1.e2c(60);
  this.o2c_1 = this.n2c_1.e2c(60);
  this.p2c_1 = new DayBased(1);
  this.q2c_1 = this.p2c_1.e2c(7);
  this.r2c_1 = new MonthBased(1);
  this.s2c_1 = this.r2c_1.e2c(3);
  this.t2c_1 = this.r2c_1.e2c(12);
  this.u2c_1 = this.t2c_1.e2c(100);
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 == null)
    new Companion_3();
  return Companion_instance_3;
}
function DateTimeUnit() {
  Companion_getInstance_3();
}
protoOf(DateTimeUnit).g2c = function (value, unit) {
  return value === 1 ? unit : '' + value + '-' + unit;
};
protoOf(DateTimeUnit).f2c = function (value, unit) {
  return value.equals(new Long(1, 0)) ? unit : value.toString() + '-' + unit;
};
function get_isoDayNumber(_this__u8e3s4) {
  return _this__u8e3s4.l2_1 + 1 | 0;
}
function DayOfWeek(isoDayNumber) {
  // Inline function 'kotlin.require' call
  if (!(1 <= isoDayNumber ? isoDayNumber <= 7 : false)) {
    var message = 'Expected ISO day-of-week number in 1..7, got ' + isoDayNumber;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return get_entries().o(isoDayNumber - 1 | 0);
}
function DateTimeFormatException_init_$Init$($this) {
  IllegalArgumentException_init_$Init$($this);
  DateTimeFormatException.call($this);
  return $this;
}
function DateTimeFormatException_init_$Create$() {
  var tmp = DateTimeFormatException_init_$Init$(objectCreate(protoOf(DateTimeFormatException)));
  captureStack(tmp, DateTimeFormatException_init_$Create$);
  return tmp;
}
function DateTimeFormatException_init_$Init$_0(message, $this) {
  IllegalArgumentException_init_$Init$_0(message, $this);
  DateTimeFormatException.call($this);
  return $this;
}
function DateTimeFormatException_init_$Create$_0(message) {
  var tmp = DateTimeFormatException_init_$Init$_0(message, objectCreate(protoOf(DateTimeFormatException)));
  captureStack(tmp, DateTimeFormatException_init_$Create$_0);
  return tmp;
}
function DateTimeFormatException_init_$Init$_1(cause, $this) {
  IllegalArgumentException_init_$Init$_1(cause, $this);
  DateTimeFormatException.call($this);
  return $this;
}
function DateTimeFormatException_init_$Create$_1(cause) {
  var tmp = DateTimeFormatException_init_$Init$_1(cause, objectCreate(protoOf(DateTimeFormatException)));
  captureStack(tmp, DateTimeFormatException_init_$Create$_1);
  return tmp;
}
function DateTimeFormatException_init_$Init$_2(message, cause, $this) {
  IllegalArgumentException_init_$Init$_2(message, cause, $this);
  DateTimeFormatException.call($this);
  return $this;
}
function DateTimeFormatException_init_$Create$_2(message, cause) {
  var tmp = DateTimeFormatException_init_$Init$_2(message, cause, objectCreate(protoOf(DateTimeFormatException)));
  captureStack(tmp, DateTimeFormatException_init_$Create$_2);
  return tmp;
}
function DateTimeFormatException() {
  captureStack(this, DateTimeFormatException);
}
function DateTimeArithmeticException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  DateTimeArithmeticException.call($this);
  return $this;
}
function DateTimeArithmeticException_init_$Create$() {
  var tmp = DateTimeArithmeticException_init_$Init$(objectCreate(protoOf(DateTimeArithmeticException)));
  captureStack(tmp, DateTimeArithmeticException_init_$Create$);
  return tmp;
}
function DateTimeArithmeticException_init_$Init$_0(cause, $this) {
  RuntimeException_init_$Init$_0(cause, $this);
  DateTimeArithmeticException.call($this);
  return $this;
}
function DateTimeArithmeticException_init_$Create$_0(cause) {
  var tmp = DateTimeArithmeticException_init_$Init$_0(cause, objectCreate(protoOf(DateTimeArithmeticException)));
  captureStack(tmp, DateTimeArithmeticException_init_$Create$_0);
  return tmp;
}
function DateTimeArithmeticException_init_$Init$_1(message, cause, $this) {
  RuntimeException_init_$Init$_1(message, cause, $this);
  DateTimeArithmeticException.call($this);
  return $this;
}
function DateTimeArithmeticException_init_$Create$_1(message, cause) {
  var tmp = DateTimeArithmeticException_init_$Init$_1(message, cause, objectCreate(protoOf(DateTimeArithmeticException)));
  captureStack(tmp, DateTimeArithmeticException_init_$Create$_1);
  return tmp;
}
function DateTimeArithmeticException() {
  captureStack(this, DateTimeArithmeticException);
}
function IllegalTimeZoneException_init_$Init$($this) {
  IllegalArgumentException_init_$Init$($this);
  IllegalTimeZoneException.call($this);
  return $this;
}
function IllegalTimeZoneException_init_$Create$() {
  var tmp = IllegalTimeZoneException_init_$Init$(objectCreate(protoOf(IllegalTimeZoneException)));
  captureStack(tmp, IllegalTimeZoneException_init_$Create$);
  return tmp;
}
function IllegalTimeZoneException_init_$Init$_0(cause, $this) {
  IllegalArgumentException_init_$Init$_1(cause, $this);
  IllegalTimeZoneException.call($this);
  return $this;
}
function IllegalTimeZoneException_init_$Create$_0(cause) {
  var tmp = IllegalTimeZoneException_init_$Init$_0(cause, objectCreate(protoOf(IllegalTimeZoneException)));
  captureStack(tmp, IllegalTimeZoneException_init_$Create$_0);
  return tmp;
}
function IllegalTimeZoneException() {
  captureStack(this, IllegalTimeZoneException);
}
function getIsoDateFormat() {
  return Formats_getInstance_0().w2c();
}
function format(_this__u8e3s4, format) {
  return format.x2c(_this__u8e3s4);
}
function getIsoDateTimeFormat() {
  return Formats_getInstance_1().y2c_1;
}
function getIsoTimeFormat() {
  return Formats_instance_2.w2c();
}
function Month(number) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(1 <= number ? number <= 12 : false)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return get_entries_0().o(number - 1 | 0);
}
function getIsoUtcOffsetFormat() {
  return Formats_instance_3.w2c();
}
function asTimeZone(_this__u8e3s4) {
  return FixedOffsetTimeZone_init_$Create$(_this__u8e3s4);
}
var timeZoneField;
function get_emptyDateTimeComponentsContents() {
  _init_properties_DateTimeComponents_kt__9iimb5();
  return emptyDateTimeComponentsContents;
}
var emptyDateTimeComponentsContents;
function DateTimeComponentsContents(date, time, offset, timeZoneId) {
  date = date === VOID ? new IncompleteLocalDate() : date;
  time = time === VOID ? new IncompleteLocalTime() : time;
  offset = offset === VOID ? new IncompleteUtcOffset() : offset;
  timeZoneId = timeZoneId === VOID ? null : timeZoneId;
  this.z2c_1 = date;
  this.a2d_1 = time;
  this.b2d_1 = offset;
  this.c2d_1 = timeZoneId;
}
protoOf(DateTimeComponentsContents).d2d = function (_set____db54di) {
  this.z2c_1.g2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).j2d = function () {
  return this.z2c_1.g2d_1;
};
protoOf(DateTimeComponentsContents).k2d = function (_set____db54di) {
  this.z2c_1.i2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).l2d = function () {
  return this.z2c_1.i2d_1;
};
protoOf(DateTimeComponentsContents).m2d = function (_set____db54di) {
  this.z2c_1.h2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).n2d = function () {
  return this.z2c_1.h2d_1;
};
protoOf(DateTimeComponentsContents).o2d = function (_set____db54di) {
  this.z2c_1.f2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).p2d = function () {
  return this.z2c_1.f2d_1;
};
protoOf(DateTimeComponentsContents).q2d = function (_set____db54di) {
  this.z2c_1.e2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).r2d = function () {
  return this.z2c_1.e2d_1;
};
protoOf(DateTimeComponentsContents).s2d = function (_set____db54di) {
  this.a2d_1.v2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).z2d = function () {
  return this.a2d_1.v2d_1;
};
protoOf(DateTimeComponentsContents).a2e = function (value) {
  this.a2d_1.a2e(value);
};
protoOf(DateTimeComponentsContents).b2e = function () {
  return this.a2d_1.b2e();
};
protoOf(DateTimeComponentsContents).c2e = function (_set____db54di) {
  this.a2d_1.t2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).d2e = function () {
  return this.a2d_1.t2d_1;
};
protoOf(DateTimeComponentsContents).e2e = function (_set____db54di) {
  this.a2d_1.u2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).f2e = function () {
  return this.a2d_1.u2d_1;
};
protoOf(DateTimeComponentsContents).g2e = function (_set____db54di) {
  this.a2d_1.w2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).h2e = function () {
  return this.a2d_1.w2d_1;
};
protoOf(DateTimeComponentsContents).i2e = function (_set____db54di) {
  this.a2d_1.y2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).j2e = function () {
  return this.a2d_1.y2d_1;
};
protoOf(DateTimeComponentsContents).k2e = function (_set____db54di) {
  this.a2d_1.x2d_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).l2e = function () {
  return this.a2d_1.x2d_1;
};
protoOf(DateTimeComponentsContents).m2e = function (_set____db54di) {
  this.b2d_1.n2e_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).r2e = function () {
  return this.b2d_1.n2e_1;
};
protoOf(DateTimeComponentsContents).s2e = function (_set____db54di) {
  this.b2d_1.p2e_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).t2e = function () {
  return this.b2d_1.p2e_1;
};
protoOf(DateTimeComponentsContents).u2e = function (_set____db54di) {
  this.b2d_1.q2e_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).v2e = function () {
  return this.b2d_1.q2e_1;
};
protoOf(DateTimeComponentsContents).w2e = function (_set____db54di) {
  this.b2d_1.o2e_1 = _set____db54di;
};
protoOf(DateTimeComponentsContents).x2e = function () {
  return this.b2d_1.o2e_1;
};
protoOf(DateTimeComponentsContents).y2e = function () {
  return new DateTimeComponentsContents(this.z2c_1.y2e(), this.a2d_1.y2e(), this.b2d_1.y2e(), this.c2d_1);
};
protoOf(DateTimeComponentsContents).equals = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  if (other instanceof DateTimeComponentsContents) {
    tmp_2 = other.z2c_1.equals(this.z2c_1);
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = other.a2d_1.equals(this.a2d_1);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = other.b2d_1.equals(this.b2d_1);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = other.c2d_1 == this.c2d_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(DateTimeComponentsContents).hashCode = function () {
  var tmp = this.z2c_1.hashCode() ^ this.a2d_1.hashCode() ^ this.b2d_1.hashCode();
  var tmp0_safe_receiver = this.c2d_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
  return tmp ^ (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
};
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda($this$Format) {
  $this$Format.z2e(get_ISO_DATE());
  var tmp = [DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda];
  alternativeParsing($this$Format, tmp, DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_0);
  $this$Format.a2f();
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.b2f();
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.c2f();
  optional($this$Format, VOID, DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_1);
  var tmp_0 = [DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_2];
  alternativeParsing($this$Format, tmp_0, DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_3);
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda($this$alternativeParsing) {
  char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_0($this$alternativeParsing) {
  char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_1($this$optional) {
  char($this$optional, _Char___init__impl__6a9atx(46));
  $this$optional.d2f(1, 9);
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_2($this$alternativeParsing) {
  $this$alternativeParsing.e2f();
  return Unit_instance;
}
function DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda$lambda_3($this$alternativeParsing) {
  $this$alternativeParsing.f2f(Formats_instance_3.w2c());
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda($this$Format) {
  var tmp = [DateTimeComponents$Formats$RFC_1123$lambda$lambda];
  alternativeParsing($this$Format, tmp, DateTimeComponents$Formats$RFC_1123$lambda$lambda_0);
  $this$Format.g2f(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.j2f(Companion_getInstance_5().i2f_1);
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.k2f();
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.a2f();
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.b2f();
  optional($this$Format, VOID, DateTimeComponents$Formats$RFC_1123$lambda$lambda_1);
  $this$Format.l2f(' ');
  var tmp_0 = DateTimeComponents$Formats$RFC_1123$lambda$lambda_2;
  var tmp_1 = [tmp_0, DateTimeComponents$Formats$RFC_1123$lambda$lambda_3];
  alternativeParsing($this$Format, tmp_1, DateTimeComponents$Formats$RFC_1123$lambda$lambda_4);
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda($this$alternativeParsing) {
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_0($this$alternativeParsing) {
  $this$alternativeParsing.o2f(Companion_getInstance_6().n2f_1);
  $this$alternativeParsing.l2f(', ');
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_1($this$optional) {
  char($this$optional, _Char___init__impl__6a9atx(58));
  $this$optional.c2f();
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_2($this$alternativeParsing) {
  $this$alternativeParsing.l2f('UT');
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_3($this$alternativeParsing) {
  $this$alternativeParsing.l2f('Z');
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda_4($this$alternativeParsing) {
  optional($this$alternativeParsing, 'GMT', DateTimeComponents$Formats$RFC_1123$lambda$lambda$lambda);
  return Unit_instance;
}
function DateTimeComponents$Formats$RFC_1123$lambda$lambda$lambda($this$optional) {
  $this$optional.f2f(Formats_instance_3.p2f());
  return Unit_instance;
}
function Companion_4() {
}
protoOf(Companion_4).q2f = function (block) {
  var builder = new Builder(new AppendableFormatStructure());
  block(builder);
  return new DateTimeComponentsFormat(builder.r2f());
};
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function Formats() {
  Formats_instance = this;
  var tmp = this;
  var tmp_0 = Companion_instance_4;
  tmp.s2f_1 = tmp_0.q2f(DateTimeComponents$Formats$ISO_DATE_TIME_OFFSET$lambda);
  var tmp_1 = this;
  var tmp_2 = Companion_instance_4;
  tmp_1.t2f_1 = tmp_2.q2f(DateTimeComponents$Formats$RFC_1123$lambda);
}
var Formats_instance;
function Formats_getInstance() {
  if (Formats_instance == null)
    new Formats();
  return Formats_instance;
}
function DateTimeComponents(contents) {
  contents = contents === VOID ? new DateTimeComponentsContents() : contents;
  this.u2f_1 = contents;
  this.v2f_1 = year$factory(this.u2f_1.z2c_1);
  this.w2f_1 = new TwoDigitNumber(monthNumber$factory(this.u2f_1.z2c_1));
  this.x2f_1 = new TwoDigitNumber(dayOfMonth$factory(this.u2f_1.z2c_1));
  this.y2f_1 = new ThreeDigitNumber(dayOfYear$factory(this.u2f_1.z2c_1));
  this.z2f_1 = new TwoDigitNumber(hour$factory(this.u2f_1.a2d_1));
  this.a2g_1 = new TwoDigitNumber(hourOfAmPm$factory(this.u2f_1.a2d_1));
  this.b2g_1 = amPm$factory(this.u2f_1.a2d_1);
  this.c2g_1 = new TwoDigitNumber(minute$factory(this.u2f_1.a2d_1));
  this.d2g_1 = new TwoDigitNumber(second$factory(this.u2f_1.a2d_1));
  this.e2g_1 = isNegative$factory(this.u2f_1.b2d_1);
  this.f2g_1 = new TwoDigitNumber(totalHoursAbs$factory(this.u2f_1.b2d_1));
  this.g2g_1 = new TwoDigitNumber(minutesOfHour$factory(this.u2f_1.b2d_1));
  this.h2g_1 = new TwoDigitNumber(secondsOfMinute$factory(this.u2f_1.b2d_1));
  this.i2g_1 = timeZoneId$factory_0(this.u2f_1);
}
protoOf(DateTimeComponents).q2d = function (_set____db54di) {
  var tmp0 = this.v2f_1;
  // Inline function 'kotlin.setValue' call
  year$factory_0();
  tmp0.set(_set____db54di);
  return Unit_instance;
};
protoOf(DateTimeComponents).r2d = function () {
  var tmp0 = this.v2f_1;
  // Inline function 'kotlin.getValue' call
  year$factory_1();
  return tmp0.get();
};
protoOf(DateTimeComponents).j2e = function () {
  return this.u2f_1.a2d_1.y2d_1;
};
protoOf(DateTimeComponents).j2g = function () {
  return this.u2f_1.b2d_1.j2g();
};
protoOf(DateTimeComponents).k2g = function () {
  return this.u2f_1.a2d_1.k2g();
};
protoOf(DateTimeComponents).l2g = function () {
  var offset = this.j2g();
  var time = this.k2g();
  var truncatedDate = this.u2f_1.z2c_1.y2e();
  truncatedDate.e2d_1 = requireParsedField(truncatedDate.e2d_1, 'year') % 10000 | 0;
  var tmp;
  try {
    var secDelta = safeMultiply(toLong(ensureNotNull(this.r2d()) / 10000 | 0), new Long(2036907392, 73));
    var epochDays = toLong(truncatedDate.m2g().o2g());
    // Inline function 'kotlin.Long.times' call
    var tmp2 = epochDays.t2(toLong(86400));
    // Inline function 'kotlin.Long.plus' call
    var other = time.q2g();
    var tmp4 = tmp2.r2(toLong(other));
    // Inline function 'kotlin.Long.minus' call
    var other_0 = offset.s2g();
    var tmp$ret$2 = tmp4.s2(toLong(other_0));
    tmp = safeAdd(secDelta, tmp$ret$2);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof ArithmeticException) {
      var e = $p;
      throw DateTimeFormatException_init_$Create$_2('The parsed date is outside the range representable by Instant', e);
    } else {
      throw $p;
    }
  }
  var totalSeconds = tmp;
  if (totalSeconds.b1(Companion_getInstance_14().z2b_1.u2g()) < 0 || totalSeconds.b1(Companion_getInstance_14().a2c_1.u2g()) > 0)
    throw DateTimeFormatException_init_$Create$_0('The parsed date is outside the range representable by Instant');
  var tmp_1 = Companion_getInstance_14();
  var tmp0_elvis_lhs = this.j2e();
  return tmp_1.v2g(totalSeconds, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs);
};
function Builder(actualBuilder) {
  this.w2g_1 = actualBuilder;
}
protoOf(Builder).x2g = function () {
  return this.w2g_1;
};
protoOf(Builder).y2g = function (structure) {
  this.w2g_1.a2h(structure);
};
protoOf(Builder).b2h = function (structure) {
  this.w2g_1.a2h(structure);
};
protoOf(Builder).c2h = function () {
  return new Builder(new AppendableFormatStructure());
};
function DateTimeComponentsFormat(actualFormat) {
  AbstractDateTimeFormat.call(this);
  this.u2h_1 = actualFormat;
}
protoOf(DateTimeComponentsFormat).v2h = function () {
  return this.u2h_1;
};
protoOf(DateTimeComponentsFormat).w2h = function (value) {
  return value.u2f_1;
};
protoOf(DateTimeComponentsFormat).x2h = function (value) {
  return this.w2h(value instanceof DateTimeComponents ? value : THROW_CCE());
};
protoOf(DateTimeComponentsFormat).y2h = function (intermediate) {
  return new DateTimeComponents(intermediate);
};
protoOf(DateTimeComponentsFormat).z2h = function (intermediate) {
  return this.y2h(intermediate instanceof DateTimeComponentsContents ? intermediate : THROW_CCE());
};
protoOf(DateTimeComponentsFormat).a2i = function () {
  return get_emptyDateTimeComponentsContents();
};
function TwoDigitNumber(reference) {
  this.c2i_1 = reference;
}
function ThreeDigitNumber(reference) {
  this.d2i_1 = reference;
}
function timeZoneId$factory() {
  return getPropertyCallableRef('timeZoneId', 1, KMutableProperty1, function (receiver) {
    return receiver.c2d_1;
  }, function (receiver, value) {
    receiver.c2d_1 = value;
    return Unit_instance;
  });
}
function year$factory($b0) {
  return getPropertyCallableRef('year', 0, KMutableProperty0, function () {
    return $b0.e2d_1;
  }, function (value) {
    $b0.e2d_1 = value;
    return Unit_instance;
  });
}
function monthNumber$factory($b0) {
  return getPropertyCallableRef('monthNumber', 0, KMutableProperty0, function () {
    return $b0.f2d_1;
  }, function (value) {
    $b0.f2d_1 = value;
    return Unit_instance;
  });
}
function dayOfMonth$factory($b0) {
  return getPropertyCallableRef('dayOfMonth', 0, KMutableProperty0, function () {
    return $b0.g2d_1;
  }, function (value) {
    $b0.g2d_1 = value;
    return Unit_instance;
  });
}
function dayOfYear$factory($b0) {
  return getPropertyCallableRef('dayOfYear', 0, KMutableProperty0, function () {
    return $b0.i2d_1;
  }, function (value) {
    $b0.i2d_1 = value;
    return Unit_instance;
  });
}
function hour$factory($b0) {
  return getPropertyCallableRef('hour', 0, KMutableProperty0, function () {
    return $b0.t2d_1;
  }, function (value) {
    $b0.t2d_1 = value;
    return Unit_instance;
  });
}
function hourOfAmPm$factory($b0) {
  return getPropertyCallableRef('hourOfAmPm', 0, KMutableProperty0, function () {
    return $b0.u2d_1;
  }, function (value) {
    $b0.u2d_1 = value;
    return Unit_instance;
  });
}
function amPm$factory($b0) {
  return getPropertyCallableRef('amPm', 0, KMutableProperty0, function () {
    return $b0.v2d_1;
  }, function (value) {
    $b0.v2d_1 = value;
    return Unit_instance;
  });
}
function minute$factory($b0) {
  return getPropertyCallableRef('minute', 0, KMutableProperty0, function () {
    return $b0.w2d_1;
  }, function (value) {
    $b0.w2d_1 = value;
    return Unit_instance;
  });
}
function second$factory($b0) {
  return getPropertyCallableRef('second', 0, KMutableProperty0, function () {
    return $b0.x2d_1;
  }, function (value) {
    $b0.x2d_1 = value;
    return Unit_instance;
  });
}
function isNegative$factory($b0) {
  return getPropertyCallableRef('isNegative', 0, KMutableProperty0, function () {
    return $b0.n2e_1;
  }, function (value) {
    $b0.n2e_1 = value;
    return Unit_instance;
  });
}
function totalHoursAbs$factory($b0) {
  return getPropertyCallableRef('totalHoursAbs', 0, KMutableProperty0, function () {
    return $b0.o2e_1;
  }, function (value) {
    $b0.o2e_1 = value;
    return Unit_instance;
  });
}
function minutesOfHour$factory($b0) {
  return getPropertyCallableRef('minutesOfHour', 0, KMutableProperty0, function () {
    return $b0.p2e_1;
  }, function (value) {
    $b0.p2e_1 = value;
    return Unit_instance;
  });
}
function secondsOfMinute$factory($b0) {
  return getPropertyCallableRef('secondsOfMinute', 0, KMutableProperty0, function () {
    return $b0.q2e_1;
  }, function (value) {
    $b0.q2e_1 = value;
    return Unit_instance;
  });
}
function timeZoneId$factory_0($b0) {
  return getPropertyCallableRef('timeZoneId', 0, KMutableProperty0, function () {
    return $b0.c2d_1;
  }, function (value) {
    $b0.c2d_1 = value;
    return Unit_instance;
  });
}
function year$factory_0() {
  return getPropertyCallableRef('year', 1, KMutableProperty1, function (receiver) {
    return receiver.r2d();
  }, function (receiver, value) {
    return receiver.q2d(value);
  });
}
function year$factory_1() {
  return getPropertyCallableRef('year', 1, KMutableProperty1, function (receiver) {
    return receiver.r2d();
  }, function (receiver, value) {
    return receiver.q2d(value);
  });
}
var properties_initialized_DateTimeComponents_kt_io5e5;
function _init_properties_DateTimeComponents_kt__9iimb5() {
  if (!properties_initialized_DateTimeComponents_kt_io5e5) {
    properties_initialized_DateTimeComponents_kt_io5e5 = true;
    timeZoneField = new GenericFieldSpec(new PropertyAccessor(timeZoneId$factory()));
    emptyDateTimeComponentsContents = new DateTimeComponentsContents();
  }
}
function AbstractDateTimeFormat() {
}
protoOf(AbstractDateTimeFormat).x2c = function (value) {
  // Inline function 'kotlin.also' call
  var this_0 = StringBuilder_init_$Create$();
  this.v2h().h2i().i2i(this.x2h(value), this_0);
  return this_0.toString();
};
protoOf(AbstractDateTimeFormat).b2i = function (input) {
  var tmp;
  try {
    tmp = Parser__match$default_impl_x2xlti(_Parser___init__impl__gdyfby(this.v2h().j2i()), input, this.a2i());
  } catch ($p) {
    var tmp_0;
    if ($p instanceof ParseException) {
      var e = $p;
      throw DateTimeFormatException_init_$Create$_2("Failed to parse value from '" + toString(input) + "'", e);
    } else {
      throw $p;
    }
  }
  var matched = tmp;
  try {
    return this.z2h(matched);
  } catch ($p) {
    if ($p instanceof IllegalArgumentException) {
      var e_0 = $p;
      var message = e_0.message;
      throw DateTimeFormatException_init_$Create$_2(message == null ? "The value parsed from '" + toString(input) + "' is invalid" : '' + message + " (when parsing '" + toString(input) + "')", e_0);
    } else {
      throw $p;
    }
  }
};
var Padding_NONE_instance;
var Padding_ZERO_instance;
var Padding_SPACE_instance;
var Padding_entriesInitialized;
function Padding_initEntries() {
  if (Padding_entriesInitialized)
    return Unit_instance;
  Padding_entriesInitialized = true;
  Padding_NONE_instance = new Padding('NONE', 0);
  Padding_ZERO_instance = new Padding('ZERO', 1);
  Padding_SPACE_instance = new Padding('SPACE', 2);
}
function Padding(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Padding_NONE_getInstance() {
  Padding_initEntries();
  return Padding_NONE_instance;
}
function Padding_ZERO_getInstance() {
  Padding_initEntries();
  return Padding_ZERO_instance;
}
function Padding_SPACE_getInstance() {
  Padding_initEntries();
  return Padding_SPACE_instance;
}
function WithDate() {
}
function WithTime() {
}
function WithUtcOffset() {
}
function char(_this__u8e3s4, value) {
  return _this__u8e3s4.l2f(toString_0(value));
}
function optional(_this__u8e3s4, ifZero, format) {
  ifZero = ifZero === VOID ? '' : ifZero;
  var tmp;
  if (isInterface(_this__u8e3s4, AbstractDateTimeFormatBuilder)) {
    _this__u8e3s4.e2h(ifZero, typeof format === 'function' ? format : THROW_CCE());
    tmp = Unit_instance;
  } else {
    throw IllegalStateException_init_$Create$('impossible');
  }
  return tmp;
}
function alternativeParsing(_this__u8e3s4, alternativeFormats, primaryFormat) {
  var tmp;
  if (isInterface(_this__u8e3s4, AbstractDateTimeFormatBuilder)) {
    var tmp_0 = (isArray(alternativeFormats) ? alternativeFormats : THROW_CCE()).slice();
    _this__u8e3s4.d2h(tmp_0, typeof primaryFormat === 'function' ? primaryFormat : THROW_CCE());
    tmp = Unit_instance;
  } else {
    throw IllegalStateException_init_$Create$('impossible');
  }
  return tmp;
}
function AbstractDateTimeFormatBuilder() {
}
function get_ISO_DATE() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp0 = ISO_DATE$delegate;
  // Inline function 'kotlin.getValue' call
  ISO_DATE$factory();
  return tmp0.t();
}
var ISO_DATE$delegate;
function get_ISO_DATE_BASIC() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp0 = ISO_DATE_BASIC$delegate;
  // Inline function 'kotlin.getValue' call
  ISO_DATE_BASIC$factory();
  return tmp0.t();
}
var ISO_DATE_BASIC$delegate;
function get_emptyIncompleteLocalDate() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  return emptyIncompleteLocalDate;
}
var emptyIncompleteLocalDate;
function IncompleteLocalDate(year, monthNumber, dayOfMonth, isoDayOfWeek, dayOfYear) {
  year = year === VOID ? null : year;
  monthNumber = monthNumber === VOID ? null : monthNumber;
  dayOfMonth = dayOfMonth === VOID ? null : dayOfMonth;
  isoDayOfWeek = isoDayOfWeek === VOID ? null : isoDayOfWeek;
  dayOfYear = dayOfYear === VOID ? null : dayOfYear;
  this.e2d_1 = year;
  this.f2d_1 = monthNumber;
  this.g2d_1 = dayOfMonth;
  this.h2d_1 = isoDayOfWeek;
  this.i2d_1 = dayOfYear;
}
protoOf(IncompleteLocalDate).q2d = function (_set____db54di) {
  this.e2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).r2d = function () {
  return this.e2d_1;
};
protoOf(IncompleteLocalDate).o2d = function (_set____db54di) {
  this.f2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).p2d = function () {
  return this.f2d_1;
};
protoOf(IncompleteLocalDate).d2d = function (_set____db54di) {
  this.g2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).j2d = function () {
  return this.g2d_1;
};
protoOf(IncompleteLocalDate).m2d = function (_set____db54di) {
  this.h2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).n2d = function () {
  return this.h2d_1;
};
protoOf(IncompleteLocalDate).k2d = function (_set____db54di) {
  this.i2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).l2d = function () {
  return this.i2d_1;
};
protoOf(IncompleteLocalDate).m2g = function () {
  var year = requireParsedField(this.e2d_1, 'year');
  var dayOfYear = this.i2d_1;
  var tmp;
  if (dayOfYear == null) {
    tmp = LocalDate_init_$Create$(year, requireParsedField(this.f2d_1, 'monthNumber'), requireParsedField(this.g2d_1, 'dayOfMonth'));
  } else {
    // Inline function 'kotlin.also' call
    var this_0 = plus_0(LocalDate_init_$Create$(year, 1, 1), dayOfYear - 1 | 0, Companion_getInstance_3().p2c_1);
    if (!(this_0.r2d() === year)) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is not a valid day of year for the year ' + year));
    }
    if (!(this.f2d_1 == null) && !(this_0.p2d() === this.f2d_1)) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is ' + this_0.l2i().toString() + ', ') + ('but ' + this.f2d_1 + ' was specified as the month number'));
    }
    if (!(this.g2d_1 == null) && !(this_0.j2d() === this.g2d_1)) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is the day ' + this_0.j2d() + ' of ' + this_0.l2i().toString() + ', ') + ('but ' + this.g2d_1 + ' was specified as the day of month'));
    }
    tmp = this_0;
  }
  var date = tmp;
  var tmp0_safe_receiver = this.h2d_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    if (!(tmp0_safe_receiver === get_isoDayNumber(date.m2i()))) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of week is ' + DayOfWeek(tmp0_safe_receiver).toString() + ' but the date is ' + date.toString() + ', which is a ' + date.m2i().toString()));
    }
  }
  return date;
};
protoOf(IncompleteLocalDate).n2i = function (date) {
  this.e2d_1 = date.r2d();
  this.f2d_1 = date.p2d();
  this.g2d_1 = date.j2d();
  this.h2d_1 = get_isoDayNumber(date.m2i());
  this.i2d_1 = date.l2d();
};
protoOf(IncompleteLocalDate).y2e = function () {
  return new IncompleteLocalDate(this.e2d_1, this.f2d_1, this.g2d_1, this.h2d_1, this.i2d_1);
};
protoOf(IncompleteLocalDate).equals = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  if (other instanceof IncompleteLocalDate) {
    tmp_3 = this.e2d_1 == other.e2d_1;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = this.f2d_1 == other.f2d_1;
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = this.g2d_1 == other.g2d_1;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = this.h2d_1 == other.h2d_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.i2d_1 == other.i2d_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(IncompleteLocalDate).hashCode = function () {
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver = this.e2d_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  var tmp = imul(tmp$ret$0, 923521);
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_0 = this.f2d_1;
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
  var tmp$ret$1 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
  var tmp_0 = tmp + imul(tmp$ret$1, 29791) | 0;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_1 = this.g2d_1;
  var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
  var tmp$ret$2 = tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
  var tmp_1 = tmp_0 + imul(tmp$ret$2, 961) | 0;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_2 = this.h2d_1;
  var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
  var tmp$ret$3 = tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2;
  var tmp_2 = tmp_1 + imul(tmp$ret$3, 31) | 0;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_3 = this.i2d_1;
  var tmp1_elvis_lhs_3 = tmp0_safe_receiver_3 == null ? null : hashCode(tmp0_safe_receiver_3);
  return tmp_2 + (tmp1_elvis_lhs_3 == null ? 0 : tmp1_elvis_lhs_3) | 0;
};
protoOf(IncompleteLocalDate).toString = function () {
  var tmp0_elvis_lhs = this.e2d_1;
  var tmp = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
  var tmp1_elvis_lhs = this.f2d_1;
  var tmp_0 = toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
  var tmp2_elvis_lhs = this.g2d_1;
  var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
  var tmp3_elvis_lhs = this.h2d_1;
  return tmp + '-' + tmp_0 + '-' + tmp_1 + ' (day of week is ' + toString(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs) + ')';
};
function Companion_5() {
  Companion_instance_5 = this;
  this.h2f_1 = new MonthNames(listOf(['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']));
  this.i2f_1 = new MonthNames(listOf(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']));
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 == null)
    new Companion_5();
  return Companion_instance_5;
}
function String$toString$ref() {
  var l = function (p0) {
    return toString(p0);
  };
  l.callableName = 'toString';
  return l;
}
function MonthNames(names) {
  Companion_getInstance_5();
  this.o2i_1 = names;
  // Inline function 'kotlin.require' call
  if (!(this.o2i_1.m() === 12)) {
    var message = 'Month names must contain exactly 12 elements';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.forEach' call
  var progression = get_indices(this.o2i_1);
  var inductionVariable = progression.v_1;
  var last = progression.w_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ix = element;
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = this.o2i_1.o(ix);
      // Inline function 'kotlin.require' call
      if (!(charSequenceLength(this_0) > 0)) {
        var message_0 = 'A month name can not be empty';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < ix)
        do {
          var ix2 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'kotlin.require' call
          if (!!(this.o2i_1.o(ix) === this.o2i_1.o(ix2))) {
            var message_1 = "Month names must be unique, but '" + this.o2i_1.o(ix) + "' was repeated";
            throw IllegalArgumentException_init_$Create$(toString(message_1));
          }
        }
         while (inductionVariable_0 < ix);
    }
     while (!(element === last));
}
protoOf(MonthNames).toString = function () {
  return joinToString(this.o2i_1, ', ', 'MonthNames(', ')', VOID, VOID, String$toString$ref());
};
protoOf(MonthNames).equals = function (other) {
  var tmp;
  if (other instanceof MonthNames) {
    tmp = equals(this.o2i_1, other.o2i_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(MonthNames).hashCode = function () {
  return hashCode(this.o2i_1);
};
function Companion_6() {
  Companion_instance_6 = this;
  this.m2f_1 = new DayOfWeekNames(listOf(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']));
  this.n2f_1 = new DayOfWeekNames(listOf(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']));
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 == null)
    new Companion_6();
  return Companion_instance_6;
}
function String$toString$ref_0() {
  var l = function (p0) {
    return toString(p0);
  };
  l.callableName = 'toString';
  return l;
}
function DayOfWeekNames(names) {
  Companion_getInstance_6();
  this.p2i_1 = names;
  // Inline function 'kotlin.require' call
  if (!(this.p2i_1.m() === 7)) {
    var message = 'Day of week names must contain exactly 7 elements';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.forEach' call
  var progression = get_indices(this.p2i_1);
  var inductionVariable = progression.v_1;
  var last = progression.w_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ix = element;
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = this.p2i_1.o(ix);
      // Inline function 'kotlin.require' call
      if (!(charSequenceLength(this_0) > 0)) {
        var message_0 = 'A day-of-week name can not be empty';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < ix)
        do {
          var ix2 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'kotlin.require' call
          if (!!(this.p2i_1.o(ix) === this.p2i_1.o(ix2))) {
            var message_1 = "Day-of-week names must be unique, but '" + this.p2i_1.o(ix) + "' was repeated";
            throw IllegalArgumentException_init_$Create$(toString(message_1));
          }
        }
         while (inductionVariable_0 < ix);
    }
     while (!(element === last));
}
protoOf(DayOfWeekNames).toString = function () {
  return joinToString(this.p2i_1, ', ', 'DayOfWeekNames(', ')', VOID, VOID, String$toString$ref_0());
};
protoOf(DayOfWeekNames).equals = function (other) {
  var tmp;
  if (other instanceof DayOfWeekNames) {
    tmp = equals(this.p2i_1, other.p2i_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(DayOfWeekNames).hashCode = function () {
  return hashCode(this.p2i_1);
};
function Companion_7() {
}
protoOf(Companion_7).q2i = function (block) {
  var builder = new Builder_0(new AppendableFormatStructure());
  block(builder);
  return new LocalDateFormat(builder.r2f());
};
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function Builder_0(actualBuilder) {
  this.r2i_1 = actualBuilder;
}
protoOf(Builder_0).x2g = function () {
  return this.r2i_1;
};
protoOf(Builder_0).f2h = function (structure) {
  return this.r2i_1.a2h(structure);
};
protoOf(Builder_0).c2h = function () {
  return new Builder_0(new AppendableFormatStructure());
};
function LocalDateFormat(actualFormat) {
  AbstractDateTimeFormat.call(this);
  this.s2i_1 = actualFormat;
}
protoOf(LocalDateFormat).v2h = function () {
  return this.s2i_1;
};
protoOf(LocalDateFormat).t2i = function (value) {
  // Inline function 'kotlin.apply' call
  var this_0 = new IncompleteLocalDate();
  this_0.n2i(value);
  return this_0;
};
protoOf(LocalDateFormat).x2h = function (value) {
  return this.t2i(value instanceof LocalDate_0 ? value : THROW_CCE());
};
protoOf(LocalDateFormat).u2i = function (intermediate) {
  return intermediate.m2g();
};
protoOf(LocalDateFormat).z2h = function (intermediate) {
  return this.u2i(intermediate instanceof IncompleteLocalDate ? intermediate : THROW_CCE());
};
protoOf(LocalDateFormat).a2i = function () {
  return get_emptyIncompleteLocalDate();
};
function requireParsedField(field, name) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  if (field == null) {
    throw DateTimeFormatException_init_$Create$_0('Can not create a ' + name + ' from the given input: the field ' + name + ' is missing');
  }
  return field;
}
function AbstractWithDateBuilder() {
}
function YearDirective(padding, isYearOfEra) {
  isYearOfEra = isYearOfEra === VOID ? false : isYearOfEra;
  var tmp = DateFields_getInstance().v2i_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 4 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 4 : null;
  SignedIntFieldFormatDirective.call(this, tmp, tmp_0, null, tmp$ret$1, 4);
  this.f2j_1 = padding;
  this.g2j_1 = isYearOfEra;
}
protoOf(YearDirective).equals = function (other) {
  var tmp;
  var tmp_0;
  if (other instanceof YearDirective) {
    tmp_0 = this.f2j_1.equals(other.f2j_1);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.g2j_1 === other.g2j_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(YearDirective).hashCode = function () {
  return imul(this.f2j_1.hashCode(), 31) + getBooleanHashCode(this.g2j_1) | 0;
};
function MonthDirective(padding) {
  var tmp = DateFields_getInstance().w2i_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.r2j_1 = padding;
}
protoOf(MonthDirective).equals = function (other) {
  var tmp;
  if (other instanceof MonthDirective) {
    tmp = this.r2j_1.equals(other.r2j_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(MonthDirective).hashCode = function () {
  return this.r2j_1.hashCode();
};
function MonthNameDirective(names) {
  NamedUnsignedIntFieldFormatDirective.call(this, DateFields_getInstance().w2i_1, names.o2i_1, 'monthName');
  this.z2j_1 = names;
}
protoOf(MonthNameDirective).equals = function (other) {
  var tmp;
  if (other instanceof MonthNameDirective) {
    tmp = equals(this.z2j_1.o2i_1, other.z2j_1.o2i_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(MonthNameDirective).hashCode = function () {
  return hashCode(this.z2j_1.o2i_1);
};
function DayDirective(padding) {
  var tmp = DateFields_getInstance().x2i_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.h2k_1 = padding;
}
protoOf(DayDirective).equals = function (other) {
  var tmp;
  if (other instanceof DayDirective) {
    tmp = this.h2k_1.equals(other.h2k_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(DayDirective).hashCode = function () {
  return this.h2k_1.hashCode();
};
function DayOfWeekDirective(names) {
  NamedUnsignedIntFieldFormatDirective.call(this, DateFields_getInstance().y2i_1, names.p2i_1, 'dayOfWeekName');
  this.l2k_1 = names;
}
protoOf(DayOfWeekDirective).equals = function (other) {
  var tmp;
  if (other instanceof DayOfWeekDirective) {
    tmp = equals(this.l2k_1.p2i_1, other.l2k_1.p2i_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(DayOfWeekDirective).hashCode = function () {
  return hashCode(this.l2k_1.p2i_1);
};
function DateFields() {
  DateFields_instance = this;
  this.v2i_1 = new GenericFieldSpec(new PropertyAccessor(year$factory_2()));
  this.w2i_1 = new UnsignedFieldSpec(new PropertyAccessor(monthNumber$factory_0()), 1, 12);
  this.x2i_1 = new UnsignedFieldSpec(new PropertyAccessor(dayOfMonth$factory_0()), 1, 31);
  this.y2i_1 = new UnsignedFieldSpec(new PropertyAccessor(isoDayOfWeek$factory()), 1, 7);
  this.z2i_1 = new UnsignedFieldSpec(new PropertyAccessor(dayOfYear$factory_0()), 1, 366);
}
var DateFields_instance;
function DateFields_getInstance() {
  if (DateFields_instance == null)
    new DateFields();
  return DateFields_instance;
}
function ISO_DATE$delegate$lambda() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp = Companion_instance_7;
  return tmp.q2i(ISO_DATE$delegate$lambda$lambda);
}
function ISO_DATE$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  $this$build.k2f();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.j2h();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.k2h();
  return Unit_instance;
}
function ISO_DATE_BASIC$delegate$lambda() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp = Companion_instance_7;
  return tmp.q2i(ISO_DATE_BASIC$delegate$lambda$lambda);
}
function ISO_DATE_BASIC$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  $this$build.k2f();
  $this$build.j2h();
  $this$build.k2h();
  return Unit_instance;
}
function ISO_DATE$factory() {
  return getPropertyCallableRef('ISO_DATE', 0, KProperty0, function () {
    return get_ISO_DATE();
  }, null);
}
function ISO_DATE_BASIC$factory() {
  return getPropertyCallableRef('ISO_DATE_BASIC', 0, KProperty0, function () {
    return get_ISO_DATE_BASIC();
  }, null);
}
function year$factory_2() {
  return getPropertyCallableRef('year', 1, KMutableProperty1, function (receiver) {
    return receiver.r2d();
  }, function (receiver, value) {
    return receiver.q2d(value);
  });
}
function monthNumber$factory_0() {
  return getPropertyCallableRef('monthNumber', 1, KMutableProperty1, function (receiver) {
    return receiver.p2d();
  }, function (receiver, value) {
    return receiver.o2d(value);
  });
}
function dayOfMonth$factory_0() {
  return getPropertyCallableRef('dayOfMonth', 1, KMutableProperty1, function (receiver) {
    return receiver.j2d();
  }, function (receiver, value) {
    return receiver.d2d(value);
  });
}
function isoDayOfWeek$factory() {
  return getPropertyCallableRef('isoDayOfWeek', 1, KMutableProperty1, function (receiver) {
    return receiver.n2d();
  }, function (receiver, value) {
    return receiver.m2d(value);
  });
}
function dayOfYear$factory_0() {
  return getPropertyCallableRef('dayOfYear', 1, KMutableProperty1, function (receiver) {
    return receiver.l2d();
  }, function (receiver, value) {
    return receiver.k2d(value);
  });
}
var properties_initialized_LocalDateFormat_kt_fmnlhc;
function _init_properties_LocalDateFormat_kt__k1uk9u() {
  if (!properties_initialized_LocalDateFormat_kt_fmnlhc) {
    properties_initialized_LocalDateFormat_kt_fmnlhc = true;
    ISO_DATE$delegate = lazy(ISO_DATE$delegate$lambda);
    ISO_DATE_BASIC$delegate = lazy(ISO_DATE_BASIC$delegate$lambda);
    emptyIncompleteLocalDate = new IncompleteLocalDate();
  }
}
function get_ISO_DATETIME() {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  var tmp0 = ISO_DATETIME$delegate;
  // Inline function 'kotlin.getValue' call
  ISO_DATETIME$factory();
  return tmp0.t();
}
var ISO_DATETIME$delegate;
function get_emptyIncompleteLocalDateTime() {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  return emptyIncompleteLocalDateTime;
}
var emptyIncompleteLocalDateTime;
function Companion_8() {
}
protoOf(Companion_8).m2k = function (block) {
  var builder = new Builder_1(new AppendableFormatStructure());
  block(builder);
  return new LocalDateTimeFormat(builder.r2f());
};
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function Builder_1(actualBuilder) {
  this.n2k_1 = actualBuilder;
}
protoOf(Builder_1).x2g = function () {
  return this.n2k_1;
};
protoOf(Builder_1).y2g = function (structure) {
  this.n2k_1.a2h(structure);
};
protoOf(Builder_1).c2h = function () {
  return new Builder_1(new AppendableFormatStructure());
};
function LocalDateTimeFormat(actualFormat) {
  AbstractDateTimeFormat.call(this);
  this.o2k_1 = actualFormat;
}
protoOf(LocalDateTimeFormat).v2h = function () {
  return this.o2k_1;
};
protoOf(LocalDateTimeFormat).p2k = function (value) {
  // Inline function 'kotlin.apply' call
  var this_0 = new IncompleteLocalDateTime();
  this_0.s2k(value);
  return this_0;
};
protoOf(LocalDateTimeFormat).x2h = function (value) {
  return this.p2k(value instanceof LocalDateTime_0 ? value : THROW_CCE());
};
protoOf(LocalDateTimeFormat).t2k = function (intermediate) {
  return intermediate.u2k();
};
protoOf(LocalDateTimeFormat).z2h = function (intermediate) {
  return this.t2k(intermediate instanceof IncompleteLocalDateTime ? intermediate : THROW_CCE());
};
protoOf(LocalDateTimeFormat).a2i = function () {
  return get_emptyIncompleteLocalDateTime();
};
function IncompleteLocalDateTime(date, time) {
  date = date === VOID ? new IncompleteLocalDate() : date;
  time = time === VOID ? new IncompleteLocalTime() : time;
  this.q2k_1 = date;
  this.r2k_1 = time;
}
protoOf(IncompleteLocalDateTime).d2d = function (_set____db54di) {
  this.q2k_1.g2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).j2d = function () {
  return this.q2k_1.g2d_1;
};
protoOf(IncompleteLocalDateTime).k2d = function (_set____db54di) {
  this.q2k_1.i2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).l2d = function () {
  return this.q2k_1.i2d_1;
};
protoOf(IncompleteLocalDateTime).m2d = function (_set____db54di) {
  this.q2k_1.h2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).n2d = function () {
  return this.q2k_1.h2d_1;
};
protoOf(IncompleteLocalDateTime).o2d = function (_set____db54di) {
  this.q2k_1.f2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).p2d = function () {
  return this.q2k_1.f2d_1;
};
protoOf(IncompleteLocalDateTime).q2d = function (_set____db54di) {
  this.q2k_1.e2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).r2d = function () {
  return this.q2k_1.e2d_1;
};
protoOf(IncompleteLocalDateTime).s2d = function (_set____db54di) {
  this.r2k_1.v2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).z2d = function () {
  return this.r2k_1.v2d_1;
};
protoOf(IncompleteLocalDateTime).a2e = function (value) {
  this.r2k_1.a2e(value);
};
protoOf(IncompleteLocalDateTime).b2e = function () {
  return this.r2k_1.b2e();
};
protoOf(IncompleteLocalDateTime).c2e = function (_set____db54di) {
  this.r2k_1.t2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).d2e = function () {
  return this.r2k_1.t2d_1;
};
protoOf(IncompleteLocalDateTime).e2e = function (_set____db54di) {
  this.r2k_1.u2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).f2e = function () {
  return this.r2k_1.u2d_1;
};
protoOf(IncompleteLocalDateTime).g2e = function (_set____db54di) {
  this.r2k_1.w2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).h2e = function () {
  return this.r2k_1.w2d_1;
};
protoOf(IncompleteLocalDateTime).i2e = function (_set____db54di) {
  this.r2k_1.y2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).j2e = function () {
  return this.r2k_1.y2d_1;
};
protoOf(IncompleteLocalDateTime).k2e = function (_set____db54di) {
  this.r2k_1.x2d_1 = _set____db54di;
};
protoOf(IncompleteLocalDateTime).l2e = function () {
  return this.r2k_1.x2d_1;
};
protoOf(IncompleteLocalDateTime).u2k = function () {
  return LocalDateTime_init_$Create$(this.q2k_1.m2g(), this.r2k_1.k2g());
};
protoOf(IncompleteLocalDateTime).s2k = function (dateTime) {
  this.q2k_1.n2i(dateTime.w2k());
  this.r2k_1.y2k(dateTime.x2k());
};
protoOf(IncompleteLocalDateTime).y2e = function () {
  return new IncompleteLocalDateTime(this.q2k_1.y2e(), this.r2k_1.y2e());
};
function AbstractWithDateTimeBuilder() {
}
function ISO_DATETIME$delegate$lambda() {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  var tmp = Companion_instance_8;
  return tmp.m2k(ISO_DATETIME$delegate$lambda$lambda);
}
function ISO_DATETIME$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  $this$build.z2e(get_ISO_DATE());
  var tmp = [ISO_DATETIME$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_DATETIME$delegate$lambda$lambda$lambda_0);
  $this$build.o2h(get_ISO_TIME());
  return Unit_instance;
}
function ISO_DATETIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
  return Unit_instance;
}
function ISO_DATETIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
  return Unit_instance;
}
function ISO_DATETIME$factory() {
  return getPropertyCallableRef('ISO_DATETIME', 0, KProperty0, function () {
    return get_ISO_DATETIME();
  }, null);
}
var properties_initialized_LocalDateTimeFormat_kt_67ys6r;
function _init_properties_LocalDateTimeFormat_kt__aloigl() {
  if (!properties_initialized_LocalDateTimeFormat_kt_67ys6r) {
    properties_initialized_LocalDateTimeFormat_kt_67ys6r = true;
    ISO_DATETIME$delegate = lazy(ISO_DATETIME$delegate$lambda);
    emptyIncompleteLocalDateTime = new IncompleteLocalDateTime();
  }
}
function get_ISO_TIME() {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  var tmp0 = ISO_TIME$delegate;
  // Inline function 'kotlin.getValue' call
  ISO_TIME$factory();
  return tmp0.t();
}
var ISO_TIME$delegate;
function get_emptyIncompleteLocalTime() {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  return emptyIncompleteLocalTime;
}
var emptyIncompleteLocalTime;
function TimeFieldContainer() {
}
function IncompleteLocalTime(hour, hourOfAmPm, amPm, minute, second, nanosecond) {
  hour = hour === VOID ? null : hour;
  hourOfAmPm = hourOfAmPm === VOID ? null : hourOfAmPm;
  amPm = amPm === VOID ? null : amPm;
  minute = minute === VOID ? null : minute;
  second = second === VOID ? null : second;
  nanosecond = nanosecond === VOID ? null : nanosecond;
  this.t2d_1 = hour;
  this.u2d_1 = hourOfAmPm;
  this.v2d_1 = amPm;
  this.w2d_1 = minute;
  this.x2d_1 = second;
  this.y2d_1 = nanosecond;
}
protoOf(IncompleteLocalTime).c2e = function (_set____db54di) {
  this.t2d_1 = _set____db54di;
};
protoOf(IncompleteLocalTime).d2e = function () {
  return this.t2d_1;
};
protoOf(IncompleteLocalTime).e2e = function (_set____db54di) {
  this.u2d_1 = _set____db54di;
};
protoOf(IncompleteLocalTime).f2e = function () {
  return this.u2d_1;
};
protoOf(IncompleteLocalTime).s2d = function (_set____db54di) {
  this.v2d_1 = _set____db54di;
};
protoOf(IncompleteLocalTime).z2d = function () {
  return this.v2d_1;
};
protoOf(IncompleteLocalTime).g2e = function (_set____db54di) {
  this.w2d_1 = _set____db54di;
};
protoOf(IncompleteLocalTime).h2e = function () {
  return this.w2d_1;
};
protoOf(IncompleteLocalTime).k2e = function (_set____db54di) {
  this.x2d_1 = _set____db54di;
};
protoOf(IncompleteLocalTime).l2e = function () {
  return this.x2d_1;
};
protoOf(IncompleteLocalTime).i2e = function (_set____db54di) {
  this.y2d_1 = _set____db54di;
};
protoOf(IncompleteLocalTime).j2e = function () {
  return this.y2d_1;
};
protoOf(IncompleteLocalTime).k2g = function () {
  var tmp0_safe_receiver = this.t2d_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = this.u2d_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.require' call
      if (!((((tmp0_safe_receiver + 11 | 0) % 12 | 0) + 1 | 0) === tmp0_safe_receiver_0)) {
        var message = 'Inconsistent hour and hour-of-am-pm: hour is ' + tmp0_safe_receiver + ', but hour-of-am-pm is ' + tmp0_safe_receiver_0;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
    var tmp1_safe_receiver = this.v2d_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.require' call
      if (!(tmp1_safe_receiver.equals(AmPmMarker_PM_getInstance()) === tmp0_safe_receiver >= 12)) {
        var message_0 = 'Inconsistent hour and the AM/PM marker: hour is ' + tmp0_safe_receiver + ', but the AM/PM marker is ' + tmp1_safe_receiver.toString();
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
    }
    tmp = tmp0_safe_receiver;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    var tmp1_safe_receiver_0 = this.u2d_1;
    var tmp_1;
    if (tmp1_safe_receiver_0 == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_1 = this.v2d_1;
      var tmp_2;
      if (tmp0_safe_receiver_1 == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.let' call
        tmp_2 = (tmp1_safe_receiver_0 === 12 ? 0 : tmp1_safe_receiver_0) + (tmp0_safe_receiver_1.equals(AmPmMarker_PM_getInstance()) ? 12 : 0) | 0;
      }
      tmp_1 = tmp_2;
    }
    tmp_0 = tmp_1;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_0;
  var tmp_3;
  if (tmp3_elvis_lhs == null) {
    throw DateTimeFormatException_init_$Create$_0('Incomplete time: missing hour');
  } else {
    tmp_3 = tmp3_elvis_lhs;
  }
  var hour = tmp_3;
  var tmp_4 = requireParsedField(this.w2d_1, 'minute');
  var tmp4_elvis_lhs = this.x2d_1;
  var tmp_5 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
  var tmp5_elvis_lhs = this.y2d_1;
  return LocalTime_init_$Create$(hour, tmp_4, tmp_5, tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
};
protoOf(IncompleteLocalTime).y2k = function (localTime) {
  this.t2d_1 = localTime.d2e();
  this.u2d_1 = ((localTime.d2e() + 11 | 0) % 12 | 0) + 1 | 0;
  this.v2d_1 = localTime.d2e() >= 12 ? AmPmMarker_PM_getInstance() : AmPmMarker_AM_getInstance();
  this.w2d_1 = localTime.h2e();
  this.x2d_1 = localTime.l2e();
  this.y2d_1 = localTime.j2e();
};
protoOf(IncompleteLocalTime).y2e = function () {
  return new IncompleteLocalTime(this.t2d_1, this.u2d_1, this.v2d_1, this.w2d_1, this.x2d_1, this.y2d_1);
};
protoOf(IncompleteLocalTime).equals = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  if (other instanceof IncompleteLocalTime) {
    tmp_4 = this.t2d_1 == other.t2d_1;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = this.u2d_1 == other.u2d_1;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = equals(this.v2d_1, other.v2d_1);
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = this.w2d_1 == other.w2d_1;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = this.x2d_1 == other.x2d_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.y2d_1 == other.y2d_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(IncompleteLocalTime).hashCode = function () {
  var tmp6_elvis_lhs = this.t2d_1;
  var tmp = imul(tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs, 31);
  var tmp5_elvis_lhs = this.u2d_1;
  var tmp_0 = tmp + imul(tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs, 31) | 0;
  var tmp3_safe_receiver = this.v2d_1;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.hashCode();
  var tmp_1 = tmp_0 + imul(tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs, 31) | 0;
  var tmp2_elvis_lhs = this.w2d_1;
  var tmp_2 = tmp_1 + imul(tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs, 31) | 0;
  var tmp1_elvis_lhs = this.x2d_1;
  var tmp_3 = tmp_2 + imul(tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs, 31) | 0;
  var tmp0_elvis_lhs = this.y2d_1;
  return tmp_3 + (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) | 0;
};
protoOf(IncompleteLocalTime).toString = function () {
  var tmp0_elvis_lhs = this.t2d_1;
  var tmp = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
  var tmp1_elvis_lhs = this.w2d_1;
  var tmp_0 = toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
  var tmp2_elvis_lhs = this.x2d_1;
  var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
  var tmp3_safe_receiver = this.y2d_1;
  var tmp_2;
  if (tmp3_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.let' call
    var it = tmp3_safe_receiver.toString();
    tmp_2 = padStart(it, 9 - it.length | 0, _Char___init__impl__6a9atx(48));
  }
  var tmp4_elvis_lhs = tmp_2;
  return tmp + ':' + tmp_0 + ':' + tmp_1 + '.' + (tmp4_elvis_lhs == null ? '???' : tmp4_elvis_lhs);
};
var AmPmMarker_AM_instance;
var AmPmMarker_PM_instance;
var AmPmMarker_entriesInitialized;
function AmPmMarker_initEntries() {
  if (AmPmMarker_entriesInitialized)
    return Unit_instance;
  AmPmMarker_entriesInitialized = true;
  AmPmMarker_AM_instance = new AmPmMarker('AM', 0);
  AmPmMarker_PM_instance = new AmPmMarker('PM', 1);
}
function AmPmMarker(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Companion_9() {
}
protoOf(Companion_9).c2l = function (block) {
  var builder = new Builder_2(new AppendableFormatStructure());
  block(builder);
  return new LocalTimeFormat(builder.r2f());
};
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function Builder_2(actualBuilder) {
  this.d2l_1 = actualBuilder;
}
protoOf(Builder_2).x2g = function () {
  return this.d2l_1;
};
protoOf(Builder_2).g2h = function (structure) {
  this.d2l_1.a2h(structure);
};
protoOf(Builder_2).c2h = function () {
  return new Builder_2(new AppendableFormatStructure());
};
function LocalTimeFormat(actualFormat) {
  AbstractDateTimeFormat.call(this);
  this.e2l_1 = actualFormat;
}
protoOf(LocalTimeFormat).v2h = function () {
  return this.e2l_1;
};
protoOf(LocalTimeFormat).f2l = function (value) {
  // Inline function 'kotlin.apply' call
  var this_0 = new IncompleteLocalTime();
  this_0.y2k(value);
  return this_0;
};
protoOf(LocalTimeFormat).x2h = function (value) {
  return this.f2l(value instanceof LocalTime_0 ? value : THROW_CCE());
};
protoOf(LocalTimeFormat).g2l = function (intermediate) {
  return intermediate.k2g();
};
protoOf(LocalTimeFormat).z2h = function (intermediate) {
  return this.g2l(intermediate instanceof IncompleteLocalTime ? intermediate : THROW_CCE());
};
protoOf(LocalTimeFormat).a2i = function () {
  return get_emptyIncompleteLocalTime();
};
function AbstractWithTimeBuilder() {
}
function HourDirective(padding) {
  var tmp = TimeFields_getInstance().h2l_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.r2l_1 = padding;
}
protoOf(HourDirective).equals = function (other) {
  var tmp;
  if (other instanceof HourDirective) {
    tmp = this.r2l_1.equals(other.r2l_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(HourDirective).hashCode = function () {
  return this.r2l_1.hashCode();
};
function MinuteDirective(padding) {
  var tmp = TimeFields_getInstance().i2l_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.w2l_1 = padding;
}
protoOf(MinuteDirective).equals = function (other) {
  var tmp;
  if (other instanceof MinuteDirective) {
    tmp = this.w2l_1.equals(other.w2l_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(MinuteDirective).hashCode = function () {
  return this.w2l_1.hashCode();
};
function SecondDirective(padding) {
  var tmp = TimeFields_getInstance().j2l_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.b2m_1 = padding;
}
protoOf(SecondDirective).equals = function (other) {
  var tmp;
  if (other instanceof SecondDirective) {
    tmp = this.b2m_1.equals(other.b2m_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(SecondDirective).hashCode = function () {
  return this.b2m_1.hashCode();
};
function Companion_10() {
  Companion_instance_10 = this;
  this.c2m_1 = listOf([0, 0, 0, 0, 0, 0, 0, 0, 0]);
  this.d2m_1 = listOf([2, 1, 0, 2, 1, 0, 2, 1, 0]);
}
var Companion_instance_10;
function Companion_getInstance_10() {
  if (Companion_instance_10 == null)
    new Companion_10();
  return Companion_instance_10;
}
function FractionalSecondDirective(minDigits, maxDigits, zerosToAdd) {
  Companion_getInstance_10();
  zerosToAdd = zerosToAdd === VOID ? Companion_getInstance_10().c2m_1 : zerosToAdd;
  DecimalFractionFieldFormatDirective.call(this, TimeFields_getInstance().k2l_1, minDigits, maxDigits, zerosToAdd);
  this.i2m_1 = minDigits;
  this.j2m_1 = maxDigits;
}
protoOf(FractionalSecondDirective).equals = function (other) {
  var tmp;
  var tmp_0;
  if (other instanceof FractionalSecondDirective) {
    tmp_0 = this.i2m_1 === other.i2m_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.j2m_1 === other.j2m_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(FractionalSecondDirective).hashCode = function () {
  return imul(31, this.i2m_1) + this.j2m_1 | 0;
};
function TimeFields() {
  TimeFields_instance = this;
  this.h2l_1 = new UnsignedFieldSpec(new PropertyAccessor(hour$factory_0()), 0, 23);
  this.i2l_1 = new UnsignedFieldSpec(new PropertyAccessor(minute$factory_0()), 0, 59);
  this.j2l_1 = new UnsignedFieldSpec(new PropertyAccessor(second$factory_0()), 0, 59, VOID, 0);
  this.k2l_1 = new GenericFieldSpec(new PropertyAccessor(fractionOfSecond$factory()), VOID, new DecimalFraction(0, 9));
  this.l2l_1 = new GenericFieldSpec(new PropertyAccessor(amPm$factory_0()));
  this.m2l_1 = new UnsignedFieldSpec(new PropertyAccessor(hourOfAmPm$factory_0()), 1, 12);
}
var TimeFields_instance;
function TimeFields_getInstance() {
  if (TimeFields_instance == null)
    new TimeFields();
  return TimeFields_instance;
}
function ISO_TIME$delegate$lambda() {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  var tmp = Companion_instance_9;
  return tmp.c2l(ISO_TIME$delegate$lambda$lambda);
}
function ISO_TIME$delegate$lambda$lambda($this$build) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  $this$build.a2f();
  char($this$build, _Char___init__impl__6a9atx(58));
  $this$build.b2f();
  var tmp = [ISO_TIME$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_TIME$delegate$lambda$lambda$lambda_0);
  return Unit_instance;
}
function ISO_TIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  return Unit_instance;
}
function ISO_TIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(58));
  $this$alternativeParsing.c2f();
  optional($this$alternativeParsing, VOID, ISO_TIME$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_TIME$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  char($this$optional, _Char___init__impl__6a9atx(46));
  $this$optional.d2f(1, 9);
  return Unit_instance;
}
function AmPmMarker_AM_getInstance() {
  AmPmMarker_initEntries();
  return AmPmMarker_AM_instance;
}
function AmPmMarker_PM_getInstance() {
  AmPmMarker_initEntries();
  return AmPmMarker_PM_instance;
}
function ISO_TIME$factory() {
  return getPropertyCallableRef('ISO_TIME', 0, KProperty0, function () {
    return get_ISO_TIME();
  }, null);
}
function hour$factory_0() {
  return getPropertyCallableRef('hour', 1, KMutableProperty1, function (receiver) {
    return receiver.d2e();
  }, function (receiver, value) {
    return receiver.c2e(value);
  });
}
function minute$factory_0() {
  return getPropertyCallableRef('minute', 1, KMutableProperty1, function (receiver) {
    return receiver.h2e();
  }, function (receiver, value) {
    return receiver.g2e(value);
  });
}
function second$factory_0() {
  return getPropertyCallableRef('second', 1, KMutableProperty1, function (receiver) {
    return receiver.l2e();
  }, function (receiver, value) {
    return receiver.k2e(value);
  });
}
function fractionOfSecond$factory() {
  return getPropertyCallableRef('fractionOfSecond', 1, KMutableProperty1, function (receiver) {
    return receiver.b2e();
  }, function (receiver, value) {
    return receiver.a2e(value);
  });
}
function amPm$factory_0() {
  return getPropertyCallableRef('amPm', 1, KMutableProperty1, function (receiver) {
    return receiver.z2d();
  }, function (receiver, value) {
    return receiver.s2d(value);
  });
}
function hourOfAmPm$factory_0() {
  return getPropertyCallableRef('hourOfAmPm', 1, KMutableProperty1, function (receiver) {
    return receiver.f2e();
  }, function (receiver, value) {
    return receiver.e2e(value);
  });
}
var properties_initialized_LocalTimeFormat_kt_l1b0w1;
function _init_properties_LocalTimeFormat_kt__5i3lfh() {
  if (!properties_initialized_LocalTimeFormat_kt_l1b0w1) {
    properties_initialized_LocalTimeFormat_kt_l1b0w1 = true;
    ISO_TIME$delegate = lazy(ISO_TIME$delegate$lambda);
    emptyIncompleteLocalTime = new IncompleteLocalTime();
  }
}
function get_ISO_OFFSET() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp0 = ISO_OFFSET$delegate;
  // Inline function 'kotlin.getValue' call
  ISO_OFFSET$factory();
  return tmp0.t();
}
var ISO_OFFSET$delegate;
function get_ISO_OFFSET_BASIC() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp0 = ISO_OFFSET_BASIC$delegate;
  // Inline function 'kotlin.getValue' call
  ISO_OFFSET_BASIC$factory();
  return tmp0.t();
}
var ISO_OFFSET_BASIC$delegate;
function get_FOUR_DIGIT_OFFSET() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp0 = FOUR_DIGIT_OFFSET$delegate;
  // Inline function 'kotlin.getValue' call
  FOUR_DIGIT_OFFSET$factory();
  return tmp0.t();
}
var FOUR_DIGIT_OFFSET$delegate;
function get_emptyIncompleteUtcOffset() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  return emptyIncompleteUtcOffset;
}
var emptyIncompleteUtcOffset;
function UtcOffsetFieldContainer() {
}
function IncompleteUtcOffset(isNegative, totalHoursAbs, minutesOfHour, secondsOfMinute) {
  isNegative = isNegative === VOID ? null : isNegative;
  totalHoursAbs = totalHoursAbs === VOID ? null : totalHoursAbs;
  minutesOfHour = minutesOfHour === VOID ? null : minutesOfHour;
  secondsOfMinute = secondsOfMinute === VOID ? null : secondsOfMinute;
  this.n2e_1 = isNegative;
  this.o2e_1 = totalHoursAbs;
  this.p2e_1 = minutesOfHour;
  this.q2e_1 = secondsOfMinute;
}
protoOf(IncompleteUtcOffset).m2e = function (_set____db54di) {
  this.n2e_1 = _set____db54di;
};
protoOf(IncompleteUtcOffset).r2e = function () {
  return this.n2e_1;
};
protoOf(IncompleteUtcOffset).w2e = function (_set____db54di) {
  this.o2e_1 = _set____db54di;
};
protoOf(IncompleteUtcOffset).x2e = function () {
  return this.o2e_1;
};
protoOf(IncompleteUtcOffset).s2e = function (_set____db54di) {
  this.p2e_1 = _set____db54di;
};
protoOf(IncompleteUtcOffset).t2e = function () {
  return this.p2e_1;
};
protoOf(IncompleteUtcOffset).u2e = function (_set____db54di) {
  this.q2e_1 = _set____db54di;
};
protoOf(IncompleteUtcOffset).v2e = function () {
  return this.q2e_1;
};
protoOf(IncompleteUtcOffset).j2g = function () {
  var sign = this.n2e_1 === true ? -1 : 1;
  var tmp0_safe_receiver = this.o2e_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = imul(tmp0_safe_receiver, sign);
  }
  var tmp_0 = tmp;
  var tmp1_safe_receiver = this.p2e_1;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = imul(tmp1_safe_receiver, sign);
  }
  var tmp_2 = tmp_1;
  var tmp2_safe_receiver = this.q2e_1;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = imul(tmp2_safe_receiver, sign);
  }
  return UtcOffset_0(tmp_0, tmp_2, tmp_3);
};
protoOf(IncompleteUtcOffset).o2m = function (offset) {
  this.n2e_1 = offset.s2g() < 0;
  // Inline function 'kotlin.math.absoluteValue' call
  var this_0 = offset.s2g();
  var totalSecondsAbs = abs(this_0);
  this.o2e_1 = totalSecondsAbs / 3600 | 0;
  this.p2e_1 = (totalSecondsAbs / 60 | 0) % 60 | 0;
  this.q2e_1 = totalSecondsAbs % 60 | 0;
};
protoOf(IncompleteUtcOffset).equals = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  if (other instanceof IncompleteUtcOffset) {
    tmp_2 = this.n2e_1 == other.n2e_1;
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = this.o2e_1 == other.o2e_1;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = this.p2e_1 == other.p2e_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.q2e_1 == other.q2e_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(IncompleteUtcOffset).hashCode = function () {
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver = this.n2e_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_0 = this.o2e_1;
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
  var tmp_0 = tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_1 = this.p2e_1;
  var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
  var tmp_1 = tmp_0 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_2 = this.q2e_1;
  var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
  return tmp_1 + (tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2) | 0;
};
protoOf(IncompleteUtcOffset).y2e = function () {
  return new IncompleteUtcOffset(this.n2e_1, this.o2e_1, this.p2e_1, this.q2e_1);
};
protoOf(IncompleteUtcOffset).toString = function () {
  var tmp0_safe_receiver = this.n2e_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp0_safe_receiver ? '-' : '+';
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0 = tmp1_elvis_lhs == null ? ' ' : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = this.o2e_1;
  var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
  var tmp3_elvis_lhs = this.p2e_1;
  var tmp_2 = toString(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs);
  var tmp4_elvis_lhs = this.q2e_1;
  return tmp_0 + tmp_1 + ':' + tmp_2 + ':' + toString(tmp4_elvis_lhs == null ? '??' : tmp4_elvis_lhs);
};
function UtcOffsetWholeHoursDirective(padding) {
  var tmp = OffsetFields_getInstance().q2m_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.x2m_1 = padding;
}
protoOf(UtcOffsetWholeHoursDirective).equals = function (other) {
  var tmp;
  if (other instanceof UtcOffsetWholeHoursDirective) {
    tmp = this.x2m_1.equals(other.x2m_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(UtcOffsetWholeHoursDirective).hashCode = function () {
  return this.x2m_1.hashCode();
};
function Companion_11() {
}
protoOf(Companion_11).y2m = function (block) {
  var builder = new Builder_3(new AppendableFormatStructure());
  block(builder);
  return new UtcOffsetFormat(builder.r2f());
};
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
function Builder_3(actualBuilder) {
  this.z2m_1 = actualBuilder;
}
protoOf(Builder_3).x2g = function () {
  return this.z2m_1;
};
protoOf(Builder_3).b2h = function (structure) {
  this.z2m_1.a2h(structure);
};
protoOf(Builder_3).c2h = function () {
  return new Builder_3(new AppendableFormatStructure());
};
function UtcOffsetFormat(actualFormat) {
  AbstractDateTimeFormat.call(this);
  this.a2n_1 = actualFormat;
}
protoOf(UtcOffsetFormat).v2h = function () {
  return this.a2n_1;
};
protoOf(UtcOffsetFormat).b2n = function (value) {
  // Inline function 'kotlin.apply' call
  var this_0 = new IncompleteUtcOffset();
  this_0.o2m(value);
  return this_0;
};
protoOf(UtcOffsetFormat).x2h = function (value) {
  return this.b2n(value instanceof UtcOffset ? value : THROW_CCE());
};
protoOf(UtcOffsetFormat).c2n = function (intermediate) {
  return intermediate.j2g();
};
protoOf(UtcOffsetFormat).z2h = function (intermediate) {
  return this.c2n(intermediate instanceof IncompleteUtcOffset ? intermediate : THROW_CCE());
};
protoOf(UtcOffsetFormat).a2i = function () {
  return get_emptyIncompleteUtcOffset();
};
function OffsetFields$sign$1() {
  this.d2n_1 = new PropertyAccessor(isNegative$factory_0());
}
protoOf(OffsetFields$sign$1).r2e = function () {
  return this.d2n_1;
};
protoOf(OffsetFields$sign$1).e2n = function (obj) {
  var tmp;
  var tmp_0;
  var tmp0_elvis_lhs = obj.x2e();
  if ((tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) === 0) {
    var tmp1_elvis_lhs = obj.t2e();
    tmp_0 = (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) === 0;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp2_elvis_lhs = obj.v2e();
    tmp = (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) === 0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(OffsetFields$sign$1).f2n = function (obj) {
  return this.e2n((!(obj == null) ? isInterface(obj, UtcOffsetFieldContainer) : false) ? obj : THROW_CCE());
};
function OffsetFields() {
  OffsetFields_instance = this;
  var tmp = this;
  tmp.p2m_1 = new OffsetFields$sign$1();
  var tmp_0 = this;
  var tmp0_accessor = new PropertyAccessor(totalHoursAbs$factory_0());
  var tmp1_sign = this.p2m_1;
  tmp_0.q2m_1 = new UnsignedFieldSpec(tmp0_accessor, 0, 18, VOID, 0, tmp1_sign);
  var tmp_1 = this;
  var tmp0_accessor_0 = new PropertyAccessor(minutesOfHour$factory_0());
  var tmp1_sign_0 = this.p2m_1;
  tmp_1.r2m_1 = new UnsignedFieldSpec(tmp0_accessor_0, 0, 59, VOID, 0, tmp1_sign_0);
  var tmp_2 = this;
  var tmp0_accessor_1 = new PropertyAccessor(secondsOfMinute$factory_0());
  var tmp1_sign_1 = this.p2m_1;
  tmp_2.s2m_1 = new UnsignedFieldSpec(tmp0_accessor_1, 0, 59, VOID, 0, tmp1_sign_1);
}
var OffsetFields_instance;
function OffsetFields_getInstance() {
  if (OffsetFields_instance == null)
    new OffsetFields();
  return OffsetFields_instance;
}
function AbstractWithOffsetBuilder() {
}
function UtcOffsetMinuteOfHourDirective(padding) {
  var tmp = OffsetFields_getInstance().r2m_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.k2n_1 = padding;
}
protoOf(UtcOffsetMinuteOfHourDirective).equals = function (other) {
  var tmp;
  if (other instanceof UtcOffsetMinuteOfHourDirective) {
    tmp = this.k2n_1.equals(other.k2n_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(UtcOffsetMinuteOfHourDirective).hashCode = function () {
  return this.k2n_1.hashCode();
};
function UtcOffsetSecondOfMinuteDirective(padding) {
  var tmp = OffsetFields_getInstance().s2m_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.p2n_1 = padding;
}
protoOf(UtcOffsetSecondOfMinuteDirective).equals = function (other) {
  var tmp;
  if (other instanceof UtcOffsetSecondOfMinuteDirective) {
    tmp = this.p2n_1.equals(other.p2n_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(UtcOffsetSecondOfMinuteDirective).hashCode = function () {
  return this.p2n_1.hashCode();
};
function ISO_OFFSET$delegate$lambda() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = Companion_instance_11;
  return tmp.y2m(ISO_OFFSET$delegate$lambda$lambda);
}
function ISO_OFFSET$delegate$lambda$lambda($this$build) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = [ISO_OFFSET$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_OFFSET$delegate$lambda$lambda$lambda_0);
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$alternativeParsing.l2f('z');
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  optional($this$alternativeParsing, 'Z', ISO_OFFSET$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.e2f();
  char($this$optional, _Char___init__impl__6a9atx(58));
  $this$optional.r2h();
  optional($this$optional, VOID, ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  char($this$optional, _Char___init__impl__6a9atx(58));
  $this$optional.t2h();
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = Companion_instance_11;
  return tmp.y2m(ISO_OFFSET_BASIC$delegate$lambda$lambda);
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda($this$build) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = [ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$alternativeParsing.l2f('z');
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  optional($this$alternativeParsing, 'Z', ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.e2f();
  optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.r2h();
  optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.t2h();
  return Unit_instance;
}
function FOUR_DIGIT_OFFSET$delegate$lambda() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = Companion_instance_11;
  return tmp.y2m(FOUR_DIGIT_OFFSET$delegate$lambda$lambda);
}
function FOUR_DIGIT_OFFSET$delegate$lambda$lambda($this$build) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$build.e2f();
  $this$build.r2h();
  return Unit_instance;
}
function ISO_OFFSET$factory() {
  return getPropertyCallableRef('ISO_OFFSET', 0, KProperty0, function () {
    return get_ISO_OFFSET();
  }, null);
}
function ISO_OFFSET_BASIC$factory() {
  return getPropertyCallableRef('ISO_OFFSET_BASIC', 0, KProperty0, function () {
    return get_ISO_OFFSET_BASIC();
  }, null);
}
function FOUR_DIGIT_OFFSET$factory() {
  return getPropertyCallableRef('FOUR_DIGIT_OFFSET', 0, KProperty0, function () {
    return get_FOUR_DIGIT_OFFSET();
  }, null);
}
function totalHoursAbs$factory_0() {
  return getPropertyCallableRef('totalHoursAbs', 1, KMutableProperty1, function (receiver) {
    return receiver.x2e();
  }, function (receiver, value) {
    return receiver.w2e(value);
  });
}
function minutesOfHour$factory_0() {
  return getPropertyCallableRef('minutesOfHour', 1, KMutableProperty1, function (receiver) {
    return receiver.t2e();
  }, function (receiver, value) {
    return receiver.s2e(value);
  });
}
function secondsOfMinute$factory_0() {
  return getPropertyCallableRef('secondsOfMinute', 1, KMutableProperty1, function (receiver) {
    return receiver.v2e();
  }, function (receiver, value) {
    return receiver.u2e(value);
  });
}
function isNegative$factory_0() {
  return getPropertyCallableRef('isNegative', 1, KMutableProperty1, function (receiver) {
    return receiver.r2e();
  }, function (receiver, value) {
    return receiver.m2e(value);
  });
}
var properties_initialized_UtcOffsetFormat_kt_6y9jku;
function _init_properties_UtcOffsetFormat_kt__9r9ddw() {
  if (!properties_initialized_UtcOffsetFormat_kt_6y9jku) {
    properties_initialized_UtcOffsetFormat_kt_6y9jku = true;
    ISO_OFFSET$delegate = lazy(ISO_OFFSET$delegate$lambda);
    ISO_OFFSET_BASIC$delegate = lazy(ISO_OFFSET_BASIC$delegate$lambda);
    FOUR_DIGIT_OFFSET$delegate = lazy(FOUR_DIGIT_OFFSET$delegate$lambda);
    emptyIncompleteUtcOffset = new IncompleteUtcOffset();
  }
}
function AppendableFormatStructure() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.z2g_1 = ArrayList_init_$Create$_0();
}
protoOf(AppendableFormatStructure).r2f = function () {
  return new ConcatenatedFormatStructure(this.z2g_1);
};
protoOf(AppendableFormatStructure).a2h = function (format) {
  if (isInterface(format, NonConcatenatedFormatStructure)) {
    this.z2g_1.e(format);
  } else {
    if (format instanceof ConcatenatedFormatStructure) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = format.k2i_1.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        this.z2g_1.e(element);
      }
    }
  }
};
function Accessor$getterNotNull$ref($boundThis) {
  var l = function (p0) {
    return $boundThis.q2n(p0);
  };
  l.callableName = 'getterNotNull';
  return l;
}
function SignedIntFieldFormatDirective(field, minDigits, maxDigits, spacePadding, outputPlusOnExceededWidth) {
  this.h2j_1 = field;
  this.i2j_1 = minDigits;
  this.j2j_1 = maxDigits;
  this.k2j_1 = spacePadding;
  this.l2j_1 = outputPlusOnExceededWidth;
  // Inline function 'kotlin.require' call
  if (!(this.i2j_1 == null || this.i2j_1 >= 0)) {
    var message = 'The minimum number of digits (' + this.i2j_1 + ') is negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.j2j_1 == null || this.i2j_1 == null || this.j2j_1 >= this.i2j_1)) {
    var message_0 = 'The maximum number of digits (' + this.j2j_1 + ') is less than the minimum number of digits (' + this.i2j_1 + ')';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(SignedIntFieldFormatDirective).m2j = function () {
  return this.h2j_1;
};
protoOf(SignedIntFieldFormatDirective).h2i = function () {
  var tmp = Accessor$getterNotNull$ref(this.h2j_1.r2n());
  var tmp0_elvis_lhs = this.i2j_1;
  var formatter = new SignedIntFormatterStructure(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, this.l2j_1);
  return !(this.k2j_1 == null) ? new SpacePaddedFormatter(formatter, this.k2j_1) : formatter;
};
protoOf(SignedIntFieldFormatDirective).j2i = function () {
  return SignedIntParser(this.i2j_1, this.j2j_1, this.k2j_1, this.h2j_1.r2n(), this.h2j_1.m1d(), this.l2j_1);
};
function Accessor$getterNotNull$ref_0($boundThis) {
  var l = function (p0) {
    return $boundThis.q2n(p0);
  };
  l.callableName = 'getterNotNull';
  return l;
}
function UnsignedIntFieldFormatDirective(field, minDigits, spacePadding) {
  this.s2j_1 = field;
  this.t2j_1 = minDigits;
  this.u2j_1 = spacePadding;
  this.v2j_1 = this.s2j_1.y2n_1;
  // Inline function 'kotlin.require' call
  if (!(this.t2j_1 >= 0)) {
    var message = 'The minimum number of digits (' + this.t2j_1 + ') is negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.v2j_1 >= this.t2j_1)) {
    var message_0 = 'The maximum number of digits (' + this.v2j_1 + ') is less than the minimum number of digits (' + this.t2j_1 + ')';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  if (!(this.u2j_1 == null)) {
    // Inline function 'kotlin.require' call
    if (!(this.u2j_1 > this.t2j_1)) {
      var message_1 = 'The space padding (' + this.u2j_1 + ') should be more than the minimum number of digits (' + this.t2j_1 + ')';
      throw IllegalArgumentException_init_$Create$(toString(message_1));
    }
  }
}
protoOf(UnsignedIntFieldFormatDirective).m2j = function () {
  return this.s2j_1;
};
protoOf(UnsignedIntFieldFormatDirective).h2i = function () {
  var formatter = new UnsignedIntFormatterStructure(Accessor$getterNotNull$ref_0(this.s2j_1.s2n_1), this.t2j_1);
  return !(this.u2j_1 == null) ? new SpacePaddedFormatter(formatter, this.u2j_1) : formatter;
};
protoOf(UnsignedIntFieldFormatDirective).j2i = function () {
  return spaceAndZeroPaddedUnsignedInt(this.t2j_1, this.v2j_1, this.u2j_1, this.s2j_1.s2n_1, this.s2j_1.v2n_1);
};
function getStringValue($this, target) {
  // Inline function 'kotlin.let' call
  var it = $this.a2k_1.s2n_1.q2n(target);
  var tmp0_elvis_lhs = getOrNull($this.b2k_1, it - $this.a2k_1.t2n_1 | 0);
  return tmp0_elvis_lhs == null ? 'The value ' + it + ' of ' + $this.a2k_1.v2n_1 + ' does not have a corresponding string representation' : tmp0_elvis_lhs;
}
function AssignableString($outer) {
  this.z2n_1 = $outer;
}
protoOf(AssignableString).a2o = function (container, newValue) {
  var tmp0_safe_receiver = this.z2n_1.a2k_1.s2n_1.b2o(container, this.z2n_1.b2k_1.w1(newValue) + this.z2n_1.a2k_1.t2n_1 | 0);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = this.z2n_1.b2k_1.o(tmp0_safe_receiver - this.z2n_1.a2k_1.t2n_1 | 0);
  }
  return tmp;
};
protoOf(AssignableString).b2o = function (container, newValue) {
  var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
  return this.a2o(tmp, (!(newValue == null) ? typeof newValue === 'string' : false) ? newValue : THROW_CCE());
};
protoOf(AssignableString).m1d = function () {
  return this.z2n_1.c2k_1;
};
function NamedUnsignedIntFieldFormatDirective$getStringValue$ref($boundThis) {
  var l = function (p0) {
    return getStringValue($boundThis, p0);
  };
  l.callableName = 'getStringValue';
  return l;
}
function NamedUnsignedIntFieldFormatDirective(field, values, name) {
  this.a2k_1 = field;
  this.b2k_1 = values;
  this.c2k_1 = name;
  // Inline function 'kotlin.require' call
  if (!(this.b2k_1.m() === ((this.a2k_1.u2n_1 - this.a2k_1.t2n_1 | 0) + 1 | 0))) {
    var message = 'The number of values (' + this.b2k_1.m() + ') in ' + toString(this.b2k_1) + ' does not match the range of the field (' + ((this.a2k_1.u2n_1 - this.a2k_1.t2n_1 | 0) + 1 | 0) + ')';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(NamedUnsignedIntFieldFormatDirective).m2j = function () {
  return this.a2k_1;
};
protoOf(NamedUnsignedIntFieldFormatDirective).h2i = function () {
  return new StringFormatterStructure(NamedUnsignedIntFieldFormatDirective$getStringValue$ref(this));
};
protoOf(NamedUnsignedIntFieldFormatDirective).j2i = function () {
  return new ParserStructure(listOf_0(new StringSetParserOperation(this.b2k_1, new AssignableString(this), 'one of ' + toString(this.b2k_1) + ' for ' + this.c2k_1)), emptyList());
};
function Accessor$getterNotNull$ref_1($boundThis) {
  var l = function (p0) {
    return $boundThis.q2n(p0);
  };
  l.callableName = 'getterNotNull';
  return l;
}
function DecimalFractionFieldFormatDirective(field, minDigits, maxDigits, zerosToAdd) {
  this.k2m_1 = field;
  this.l2m_1 = minDigits;
  this.m2m_1 = maxDigits;
  this.n2m_1 = zerosToAdd;
}
protoOf(DecimalFractionFieldFormatDirective).m2j = function () {
  return this.k2m_1;
};
protoOf(DecimalFractionFieldFormatDirective).h2i = function () {
  return new DecimalFractionFormatterStructure(Accessor$getterNotNull$ref_1(this.k2m_1.r2n()), this.l2m_1, this.m2m_1, this.n2m_1);
};
protoOf(DecimalFractionFieldFormatDirective).j2i = function () {
  return new ParserStructure(listOf_0(new NumberSpanParserOperation(listOf_0(new FractionPartConsumer(this.l2m_1, this.m2m_1, this.k2m_1.r2n(), this.k2m_1.m1d())))), emptyList());
};
function GenericFieldSpec(accessor, name, defaultValue, sign) {
  name = name === VOID ? accessor.m1d() : name;
  defaultValue = defaultValue === VOID ? null : defaultValue;
  sign = sign === VOID ? null : sign;
  AbstractFieldSpec.call(this);
  this.c2o_1 = accessor;
  this.d2o_1 = name;
  this.e2o_1 = defaultValue;
  this.f2o_1 = sign;
}
protoOf(GenericFieldSpec).r2n = function () {
  return this.c2o_1;
};
protoOf(GenericFieldSpec).m1d = function () {
  return this.d2o_1;
};
protoOf(GenericFieldSpec).g2o = function () {
  return this.e2o_1;
};
protoOf(GenericFieldSpec).h2o = function () {
  return this.f2o_1;
};
function PropertyAccessor(property) {
  this.i2o_1 = property;
}
protoOf(PropertyAccessor).m1d = function () {
  return this.i2o_1.callableName;
};
protoOf(PropertyAccessor).j2o = function (container, newValue) {
  var oldValue = this.i2o_1.get(container);
  var tmp;
  if (oldValue === null) {
    this.i2o_1.set(container, newValue);
    tmp = null;
  } else if (equals(oldValue, newValue)) {
    tmp = null;
  } else {
    tmp = oldValue;
  }
  return tmp;
};
protoOf(PropertyAccessor).b2o = function (container, newValue) {
  var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
  return this.j2o(tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
};
protoOf(PropertyAccessor).k2o = function (container) {
  return this.i2o_1.get(container);
};
function UnsignedFieldSpec(accessor, minValue, maxValue, name, defaultValue, sign) {
  name = name === VOID ? accessor.m1d() : name;
  defaultValue = defaultValue === VOID ? null : defaultValue;
  sign = sign === VOID ? null : sign;
  AbstractFieldSpec.call(this);
  this.s2n_1 = accessor;
  this.t2n_1 = minValue;
  this.u2n_1 = maxValue;
  this.v2n_1 = name;
  this.w2n_1 = defaultValue;
  this.x2n_1 = sign;
  var tmp = this;
  var tmp_0;
  if (this.u2n_1 < 10) {
    tmp_0 = 1;
  } else if (this.u2n_1 < 100) {
    tmp_0 = 2;
  } else if (this.u2n_1 < 1000) {
    tmp_0 = 3;
  } else {
    throw IllegalArgumentException_init_$Create$('Max value ' + this.u2n_1 + ' is too large');
  }
  tmp.y2n_1 = tmp_0;
}
protoOf(UnsignedFieldSpec).r2n = function () {
  return this.s2n_1;
};
protoOf(UnsignedFieldSpec).m1d = function () {
  return this.v2n_1;
};
protoOf(UnsignedFieldSpec).g2o = function () {
  return this.w2n_1;
};
protoOf(UnsignedFieldSpec).h2o = function () {
  return this.x2n_1;
};
function Accessor() {
}
function AbstractFieldSpec() {
}
protoOf(AbstractFieldSpec).toString = function () {
  return 'The field ' + this.m1d() + ' (default value is ' + toString_1(this.g2o()) + ')';
};
function CachedFormatStructure(formats) {
  ConcatenatedFormatStructure.call(this, formats);
  this.f2i_1 = protoOf(ConcatenatedFormatStructure).h2i.call(this);
  this.g2i_1 = protoOf(ConcatenatedFormatStructure).j2i.call(this);
}
protoOf(CachedFormatStructure).h2i = function () {
  return this.f2i_1;
};
protoOf(CachedFormatStructure).j2i = function () {
  return this.g2i_1;
};
function BasicFormatStructure(directive) {
  this.l2o_1 = directive;
}
protoOf(BasicFormatStructure).toString = function () {
  return 'BasicFormatStructure(' + toString(this.l2o_1) + ')';
};
protoOf(BasicFormatStructure).equals = function (other) {
  var tmp;
  if (other instanceof BasicFormatStructure) {
    tmp = equals(this.l2o_1, other.l2o_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(BasicFormatStructure).hashCode = function () {
  return hashCode(this.l2o_1);
};
protoOf(BasicFormatStructure).j2i = function () {
  return this.l2o_1.j2i();
};
protoOf(BasicFormatStructure).h2i = function () {
  return this.l2o_1.h2i();
};
function ConstantFormatStructure(string) {
  this.m2o_1 = string;
}
protoOf(ConstantFormatStructure).toString = function () {
  return 'ConstantFormatStructure(' + this.m2o_1 + ')';
};
protoOf(ConstantFormatStructure).equals = function (other) {
  var tmp;
  if (other instanceof ConstantFormatStructure) {
    tmp = this.m2o_1 === other.m2o_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ConstantFormatStructure).hashCode = function () {
  return getStringHashCode(this.m2o_1);
};
protoOf(ConstantFormatStructure).j2i = function () {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = this.m2o_1;
  if (charSequenceLength(this_0) === 0) {
    tmp = emptyList();
  } else {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_1 = ArrayList_init_$Create$_0();
    var tmp_0;
    if (isAsciiDigit(charSequenceGet(this.m2o_1, 0))) {
      var tmp0 = this.m2o_1;
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.text.takeWhile' call
        var inductionVariable = 0;
        var last = tmp0.length;
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var it = charSequenceGet(tmp0, index);
            if (!isAsciiDigit(it)) {
              // Inline function 'kotlin.text.substring' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp$ret$4 = tmp0.substring(0, index);
              break $l$block;
            }
          }
           while (inductionVariable < last);
        tmp$ret$4 = tmp0;
      }
      this_1.e(new NumberSpanParserOperation(listOf_0(new ConstantNumberConsumer(tmp$ret$4))));
      var tmp2 = this.m2o_1;
      var tmp$ret$8;
      $l$block_0: {
        // Inline function 'kotlin.text.dropWhile' call
        var inductionVariable_0 = 0;
        var last_0 = charSequenceLength(tmp2) - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var it_0 = charSequenceGet(tmp2, index_0);
            if (!isAsciiDigit(it_0)) {
              // Inline function 'kotlin.text.substring' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp$ret$8 = tmp2.substring(index_0);
              break $l$block_0;
            }
          }
           while (inductionVariable_0 <= last_0);
        tmp$ret$8 = '';
      }
      tmp_0 = tmp$ret$8;
    } else {
      tmp_0 = this.m2o_1;
    }
    var suffix = tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(suffix) > 0) {
      if (isAsciiDigit(charSequenceGet(suffix, suffix.length - 1 | 0))) {
        var tmp$ret$13;
        $l$block_1: {
          // Inline function 'kotlin.text.dropLastWhile' call
          var inductionVariable_1 = get_lastIndex(suffix);
          if (0 <= inductionVariable_1)
            do {
              var index_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + -1 | 0;
              var it_1 = charSequenceGet(suffix, index_1);
              if (!isAsciiDigit(it_1)) {
                // Inline function 'kotlin.text.substring' call
                var endIndex = index_1 + 1 | 0;
                // Inline function 'kotlin.js.asDynamic' call
                tmp$ret$13 = suffix.substring(0, endIndex);
                break $l$block_1;
              }
            }
             while (0 <= inductionVariable_1);
          tmp$ret$13 = '';
        }
        this_1.e(new PlainStringParserOperation(tmp$ret$13));
        var tmp$ret$17;
        $l$block_2: {
          // Inline function 'kotlin.text.takeLastWhile' call
          var inductionVariable_2 = get_lastIndex(suffix);
          if (0 <= inductionVariable_2)
            do {
              var index_2 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + -1 | 0;
              var it_2 = charSequenceGet(suffix, index_2);
              if (!isAsciiDigit(it_2)) {
                // Inline function 'kotlin.text.substring' call
                var startIndex = index_2 + 1 | 0;
                // Inline function 'kotlin.js.asDynamic' call
                tmp$ret$17 = suffix.substring(startIndex);
                break $l$block_2;
              }
            }
             while (0 <= inductionVariable_2);
          tmp$ret$17 = suffix;
        }
        this_1.e(new NumberSpanParserOperation(listOf_0(new ConstantNumberConsumer(tmp$ret$17))));
      } else {
        this_1.e(new PlainStringParserOperation(suffix));
      }
    }
    tmp = this_1.i5();
  }
  return new ParserStructure(tmp, emptyList());
};
protoOf(ConstantFormatStructure).h2i = function () {
  return new ConstantStringFormatterStructure(this.m2o_1);
};
function formatter$checkIfAllNegative(this$0, value) {
  var seenNonZero = false;
  var tmp0_iterator = this$0.p2o_1.j();
  $l$loop: while (tmp0_iterator.k()) {
    var check = tmp0_iterator.l();
    if (check.r2e().k2o(value) === true)
      seenNonZero = true;
    else if (check.f2n(value))
      continue $l$loop;
    else
      return false;
  }
  return seenNonZero;
}
function SignedFormatStructure$parser$lambda(this$0) {
  return function (value, isNegative) {
    var tmp0_iterator = this$0.p2o_1.j();
    while (tmp0_iterator.k()) {
      var field = tmp0_iterator.l();
      var wasNegative = field.r2e().k2o(value) === true;
      field.r2e().b2o(value, !(isNegative === wasNegative));
    }
    return Unit_instance;
  };
}
function SignedFormatStructure$formatter$checkIfAllNegative$ref(this$0) {
  var l = function (p0) {
    return formatter$checkIfAllNegative(this$0, p0);
  };
  l.callableName = 'checkIfAllNegative';
  return l;
}
function SignedFormatStructure(format, withPlusSign) {
  this.n2o_1 = format;
  this.o2o_1 = withPlusSign;
  var tmp = this;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = basicFormats(this.n2o_1);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = element.m2j().h2o();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.e(tmp0_safe_receiver);
    }
  }
  tmp.p2o_1 = toSet(destination);
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.require' call
  if (!!this.p2o_1.p()) {
    var message = 'Signed format must contain at least one field with a sign';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(SignedFormatStructure).toString = function () {
  return 'SignedFormatStructure(' + toString(this.n2o_1) + ')';
};
protoOf(SignedFormatStructure).equals = function (other) {
  var tmp;
  var tmp_0;
  if (other instanceof SignedFormatStructure) {
    tmp_0 = equals(this.n2o_1, other.n2o_1);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.o2o_1 === other.o2o_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(SignedFormatStructure).hashCode = function () {
  return imul(31, hashCode(this.n2o_1)) + getBooleanHashCode(this.o2o_1) | 0;
};
protoOf(SignedFormatStructure).j2i = function () {
  return concat(listOf([new ParserStructure(listOf_0(new SignParser(SignedFormatStructure$parser$lambda(this), this.o2o_1, 'sign for ' + toString(this.p2o_1))), emptyList()), this.n2o_1.j2i()]));
};
protoOf(SignedFormatStructure).h2i = function () {
  var innerFormat = this.n2o_1.h2i();
  return new SignedFormatter(innerFormat, SignedFormatStructure$formatter$checkIfAllNegative$ref(this), this.o2o_1);
};
function Companion_12() {
}
protoOf(Companion_12).q2o = function (field) {
  var default_0 = field.g2o();
  // Inline function 'kotlin.require' call
  if (!!(default_0 == null)) {
    var message = "The field '" + field.m1d() + "' does not define a default value";
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return new PropertyWithDefault(field.r2n(), default_0);
};
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
function access$_get_accessor__yxxs4k($this) {
  return $this.r2o_1;
}
function access$_get_defaultValue__8tt04b($this) {
  return $this.s2o_1;
}
function PropertyWithDefault(accessor, defaultValue) {
  this.r2o_1 = accessor;
  this.s2o_1 = defaultValue;
}
function OptionalFormatStructure$parser$lambda(this$0) {
  return function (it) {
    var tmp0_iterator = this$0.v2o_1.j();
    while (tmp0_iterator.k()) {
      var field = tmp0_iterator.l();
      // Inline function 'kotlinx.datetime.internal.format.PropertyWithDefault.assignDefault' call
      access$_get_accessor__yxxs4k(field).b2o(it, access$_get_defaultValue__8tt04b(field));
    }
    return Unit_instance;
  };
}
function Accessor$getter$ref($boundThis) {
  var l = function (p0) {
    return $boundThis.k2o(p0);
  };
  l.callableName = 'getter';
  return l;
}
function Predicate$test$ref($boundThis) {
  var l = function (p0) {
    return $boundThis.w2o(p0);
  };
  l.callableName = 'test';
  return l;
}
function Truth$test$ref($boundThis) {
  var l = function (p0) {
    return $boundThis.x2o(p0);
  };
  l.callableName = 'test';
  return l;
}
function OptionalFormatStructure(onZero, format) {
  this.t2o_1 = onZero;
  this.u2o_1 = format;
  var tmp = this;
  // Inline function 'kotlin.collections.map' call
  var this_0 = basicFormats(this.u2o_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = item.m2j();
    destination.e(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = distinct(destination);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$3 = Companion_instance_12.q2o(item_0);
    destination_0.e(tmp$ret$3);
  }
  tmp.v2o_1 = destination_0;
}
protoOf(OptionalFormatStructure).toString = function () {
  return 'Optional(' + this.t2o_1 + ', ' + toString(this.u2o_1) + ')';
};
protoOf(OptionalFormatStructure).equals = function (other) {
  var tmp;
  var tmp_0;
  if (other instanceof OptionalFormatStructure) {
    tmp_0 = this.t2o_1 === other.t2o_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = equals(this.u2o_1, other.u2o_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(OptionalFormatStructure).hashCode = function () {
  return imul(31, getStringHashCode(this.t2o_1)) + hashCode(this.u2o_1) | 0;
};
protoOf(OptionalFormatStructure).j2i = function () {
  var tmp = emptyList();
  var tmp_0 = this.u2o_1.j2i();
  var tmp_1 = (new ConstantFormatStructure(this.t2o_1)).j2i();
  var tmp_2;
  if (this.v2o_1.p()) {
    tmp_2 = emptyList();
  } else {
    tmp_2 = listOf_0(new UnconditionalModification(OptionalFormatStructure$parser$lambda(this)));
  }
  return new ParserStructure(tmp, listOf([tmp_0, concat(listOf([tmp_1, new ParserStructure(tmp_2, emptyList())]))]));
};
protoOf(OptionalFormatStructure).h2i = function () {
  var formatter = this.u2o_1.h2i();
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.v2o_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlinx.datetime.internal.format.PropertyWithDefault.isDefaultComparisonPredicate' call
    var tmp = access$_get_defaultValue__8tt04b(item);
    var tmp$ret$1 = new ComparisonPredicate(tmp, Accessor$getter$ref(access$_get_accessor__yxxs4k(item)));
    destination.e(tmp$ret$1);
  }
  var predicate = conjunctionPredicate(destination);
  var tmp_0;
  if (predicate instanceof Truth) {
    tmp_0 = new ConstantStringFormatterStructure(this.t2o_1);
  } else {
    var tmp_1 = to(Predicate$test$ref(predicate), new ConstantStringFormatterStructure(this.t2o_1));
    tmp_0 = new ConditionalFormatter(listOf([tmp_1, to(Truth$test$ref(Truth_instance), formatter)]));
  }
  return tmp_0;
};
function AlternativesParsingFormatStructure(mainFormat, formats) {
  this.y2o_1 = mainFormat;
  this.z2o_1 = formats;
}
protoOf(AlternativesParsingFormatStructure).toString = function () {
  return 'AlternativesParsing(' + toString(this.z2o_1) + ')';
};
protoOf(AlternativesParsingFormatStructure).equals = function (other) {
  var tmp;
  var tmp_0;
  if (other instanceof AlternativesParsingFormatStructure) {
    tmp_0 = equals(this.y2o_1, other.y2o_1);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = equals(this.z2o_1, other.z2o_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(AlternativesParsingFormatStructure).hashCode = function () {
  return imul(31, hashCode(this.y2o_1)) + hashCode(this.z2o_1) | 0;
};
protoOf(AlternativesParsingFormatStructure).j2i = function () {
  var tmp = emptyList();
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList_init_$Create$_0();
  this_0.e(this.y2o_1.j2i());
  var tmp0_iterator = this.z2o_1.j();
  while (tmp0_iterator.k()) {
    var format = tmp0_iterator.l();
    this_0.e(format.j2i());
  }
  var tmp$ret$3 = this_0.i5();
  return new ParserStructure(tmp, tmp$ret$3);
};
protoOf(AlternativesParsingFormatStructure).h2i = function () {
  return this.y2o_1.h2i();
};
function ConcatenatedFormatStructure(formats) {
  this.k2i_1 = formats;
}
protoOf(ConcatenatedFormatStructure).toString = function () {
  return 'ConcatenatedFormatStructure(' + joinToString(this.k2i_1, ', ') + ')';
};
protoOf(ConcatenatedFormatStructure).equals = function (other) {
  var tmp;
  if (other instanceof ConcatenatedFormatStructure) {
    tmp = equals(this.k2i_1, other.k2i_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ConcatenatedFormatStructure).hashCode = function () {
  return hashCode(this.k2i_1);
};
protoOf(ConcatenatedFormatStructure).j2i = function () {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.k2i_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = item.j2i();
    destination.e(tmp$ret$0);
  }
  return concat(destination);
};
protoOf(ConcatenatedFormatStructure).h2i = function () {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.k2i_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = item.h2i();
    destination.e(tmp$ret$0);
  }
  var formatters = destination;
  var tmp;
  if (formatters.m() === 1) {
    tmp = single(formatters);
  } else {
    tmp = new ConcatenatedFormatter(formatters);
  }
  return tmp;
};
function NonConcatenatedFormatStructure() {
}
function basicFormats(format) {
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList_init_$Create$_0();
  basicFormats$_anonymous_$rec_hkf0lf(this_0, format);
  return this_0.i5();
}
function basicFormats$_anonymous_$rec_hkf0lf($this_buildList, format) {
  if (format instanceof BasicFormatStructure) {
    $this_buildList.e(format.l2o_1);
  } else {
    if (format instanceof ConcatenatedFormatStructure) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = format.k2i_1.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        basicFormats$_anonymous_$rec_hkf0lf($this_buildList, element);
      }
    } else {
      if (!(format instanceof ConstantFormatStructure)) {
        if (format instanceof SignedFormatStructure) {
          basicFormats$_anonymous_$rec_hkf0lf($this_buildList, format.n2o_1);
        } else {
          if (format instanceof AlternativesParsingFormatStructure) {
            basicFormats$_anonymous_$rec_hkf0lf($this_buildList, format.y2o_1);
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s_0 = format.z2o_1.j();
            while (_iterator__ex2g4s_0.k()) {
              var element_0 = _iterator__ex2g4s_0.l();
              basicFormats$_anonymous_$rec_hkf0lf($this_buildList, element_0);
            }
          } else {
            if (format instanceof OptionalFormatStructure) {
              basicFormats$_anonymous_$rec_hkf0lf($this_buildList, format.u2o_1);
            }
          }
        }
      }
    }
  }
}
function conjunctionPredicate(predicates) {
  return predicates.p() ? Truth_instance : predicates.m() === 1 ? single(predicates) : new ConjunctionPredicate(predicates);
}
function ComparisonPredicate(expectedValue, getter) {
  this.a2p_1 = expectedValue;
  this.b2p_1 = getter;
}
protoOf(ComparisonPredicate).w2o = function (value) {
  return equals(this.b2p_1(value), this.a2p_1);
};
function Truth() {
}
protoOf(Truth).x2o = function (value) {
  return true;
};
protoOf(Truth).w2o = function (value) {
  return this.x2o((value == null ? true : !(value == null)) ? value : THROW_CCE());
};
var Truth_instance;
function Truth_getInstance() {
  return Truth_instance;
}
function ConjunctionPredicate(predicates) {
  this.c2p_1 = predicates;
}
protoOf(ConjunctionPredicate).w2o = function (value) {
  var tmp0 = this.c2p_1;
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.p();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!element.w2o(value)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
function FormatterStructure() {
}
function SpacePaddedFormatter(formatter, padding) {
  this.e2p_1 = formatter;
  this.f2p_1 = padding;
}
protoOf(SpacePaddedFormatter).d2p = function (obj, builder, minusNotRequired) {
  // Inline function 'kotlin.let' call
  var it = StringBuilder_init_$Create$();
  this.e2p_1.d2p(obj, it, minusNotRequired);
  var string = it.toString();
  // Inline function 'kotlin.repeat' call
  var times = this.f2p_1 - string.length | 0;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      builder.c8(_Char___init__impl__6a9atx(32));
    }
     while (inductionVariable < times);
  builder.f(string);
};
function SignedFormatter(formatter, allSubFormatsNegative, alwaysOutputSign) {
  this.g2p_1 = formatter;
  this.h2p_1 = allSubFormatsNegative;
  this.i2p_1 = alwaysOutputSign;
}
protoOf(SignedFormatter).d2p = function (obj, builder, minusNotRequired) {
  var tmp;
  if (!minusNotRequired && this.h2p_1(obj)) {
    tmp = _Char___init__impl__6a9atx(45);
  } else if (this.i2p_1) {
    tmp = _Char___init__impl__6a9atx(43);
  } else {
    tmp = null;
  }
  var sign = tmp;
  var tmp_0 = sign;
  if ((tmp_0 == null ? null : new Char(tmp_0)) == null)
    null;
  else {
    var tmp_1 = sign;
    // Inline function 'kotlin.let' call
    var it = (tmp_1 == null ? null : new Char(tmp_1)).i1_1;
    builder.c8(it);
  }
  var tmp_2;
  if (minusNotRequired) {
    tmp_2 = true;
  } else {
    var tmp_3 = sign;
    tmp_2 = equals(tmp_3 == null ? null : new Char(tmp_3), new Char(_Char___init__impl__6a9atx(45)));
  }
  this.g2p_1.d2p(obj, builder, tmp_2);
};
function ConditionalFormatter(formatters) {
  this.j2p_1 = formatters;
}
protoOf(ConditionalFormatter).d2p = function (obj, builder, minusNotRequired) {
  var tmp0_iterator = this.j2p_1.j();
  while (tmp0_iterator.k()) {
    var tmp1_loop_parameter = tmp0_iterator.l();
    var condition = tmp1_loop_parameter.mf();
    var formatter = tmp1_loop_parameter.nf();
    if (condition(obj)) {
      formatter.d2p(obj, builder, minusNotRequired);
      return Unit_instance;
    }
  }
};
function ConcatenatedFormatter(formatters) {
  this.k2p_1 = formatters;
}
protoOf(ConcatenatedFormatter).d2p = function (obj, builder, minusNotRequired) {
  var tmp0_iterator = this.k2p_1.j();
  while (tmp0_iterator.k()) {
    var formatter = tmp0_iterator.l();
    formatter.d2p(obj, builder, minusNotRequired);
  }
};
function SignedIntFormatterStructure(number, zeroPadding, outputPlusOnExceededWidth) {
  this.l2p_1 = number;
  this.m2p_1 = zeroPadding;
  this.n2p_1 = outputPlusOnExceededWidth;
  // Inline function 'kotlin.require' call
  if (!(this.m2p_1 >= 0)) {
    var message = 'The minimum number of digits (' + this.m2p_1 + ') is negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.m2p_1 <= 9)) {
    var message_0 = 'The minimum number of digits (' + this.m2p_1 + ') exceeds the length of an Int';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(SignedIntFormatterStructure).d2p = function (obj, builder, minusNotRequired) {
  var innerBuilder = StringBuilder_init_$Create$();
  // Inline function 'kotlin.let' call
  var it = this.l2p_1(obj);
  var number = minusNotRequired && it < 0 ? -it | 0 : it;
  if (!(this.n2p_1 == null) && number >= get_POWERS_OF_TEN()[this.n2p_1]) {
    innerBuilder.c8(_Char___init__impl__6a9atx(43));
  }
  // Inline function 'kotlin.math.absoluteValue' call
  if (abs(number) < get_POWERS_OF_TEN()[this.m2p_1 - 1 | 0]) {
    if (number >= 0) {
      innerBuilder.ic(number + get_POWERS_OF_TEN()[this.m2p_1] | 0).nc(0);
    } else {
      innerBuilder.ic(number - get_POWERS_OF_TEN()[this.m2p_1] | 0).nc(1);
    }
  } else {
    innerBuilder.ic(number);
  }
  builder.f(innerBuilder);
};
function UnsignedIntFormatterStructure(number, zeroPadding) {
  this.o2p_1 = number;
  this.p2p_1 = zeroPadding;
  // Inline function 'kotlin.require' call
  if (!(this.p2p_1 >= 0)) {
    var message = 'The minimum number of digits (' + this.p2p_1 + ') is negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.p2p_1 <= 9)) {
    var message_0 = 'The minimum number of digits (' + this.p2p_1 + ') exceeds the length of an Int';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(UnsignedIntFormatterStructure).d2p = function (obj, builder, minusNotRequired) {
  var num = this.o2p_1(obj);
  var numberStr = num.toString();
  // Inline function 'kotlin.repeat' call
  var times = this.p2p_1 - numberStr.length | 0;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      builder.c8(_Char___init__impl__6a9atx(48));
    }
     while (inductionVariable < times);
  builder.f(numberStr);
};
function StringFormatterStructure(string) {
  this.q2p_1 = string;
}
protoOf(StringFormatterStructure).d2p = function (obj, builder, minusNotRequired) {
  builder.f(this.q2p_1(obj));
};
function DecimalFractionFormatterStructure(number, minDigits, maxDigits, zerosToAdd) {
  this.r2p_1 = number;
  this.s2p_1 = minDigits;
  this.t2p_1 = maxDigits;
  this.u2p_1 = zerosToAdd;
  var containsArg = this.s2p_1;
  // Inline function 'kotlin.require' call
  if (!(1 <= containsArg ? containsArg <= 9 : false)) {
    var message = 'The minimum number of digits (' + this.s2p_1 + ') is not in range 1..9';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var containsLower = this.s2p_1;
  var containsArg_0 = this.t2p_1;
  // Inline function 'kotlin.require' call
  if (!(containsLower <= containsArg_0 ? containsArg_0 <= 9 : false)) {
    var message_0 = 'The maximum number of digits (' + this.t2p_1 + ') is not in range ' + this.s2p_1 + '..9';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(DecimalFractionFormatterStructure).d2p = function (obj, builder, minusNotRequired) {
  var number = this.r2p_1(obj);
  var numberWithRequiredPrecision = number.b2l(this.t2p_1);
  var zerosToStrip = 0;
  while (this.t2p_1 > (this.s2p_1 + zerosToStrip | 0) && (numberWithRequiredPrecision % get_POWERS_OF_TEN()[zerosToStrip + 1 | 0] | 0) === 0) {
    zerosToStrip = zerosToStrip + 1 | 0;
  }
  var zerosToAddBack = this.u2p_1.o((this.t2p_1 - zerosToStrip | 0) - 1 | 0);
  if (zerosToStrip >= zerosToAddBack)
    zerosToStrip = zerosToStrip - zerosToAddBack | 0;
  var digitsToOutput = this.t2p_1 - zerosToStrip | 0;
  var numberToOutput = numberWithRequiredPrecision / get_POWERS_OF_TEN()[zerosToStrip] | 0;
  // Inline function 'kotlin.text.substring' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = (numberToOutput + get_POWERS_OF_TEN()[digitsToOutput] | 0).toString().substring(1);
  builder.f(tmp$ret$1);
};
function ConstantStringFormatterStructure(string) {
  this.v2p_1 = string;
}
protoOf(ConstantStringFormatterStructure).d2p = function (obj, builder, minusNotRequired) {
  builder.f(this.v2p_1);
};
function FractionPartConsumer(minLength, maxLength, setter, name) {
  NumberConsumer.call(this, minLength === maxLength ? minLength : null, name);
  this.y2p_1 = minLength;
  this.z2p_1 = maxLength;
  this.a2q_1 = setter;
  var containsArg = this.y2p_1;
  // Inline function 'kotlin.require' call
  if (!(1 <= containsArg ? containsArg <= 9 : false)) {
    var message = 'Invalid minimum length ' + this.y2p_1 + ' for field ' + this.c2q_1 + ': expected 1..9';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var containsLower = this.y2p_1;
  var containsArg_0 = this.z2p_1;
  // Inline function 'kotlin.require' call
  if (!(containsLower <= containsArg_0 ? containsArg_0 <= 9 : false)) {
    var message_0 = 'Invalid maximum length ' + this.z2p_1 + ' for field ' + this.c2q_1 + ': expected ' + this.y2p_1 + '..9';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(FractionPartConsumer).d2q = function (storage, input, start, end) {
  return (end - start | 0) < this.y2p_1 ? new TooFewDigits(this.y2p_1) : (end - start | 0) > this.z2p_1 ? new TooManyDigits(this.z2p_1) : setWithoutReassigning(this.a2q_1, storage, new DecimalFraction(parseAsciiInt(input, start, end), end - start | 0));
};
function ConstantNumberConsumer(expected) {
  NumberConsumer.call(this, expected.length, 'the predefined string ' + expected);
  this.g2q_1 = expected;
}
protoOf(ConstantNumberConsumer).d2q = function (storage, input, start, end) {
  var tmp;
  // Inline function 'kotlin.text.substring' call
  if (toString(charSequenceSubSequence(input, start, end)) === this.g2q_1) {
    tmp = null;
  } else {
    tmp = new WrongConstant(this.g2q_1);
  }
  return tmp;
};
function NumberConsumer(length, whatThisExpects) {
  this.b2q_1 = length;
  this.c2q_1 = whatThisExpects;
}
protoOf(NumberConsumer).a = function () {
  return this.b2q_1;
};
function ExpectedInt() {
}
protoOf(ExpectedInt).h2q = function () {
  return 'expected an Int value';
};
var ExpectedInt_instance;
function ExpectedInt_getInstance() {
  return ExpectedInt_instance;
}
function TooManyDigits(maxDigits) {
  this.i2q_1 = maxDigits;
}
protoOf(TooManyDigits).h2q = function () {
  return 'expected at most ' + this.i2q_1 + ' digits';
};
function TooFewDigits(minDigits) {
  this.j2q_1 = minDigits;
}
protoOf(TooFewDigits).h2q = function () {
  return 'expected at least ' + this.j2q_1 + ' digits';
};
function WrongConstant(expected) {
  this.k2q_1 = expected;
}
protoOf(WrongConstant).h2q = function () {
  return "expected '" + this.k2q_1 + "'";
};
function Conflicting(conflicting) {
  this.l2q_1 = conflicting;
}
protoOf(Conflicting).h2q = function () {
  return "attempted to overwrite the existing value '" + toString(this.l2q_1) + "'";
};
function setWithoutReassigning(_this__u8e3s4, receiver, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.b2o(receiver, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var conflictingValue = tmp;
  return new Conflicting(conflictingValue);
}
function parseAsciiInt(_this__u8e3s4, start, end) {
  var result = 0;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var digit = charSequenceGet(_this__u8e3s4, i);
      result = imul(result, 10) + asciiDigitToInt(digit) | 0;
    }
     while (inductionVariable < end);
  return result;
}
function UnsignedIntConsumer(minLength, maxLength, setter, name, multiplyByMinus1) {
  multiplyByMinus1 = multiplyByMinus1 === VOID ? false : multiplyByMinus1;
  NumberConsumer.call(this, minLength == maxLength ? minLength : null, name);
  this.o2q_1 = minLength;
  this.p2q_1 = maxLength;
  this.q2q_1 = setter;
  this.r2q_1 = multiplyByMinus1;
  // Inline function 'kotlin.require' call
  if (!(this.a() == null || numberRangeToNumber(1, 9).ei(this.a()))) {
    var message = 'Invalid length for field ' + this.c2q_1 + ': ' + this.a();
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(UnsignedIntConsumer).d2q = function (storage, input, start, end) {
  var tmp;
  if (!(this.p2q_1 == null) && (end - start | 0) > this.p2q_1) {
    tmp = new TooManyDigits(this.p2q_1);
  } else if (!(this.o2q_1 == null) && (end - start | 0) < this.o2q_1) {
    tmp = new TooFewDigits(this.o2q_1);
  } else {
    var result = parseAsciiIntOrNull(input, start, end);
    tmp = result == null ? ExpectedInt_instance : setWithoutReassigning(this.q2q_1, storage, this.r2q_1 ? -result | 0 : result);
  }
  return tmp;
};
function parseAsciiIntOrNull(_this__u8e3s4, start, end) {
  var result = 0;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var digit = charSequenceGet(_this__u8e3s4, i);
      result = imul(result, 10) + asciiDigitToInt(digit) | 0;
      if (result < 0)
        return null;
    }
     while (inductionVariable < end);
  return result;
}
function ParseError(position, message) {
  this.s2q_1 = position;
  this.t2q_1 = message;
}
function _ParseResult___init__impl__gvz3cn(value) {
  return value;
}
function _ParseResult___get_value__impl__86mnxf($this) {
  return $this;
}
function Companion_13() {
}
protoOf(Companion_13).u2q = function (indexOfNextUnparsed) {
  return _ParseResult___init__impl__gvz3cn(indexOfNextUnparsed);
};
protoOf(Companion_13).v2q = function (position, message) {
  return _ParseResult___init__impl__gvz3cn(new ParseError(position, message));
};
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
function _Parser___init__impl__gdyfby(commands) {
  return commands;
}
function _get_commands__a20n1($this) {
  return $this;
}
function Parser__match_impl_nzt83d($this, input, initialContainer, startIndex) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var errors = ArrayList_init_$Create$_0();
  // Inline function 'kotlinx.datetime.internal.format.parser.Parser.parse' call
  var parseOptions = mutableListOf([new ParserState(initialContainer, _get_commands__a20n1($this), startIndex)]);
  iterate_over_alternatives: while (true) {
    var tmp0_elvis_lhs = removeLastOrNull(parseOptions);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break iterate_over_alternatives;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var state = tmp;
    var output = state.w2q_1.y2e();
    var inputPosition = state.y2q_1;
    var parserStructure = state.x2q_1;
    // Inline function 'kotlin.run' call
    $l$block: {
      var inductionVariable = 0;
      var last = parserStructure.a2r_1.m() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var ix = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.datetime.internal.format.parser.ParseResult.match' call
          var this_0 = parserStructure.a2r_1.o(ix).c2r(output, input, inputPosition);
          var tmp0_subject = _ParseResult___get_value__impl__86mnxf(this_0);
          if (typeof tmp0_subject === 'number') {
            inputPosition = _ParseResult___get_value__impl__86mnxf(this_0);
          } else {
            if (tmp0_subject instanceof ParseError) {
              var it = _ParseResult___get_value__impl__86mnxf(this_0);
              errors.e(it);
              break $l$block;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Unexpected parse result: ' + toString(_ParseResult___get_value__impl__86mnxf(this_0));
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
         while (inductionVariable <= last);
      if (parserStructure.b2r_1.p()) {
        if (false || inputPosition === charSequenceLength(input)) {
          return output;
        } else {
          var tmp_0 = inputPosition;
          var it_0 = new ParseError(tmp_0, Parser$match$lambda);
          errors.e(it_0);
        }
      } else {
        var inductionVariable_0 = parserStructure.b2r_1.m() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var ix_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            parseOptions.e(new ParserState(output, parserStructure.b2r_1.o(ix_0), inputPosition));
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  // Inline function 'kotlin.collections.sortByDescending' call
  if (errors.m() > 1) {
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_1 = Parser$match$lambda_0;
    var tmp$ret$8 = new sam$kotlin_Comparator$0(tmp_1);
    sortWith(errors, tmp$ret$8);
  }
  throw new ParseException(errors);
}
function Parser__match$default_impl_x2xlti($this, input, initialContainer, startIndex, $super) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  var tmp;
  if ($super === VOID) {
    tmp = Parser__match_impl_nzt83d($this, input, initialContainer, startIndex);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new Parser(tmp_0)).d2r.call(new Parser($this), input, initialContainer, startIndex);
  }
  return tmp;
}
function ParserState(output, parserStructure, inputPosition) {
  this.w2q_1 = output;
  this.x2q_1 = parserStructure;
  this.y2q_1 = inputPosition;
}
function Parser__toString_impl_x33iea($this) {
  return 'Parser(commands=' + $this.toString() + ')';
}
function Parser__hashCode_impl_bbxllf($this) {
  return hashCode($this);
}
function Parser__equals_impl_djxokv($this, other) {
  if (!(other instanceof Parser))
    return false;
  var tmp0_other_with_cast = other instanceof Parser ? other.z2q_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function sam$kotlin_Comparator$0(function_0) {
  this.e2r_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).vc = function (a, b) {
  return this.e2r_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.vc(a, b);
};
protoOf(sam$kotlin_Comparator$0).k3 = function () {
  return this.e2r_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.k3(), other.k3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.k3());
};
function Parser$match$lambda() {
  return 'There is more input to consume';
}
function Parser$match$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.s2q_1;
  var tmp$ret$1 = a.s2q_1;
  return compareValues(tmp, tmp$ret$1);
}
function Parser(commands) {
  this.z2q_1 = commands;
}
protoOf(Parser).toString = function () {
  return Parser__toString_impl_x33iea(this.z2q_1);
};
protoOf(Parser).hashCode = function () {
  return Parser__hashCode_impl_bbxllf(this.z2q_1);
};
protoOf(Parser).equals = function (other) {
  return Parser__equals_impl_djxokv(this.z2q_1, other);
};
function ParserStructure(operations, followedBy) {
  this.a2r_1 = operations;
  this.b2r_1 = followedBy;
}
protoOf(ParserStructure).toString = function () {
  return joinToString(this.a2r_1, ', ') + '(' + joinToString(this.b2r_1, ';') + ')';
};
function ParseException(errors) {
  Exception_init_$Init$(formatError(errors), this);
  captureStack(this, ParseException);
}
function concat(_this__u8e3s4) {
  // Inline function 'kotlin.collections.foldRight' call
  var accumulator = new ParserStructure(emptyList(), emptyList());
  if (!_this__u8e3s4.p()) {
    var iterator = _this__u8e3s4.q(_this__u8e3s4.m());
    while (iterator.m4()) {
      var tmp2 = iterator.n4();
      var acc = accumulator;
      accumulator = concat$append(tmp2, acc);
    }
  }
  var naiveParser = accumulator;
  return concat$simplify(naiveParser, emptyList());
}
function formatError(errors) {
  if (errors.m() === 1) {
    return 'Position ' + errors.o(0).s2q_1 + ': ' + errors.o(0).t2q_1();
  }
  var averageMessageLength = 33;
  var tmp0_buffer = StringBuilder_init_$Create$_0(imul(averageMessageLength, errors.m()));
  return joinTo(errors, tmp0_buffer, ', ', 'Errors: ', VOID, VOID, VOID, formatError$lambda).toString();
}
function concat$append(_this__u8e3s4, other) {
  var tmp;
  if (_this__u8e3s4.b2r_1.p()) {
    tmp = new ParserStructure(plus(_this__u8e3s4.a2r_1, other.a2r_1), other.b2r_1);
  } else {
    // Inline function 'kotlin.collections.map' call
    var this_0 = _this__u8e3s4.b2r_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.j();
    while (_iterator__ex2g4s.k()) {
      var item = _iterator__ex2g4s.l();
      var tmp$ret$0 = concat$append(item, other);
      destination.e(tmp$ret$0);
    }
    tmp = new ParserStructure(_this__u8e3s4.a2r_1, destination);
  }
  return tmp;
}
function concat$simplify(_this__u8e3s4, unconditionalModifications) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var newOperations = ArrayList_init_$Create$_0();
  var currentNumberSpan = null;
  var unconditionalModificationsForTails = toMutableList(unconditionalModifications);
  var tmp0_iterator = _this__u8e3s4.a2r_1.j();
  while (tmp0_iterator.k()) {
    var op = tmp0_iterator.l();
    if (op instanceof NumberSpanParserOperation) {
      if (!(currentNumberSpan == null)) {
        currentNumberSpan.n(op.f2r_1);
      } else {
        currentNumberSpan = toMutableList(op.f2r_1);
      }
    } else {
      if (op instanceof UnconditionalModification) {
        unconditionalModificationsForTails.e(op);
      } else {
        if (!(currentNumberSpan == null)) {
          newOperations.e(new NumberSpanParserOperation(currentNumberSpan));
          currentNumberSpan = null;
        }
        newOperations.e(op);
      }
    }
  }
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = _this__u8e3s4.b2r_1;
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var simplified = concat$simplify(element, unconditionalModificationsForTails);
    var tmp;
    if (simplified.a2r_1.p()) {
      // Inline function 'kotlin.collections.ifEmpty' call
      var this_0 = simplified.b2r_1;
      var tmp_0;
      if (this_0.p()) {
        tmp_0 = listOf_0(simplified);
      } else {
        tmp_0 = this_0;
      }
      tmp = tmp_0;
    } else {
      tmp = listOf_0(simplified);
    }
    var list = tmp;
    addAll(destination, list);
  }
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_1;
  if (destination.p()) {
    tmp_1 = listOf_0(new ParserStructure(unconditionalModificationsForTails, emptyList()));
  } else {
    tmp_1 = destination;
  }
  var mergedTails = tmp_1;
  var tmp_2;
  if (currentNumberSpan == null) {
    tmp_2 = new ParserStructure(newOperations, mergedTails);
  } else {
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_3;
      if (isInterface(mergedTails, Collection)) {
        tmp_3 = mergedTails.p();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$8 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = mergedTails.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        var tmp0_safe_receiver = firstOrNull(element_0.a2r_1);
        var tmp_4;
        if (tmp0_safe_receiver == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_4 = tmp0_safe_receiver instanceof NumberSpanParserOperation;
        }
        if (tmp_4 === true) {
          tmp$ret$8 = false;
          break $l$block_0;
        }
      }
      tmp$ret$8 = true;
    }
    if (tmp$ret$8) {
      newOperations.e(new NumberSpanParserOperation(currentNumberSpan));
      tmp_2 = new ParserStructure(newOperations, mergedTails);
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(mergedTails, 10));
      var _iterator__ex2g4s_1 = mergedTails.j();
      while (_iterator__ex2g4s_1.k()) {
        var item = _iterator__ex2g4s_1.l();
        var firstOperation = firstOrNull(item.a2r_1);
        var tmp_5;
        if (firstOperation instanceof NumberSpanParserOperation) {
          tmp_5 = new ParserStructure(plus(listOf_0(new NumberSpanParserOperation(plus(currentNumberSpan, firstOperation.f2r_1))), drop(item.a2r_1, 1)), item.b2r_1);
        } else {
          if (firstOperation == null) {
            tmp_5 = new ParserStructure(listOf_0(new NumberSpanParserOperation(currentNumberSpan)), item.b2r_1);
          } else {
            tmp_5 = new ParserStructure(plus(listOf_0(new NumberSpanParserOperation(currentNumberSpan)), item.a2r_1), item.b2r_1);
          }
        }
        var tmp$ret$12 = tmp_5;
        destination_0.e(tmp$ret$12);
      }
      var newTails = destination_0;
      tmp_2 = new ParserStructure(newOperations, newTails);
    }
  }
  return tmp_2;
}
function formatError$lambda(it) {
  return 'position ' + it.s2q_1 + ": '" + it.t2q_1() + "'";
}
function SignedIntParser(minDigits, maxDigits, spacePadding, setter, name, plusOnExceedsWidth) {
  var parsers = mutableListOf([spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, true)]);
  if (!(plusOnExceedsWidth == null)) {
    parsers.e(spaceAndZeroPaddedUnsignedInt(minDigits, plusOnExceedsWidth, spacePadding, setter, name));
    parsers.e(new ParserStructure(listOf([new PlainStringParserOperation('+'), new NumberSpanParserOperation(listOf_0(new UnsignedIntConsumer(plusOnExceedsWidth + 1 | 0, maxDigits, setter, name, false)))]), emptyList()));
  } else {
    parsers.e(spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name));
  }
  return new ParserStructure(emptyList(), parsers);
}
function spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, withMinus) {
  withMinus = withMinus === VOID ? false : withMinus;
  var minNumberLength = (minDigits == null ? 1 : minDigits) + (withMinus ? 1 : 0) | 0;
  var tmp;
  if (maxDigits == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = withMinus ? maxDigits + 1 | 0 : maxDigits;
  }
  var tmp2_elvis_lhs = tmp;
  var maxNumberLength = tmp2_elvis_lhs == null ? 2147483647 : tmp2_elvis_lhs;
  var spacePadding_0 = spacePadding == null ? 0 : spacePadding;
  // Inline function 'kotlin.comparisons.minOf' call
  var maxPaddedNumberLength = Math.min(maxNumberLength, spacePadding_0);
  if (minNumberLength >= maxPaddedNumberLength)
    return spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, maxNumberLength);
  var accumulated = spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, minNumberLength);
  var inductionVariable = minNumberLength;
  if (inductionVariable < maxPaddedNumberLength)
    do {
      var accumulatedWidth = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      accumulated = new ParserStructure(emptyList(), listOf([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, accumulatedWidth + 1 | 0, accumulatedWidth + 1 | 0), concat(listOf([new ParserStructure(listOf_0(new PlainStringParserOperation(' ')), emptyList()), accumulated]))]));
    }
     while (inductionVariable < maxPaddedNumberLength);
  var tmp_0;
  if (spacePadding_0 > maxNumberLength) {
    var prepadding = new PlainStringParserOperation(repeat(' ', spacePadding_0 - maxNumberLength | 0));
    tmp_0 = concat(listOf([new ParserStructure(listOf_0(prepadding), emptyList()), accumulated]));
  } else if (spacePadding_0 === maxNumberLength) {
    tmp_0 = accumulated;
  } else {
    var r = new ParserStructure(emptyList(), listOf([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, spacePadding_0 + 1 | 0, maxNumberLength), accumulated]));
    tmp_0 = r;
  }
  return tmp_0;
}
function TrieNode(children, isTerminal) {
  var tmp;
  if (children === VOID) {
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp = ArrayList_init_$Create$_0();
  } else {
    tmp = children;
  }
  children = tmp;
  isTerminal = isTerminal === VOID ? false : isTerminal;
  this.i2r_1 = children;
  this.j2r_1 = isTerminal;
}
function sam$kotlin_Comparator$0_0(function_0) {
  this.k2r_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_0).vc = function (a, b) {
  return this.k2r_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
  return this.vc(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).k3 = function () {
  return this.k2r_1;
};
protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.k3(), other.k3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
  return hashCode(this.k3());
};
function _init_$reduceTrie(trie) {
  var tmp0_iterator = trie.i2r_1.j();
  while (tmp0_iterator.k()) {
    var child = tmp0_iterator.l().nf();
    _init_$reduceTrie(child);
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var newChildren = ArrayList_init_$Create$_0();
  var tmp2_iterator = trie.i2r_1.j();
  while (tmp2_iterator.k()) {
    var tmp3_loop_parameter = tmp2_iterator.l();
    var key = tmp3_loop_parameter.mf();
    var child_0 = tmp3_loop_parameter.nf();
    if (!child_0.j2r_1 && child_0.i2r_1.m() === 1) {
      var tmp4_container = single(child_0.i2r_1);
      var grandChildKey = tmp4_container.mf();
      var grandChild = tmp4_container.nf();
      newChildren.e(to(key + grandChildKey, grandChild));
    } else {
      newChildren.e(to(key, child_0));
    }
  }
  trie.i2r_1.d2();
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = StringSetParserOperation$reduceTrie$lambda;
  var tmp$ret$1 = new sam$kotlin_Comparator$0_0(tmp);
  var tmp$ret$2 = sortedWith(newChildren, tmp$ret$1);
  trie.i2r_1.n(tmp$ret$2);
}
function StringSetParserOperation$lambda($key) {
  return function (it) {
    var tmp$ret$0 = it.kf_1;
    return compareValues(tmp$ret$0, $key);
  };
}
function StringSetParserOperation$consume$lambda(this$0, $input, $startIndex, $index) {
  return function () {
    var tmp0 = $input;
    var tmp1 = $startIndex;
    // Inline function 'kotlin.text.substring' call
    var endIndex = $index._v;
    var tmp$ret$0 = toString(charSequenceSubSequence(tmp0, tmp1, endIndex));
    return 'Expected ' + this$0.m2r_1 + ' but got ' + tmp$ret$0;
  };
}
function StringSetParserOperation$reduceTrie$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.kf_1;
  var tmp$ret$1 = b.kf_1;
  return compareValues(tmp, tmp$ret$1);
}
function StringSetParserOperation(strings, setter, whatThisExpects) {
  this.l2r_1 = setter;
  this.m2r_1 = whatThisExpects;
  this.n2r_1 = new TrieNode();
  var tmp0_iterator = strings.j();
  while (tmp0_iterator.k()) {
    var string = tmp0_iterator.l();
    // Inline function 'kotlin.text.isNotEmpty' call
    // Inline function 'kotlin.require' call
    if (!(charSequenceLength(string) > 0)) {
      var message = 'Found an empty string in ' + this.m2r_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var node = this.n2r_1;
    var inductionVariable = 0;
    var last = string.length;
    while (inductionVariable < last) {
      var char = charSequenceGet(string, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp2 = node.i2r_1;
      // Inline function 'kotlin.collections.binarySearchBy' call
      var key = toString_0(char);
      var toIndex = tmp2.m();
      var searchResult = binarySearch(tmp2, 0, toIndex, StringSetParserOperation$lambda(key));
      var tmp;
      if (searchResult < 0) {
        // Inline function 'kotlin.also' call
        var this_0 = new TrieNode();
        node.i2r_1.f2((-searchResult | 0) - 1 | 0, to(toString_0(char), this_0));
        tmp = this_0;
      } else {
        tmp = node.i2r_1.o(searchResult).lf_1;
      }
      node = tmp;
    }
    // Inline function 'kotlin.require' call
    if (!!node.j2r_1) {
      var message_0 = "The string '" + string + "' was passed several times";
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    node.j2r_1 = true;
  }
  _init_$reduceTrie(this.n2r_1);
}
protoOf(StringSetParserOperation).c2r = function (storage, input, startIndex) {
  var node = this.n2r_1;
  var index = {_v: startIndex};
  var lastMatch = null;
  loop: while (index._v <= charSequenceLength(input)) {
    if (node.j2r_1)
      lastMatch = index._v;
    var tmp0_iterator = node.i2r_1.j();
    while (tmp0_iterator.k()) {
      var tmp1_loop_parameter = tmp0_iterator.l();
      var key = tmp1_loop_parameter.mf();
      var child = tmp1_loop_parameter.nf();
      if (startsWith(input, key, index._v)) {
        node = child;
        index._v = index._v + key.length | 0;
        continue loop;
      }
    }
    break loop;
  }
  var tmp;
  if (!(lastMatch == null)) {
    // Inline function 'kotlin.text.substring' call
    var endIndex = lastMatch;
    var tmp$ret$0 = toString(charSequenceSubSequence(input, startIndex, endIndex));
    tmp = setWithoutReassigning_0(this.l2r_1, storage, tmp$ret$0, startIndex, lastMatch);
  } else {
    var tmp_0 = Companion_instance_13;
    tmp = tmp_0.v2q(startIndex, StringSetParserOperation$consume$lambda(this, input, startIndex, index));
  }
  return tmp;
};
function _get_whatThisExpects__4pg11j($this) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.f2r_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var length = item.a();
    var tmp$ret$0 = (length == null ? 'at least one digit' : '' + length + ' digits') + (' for ' + item.c2q_1);
    destination.e(tmp$ret$0);
  }
  var consumerLengths = destination;
  var tmp;
  if ($this.h2r_1) {
    tmp = 'a number with at least ' + $this.g2r_1 + ' digits: ' + toString(consumerLengths);
  } else {
    tmp = 'a number with exactly ' + $this.g2r_1 + ' digits: ' + toString(consumerLengths);
  }
  return tmp;
}
function NumberSpanParserOperation$consume$lambda(this$0) {
  return function () {
    return 'Unexpected end of input: yet to parse ' + _get_whatThisExpects__4pg11j(this$0);
  };
}
function NumberSpanParserOperation$consume$lambda_0($digitsInRow, this$0) {
  return function () {
    return 'Only found ' + $digitsInRow._v + ' digits in a row, but need to parse ' + _get_whatThisExpects__4pg11j(this$0);
  };
}
function NumberSpanParserOperation$consume$lambda_1($numberString, this$0, $i, $error) {
  return function () {
    return "Can not interpret the string '" + $numberString + "' as " + this$0.f2r_1.o($i).c2q_1 + ': ' + $error.h2q();
  };
}
function NumberSpanParserOperation(consumers) {
  this.f2r_1 = consumers;
  var tmp = this;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = this.f2r_1.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp_0 = sum;
    var tmp0_elvis_lhs = element.a();
    sum = tmp_0 + (tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs) | 0;
  }
  tmp.g2r_1 = sum;
  var tmp_1 = this;
  var tmp0 = this.f2r_1;
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_2;
    if (isInterface(tmp0, Collection)) {
      tmp_2 = tmp0.p();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp$ret$2 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = tmp0.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (element_0.a() == null) {
        tmp$ret$2 = true;
        break $l$block_0;
      }
    }
    tmp$ret$2 = false;
  }
  tmp_1.h2r_1 = tmp$ret$2;
  var tmp0_0 = this.f2r_1;
  var tmp$ret$4;
  $l$block_2: {
    // Inline function 'kotlin.collections.all' call
    var tmp_3;
    if (isInterface(tmp0_0, Collection)) {
      tmp_3 = tmp0_0.p();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp$ret$4 = true;
      break $l$block_2;
    }
    var _iterator__ex2g4s_1 = tmp0_0.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_1 = _iterator__ex2g4s_1.l();
      var tmp0_elvis_lhs_0 = element_1.a();
      if (!((tmp0_elvis_lhs_0 == null ? 2147483647 : tmp0_elvis_lhs_0) > 0)) {
        tmp$ret$4 = false;
        break $l$block_2;
      }
    }
    tmp$ret$4 = true;
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!tmp$ret$4) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp3 = this.f2r_1;
  var tmp$ret$9;
  $l$block_3: {
    // Inline function 'kotlin.collections.count' call
    var tmp_4;
    if (isInterface(tmp3, Collection)) {
      tmp_4 = tmp3.p();
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp$ret$9 = 0;
      break $l$block_3;
    }
    var count = 0;
    var _iterator__ex2g4s_2 = tmp3.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_2 = _iterator__ex2g4s_2.l();
      if (element_2.a() == null) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$9 = count;
  }
  // Inline function 'kotlin.require' call
  if (!(tmp$ret$9 <= 1)) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0_1 = this.f2r_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_3 = tmp0_1.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_3 = _iterator__ex2g4s_3.l();
      if (element_3.a() == null) {
        destination.e(element_3);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_4 = destination.j();
    while (_iterator__ex2g4s_4.k()) {
      var item = _iterator__ex2g4s_4.l();
      var tmp$ret$14 = item.c2q_1;
      destination_0.e(tmp$ret$14);
    }
    var fieldNames = destination_0;
    var message_0 = 'At most one variable-length numeric field in a row is allowed, but got several: ' + toString(fieldNames) + '. ' + 'Parsing is undefined: for example, with variable-length month number ' + "and variable-length day of month, '111' can be parsed as Jan 11th or Nov 1st.";
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(NumberSpanParserOperation).c2r = function (storage, input, startIndex) {
  if ((startIndex + this.g2r_1 | 0) > charSequenceLength(input)) {
    var tmp = Companion_instance_13;
    return tmp.v2q(startIndex, NumberSpanParserOperation$consume$lambda(this));
  }
  var digitsInRow = {_v: 0};
  while ((startIndex + digitsInRow._v | 0) < charSequenceLength(input) && isAsciiDigit(charSequenceGet(input, startIndex + digitsInRow._v | 0))) {
    digitsInRow._v = digitsInRow._v + 1 | 0;
    digitsInRow._v;
  }
  if (digitsInRow._v < this.g2r_1) {
    var tmp_0 = Companion_instance_13;
    return tmp_0.v2q(startIndex, NumberSpanParserOperation$consume$lambda_0(digitsInRow, this));
  }
  var index = startIndex;
  var inductionVariable = 0;
  var last = this.f2r_1.m() - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp1_elvis_lhs = this.f2r_1.o(i).a();
      var length = tmp1_elvis_lhs == null ? (digitsInRow._v - this.g2r_1 | 0) + 1 | 0 : tmp1_elvis_lhs;
      var error = this.f2r_1.o(i).d2q(storage, input, index, index + length | 0);
      if (!(error == null)) {
        var tmp1 = index;
        // Inline function 'kotlin.text.substring' call
        var endIndex = index + length | 0;
        var numberString = toString(charSequenceSubSequence(input, tmp1, endIndex));
        var tmp_1 = Companion_instance_13;
        var tmp_2 = index;
        return tmp_1.v2q(tmp_2, NumberSpanParserOperation$consume$lambda_1(numberString, this, i, error));
      }
      index = index + length | 0;
    }
     while (inductionVariable <= last);
  return Companion_instance_13.u2q(index);
};
protoOf(NumberSpanParserOperation).toString = function () {
  return _get_whatThisExpects__4pg11j(this);
};
function PlainStringParserOperation$consume$lambda(this$0) {
  return function () {
    return "Unexpected end of input: yet to parse '" + this$0.o2r_1 + "'";
  };
}
function PlainStringParserOperation$consume$lambda_0(this$0, $input, $startIndex, $i) {
  return function () {
    var tmp0 = $input;
    var tmp1 = $startIndex;
    // Inline function 'kotlin.text.substring' call
    var endIndex = ($startIndex + $i | 0) + 1 | 0;
    var tmp$ret$0 = toString(charSequenceSubSequence(tmp0, tmp1, endIndex));
    return 'Expected ' + this$0.o2r_1 + ' but got ' + tmp$ret$0;
  };
}
function PlainStringParserOperation(string) {
  this.o2r_1 = string;
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = this.o2r_1;
  // Inline function 'kotlin.require' call
  if (!(charSequenceLength(this_0) > 0)) {
    var message = 'Empty string is not allowed';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!isAsciiDigit(charSequenceGet(this.o2r_1, 0))) {
    var message_0 = "String '" + this.o2r_1 + "' starts with a digit";
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!!isAsciiDigit(charSequenceGet(this.o2r_1, this.o2r_1.length - 1 | 0))) {
    var message_1 = "String '" + this.o2r_1 + "' ends with a digit";
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
}
protoOf(PlainStringParserOperation).c2r = function (storage, input, startIndex) {
  if ((startIndex + this.o2r_1.length | 0) > charSequenceLength(input)) {
    var tmp = Companion_instance_13;
    return tmp.v2q(startIndex, PlainStringParserOperation$consume$lambda(this));
  }
  var inductionVariable = 0;
  var last = charSequenceLength(this.o2r_1) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charSequenceGet(input, startIndex + i | 0) === charSequenceGet(this.o2r_1, i))) {
        var tmp_0 = Companion_instance_13;
        return tmp_0.v2q(startIndex, PlainStringParserOperation$consume$lambda_0(this, input, startIndex, i));
      }
    }
     while (inductionVariable <= last);
  return Companion_instance_13.u2q(startIndex + this.o2r_1.length | 0);
};
protoOf(PlainStringParserOperation).toString = function () {
  return "'" + this.o2r_1 + "'";
};
function SignParser$consume$lambda(this$0, $char) {
  return function () {
    return 'Expected ' + this$0.r2r_1 + ' but got ' + toString_0($char);
  };
}
function SignParser(isNegativeSetter, withPlusSign, whatThisExpects) {
  this.p2r_1 = isNegativeSetter;
  this.q2r_1 = withPlusSign;
  this.r2r_1 = whatThisExpects;
}
protoOf(SignParser).c2r = function (storage, input, startIndex) {
  if (startIndex >= charSequenceLength(input))
    return Companion_instance_13.u2q(startIndex);
  var char = charSequenceGet(input, startIndex);
  if (char === _Char___init__impl__6a9atx(45)) {
    this.p2r_1(storage, true);
    return Companion_instance_13.u2q(startIndex + 1 | 0);
  }
  if (char === _Char___init__impl__6a9atx(43) && this.q2r_1) {
    this.p2r_1(storage, false);
    return Companion_instance_13.u2q(startIndex + 1 | 0);
  }
  var tmp = Companion_instance_13;
  return tmp.v2q(startIndex, SignParser$consume$lambda(this, char));
};
protoOf(SignParser).toString = function () {
  return this.r2r_1;
};
function UnconditionalModification(operation) {
  this.s2r_1 = operation;
}
protoOf(UnconditionalModification).c2r = function (storage, input, startIndex) {
  this.s2r_1(storage);
  return Companion_instance_13.u2q(startIndex);
};
function setWithoutReassigning_0(_this__u8e3s4, receiver, value, position, nextIndex) {
  var conflictingValue = _this__u8e3s4.b2o(receiver, value);
  var tmp;
  if (conflictingValue === null) {
    tmp = Companion_instance_13.u2q(nextIndex);
  } else {
    var tmp_0 = Companion_instance_13;
    tmp = tmp_0.v2q(position, setWithoutReassigning$lambda(conflictingValue, value, _this__u8e3s4));
  }
  return tmp;
}
function spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths($withMinus, $setter, $name, minNumberLength, maxNumberLength) {
  // Inline function 'kotlin.check' call
  if (!(maxNumberLength >= (1 + ($withMinus ? 1 : 0) | 0))) {
    throw IllegalStateException_init_$Create$('Check failed.');
  }
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList_init_$Create$_0();
  if ($withMinus) {
    this_0.e(new PlainStringParserOperation('-'));
  }
  this_0.e(new NumberSpanParserOperation(listOf_0(new UnsignedIntConsumer(minNumberLength - ($withMinus ? 1 : 0) | 0, maxNumberLength - ($withMinus ? 1 : 0) | 0, $setter, $name, $withMinus))));
  var tmp$ret$4 = this_0.i5();
  return new ParserStructure(tmp$ret$4, emptyList());
}
function setWithoutReassigning$lambda($conflictingValue, $value, $this_setWithoutReassigning) {
  return function () {
    return "Attempting to assign conflicting values '" + toString_1($conflictingValue) + "' and '" + toString_1($value) + "' to field '" + $this_setWithoutReassigning.m1d() + "'";
  };
}
function get_POWERS_OF_TEN() {
  _init_properties_math_kt__tgcmt4();
  return POWERS_OF_TEN;
}
var POWERS_OF_TEN;
function DecimalFraction(fractionalPart, digits) {
  this.z2k_1 = fractionalPart;
  this.a2l_1 = digits;
  // Inline function 'kotlin.require' call
  if (!(this.a2l_1 >= 0)) {
    var message = 'Digits must be non-negative, but was ' + this.a2l_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(DecimalFraction).b2l = function (newDigits) {
  return newDigits === this.a2l_1 ? this.z2k_1 : newDigits > this.a2l_1 ? imul(this.z2k_1, get_POWERS_OF_TEN()[newDigits - this.a2l_1 | 0]) : this.z2k_1 / get_POWERS_OF_TEN()[this.a2l_1 - newDigits | 0] | 0;
};
protoOf(DecimalFraction).t2r = function (other) {
  var tmp0 = this.a2l_1;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = other.a2l_1;
  // Inline function 'kotlin.let' call
  var maxPrecision = Math.max(tmp0, b);
  return compareTo(this.b2l(maxPrecision), other.b2l(maxPrecision));
};
protoOf(DecimalFraction).d = function (other) {
  return this.t2r(other instanceof DecimalFraction ? other : THROW_CCE());
};
protoOf(DecimalFraction).equals = function (other) {
  var tmp;
  if (other instanceof DecimalFraction) {
    tmp = this.t2r(other) === 0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(DecimalFraction).toString = function () {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  var denominator = get_POWERS_OF_TEN()[this.a2l_1];
  this_0.ic(this.z2k_1 / denominator | 0);
  this_0.c8(_Char___init__impl__6a9atx(46));
  this_0.b8(removePrefix((denominator + (this.z2k_1 % denominator | 0) | 0).toString(), '1'));
  return this_0.toString();
};
protoOf(DecimalFraction).hashCode = function () {
  throw UnsupportedOperationException_init_$Create$('DecimalFraction is not supposed to be used as a hash key');
};
var properties_initialized_math_kt_amm9wq;
function _init_properties_math_kt__tgcmt4() {
  if (!properties_initialized_math_kt_amm9wq) {
    properties_initialized_math_kt_amm9wq = true;
    // Inline function 'kotlin.intArrayOf' call
    POWERS_OF_TEN = new Int32Array([1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000]);
  }
}
function isAsciiDigit(_this__u8e3s4) {
  return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
}
function asciiDigitToInt(_this__u8e3s4) {
  return Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(48));
}
function removeLeadingZerosFromLongYearFormLocalDate(input) {
  return removeLeadingZerosFromLongYearForm(toString(input), 6);
}
function removeLeadingZerosFromLongYearFormLocalDateTime(input) {
  return removeLeadingZerosFromLongYearForm(toString(input), 12);
}
function removeLeadingZerosFromLongYearForm(input, minStringLengthAfterYear) {
  var failingYearStringLength = 12;
  if (input.length < (failingYearStringLength + minStringLengthAfterYear | 0) || !contains('+-', charSequenceGet(input, 0)))
    return input;
  var yearEnd = indexOf(input, _Char___init__impl__6a9atx(45), 1);
  if (yearEnd < failingYearStringLength)
    return input;
  var leadingZeros = 0;
  while (charSequenceGet(input, 1 + leadingZeros | 0) === _Char___init__impl__6a9atx(48)) {
    leadingZeros = leadingZeros + 1 | 0;
  }
  if ((yearEnd - leadingZeros | 0) >= failingYearStringLength)
    return input;
  // Inline function 'kotlin.text.removeRange' call
  var endIndex = (yearEnd - failingYearStringLength | 0) + 2 | 0;
  return toString(removeRange(isCharSequence(input) ? input : THROW_CCE(), 1, endIndex));
}
function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.TimeBased', [], TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var elementName = 'nanoseconds';
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(getKClass(Long), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).xn();
  $this$buildClassSerialDescriptor.gq(elementName, descriptor, annotations, false);
  return Unit_instance;
}
function TimeBasedDateTimeUnitSerializer() {
  TimeBasedDateTimeUnitSerializer_instance = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.u2r_1 = lazy_0(tmp_0, TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
}
protoOf(TimeBasedDateTimeUnitSerializer).xn = function () {
  var tmp0 = this.u2r_1;
  // Inline function 'kotlin.getValue' call
  descriptor$factory();
  return tmp0.t();
};
protoOf(TimeBasedDateTimeUnitSerializer).v2r = function (encoder, value) {
  // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
  var descriptor = this.xn();
  var composite = encoder.kr(descriptor);
  composite.vs(TimeBasedDateTimeUnitSerializer_getInstance().xn(), 0, value.b2c_1);
  composite.lr(descriptor);
};
protoOf(TimeBasedDateTimeUnitSerializer).yn = function (encoder, value) {
  return this.v2r(encoder, value instanceof TimeBased ? value : THROW_CCE());
};
protoOf(TimeBasedDateTimeUnitSerializer).zn = function (decoder) {
  var seen = {_v: false};
  var nanoseconds = {_v: new Long(0, 0)};
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.xn();
  var composite = decoder.kr(descriptor);
  if (composite.as()) {
    nanoseconds._v = composite.qr(TimeBasedDateTimeUnitSerializer_getInstance().xn(), 0);
    seen._v = true;
  } else {
    loop: while (true) {
      var elementIndex = composite.bs(TimeBasedDateTimeUnitSerializer_getInstance().xn());
      switch (elementIndex) {
        case 0:
          nanoseconds._v = composite.qr(TimeBasedDateTimeUnitSerializer_getInstance().xn(), 0);
          seen._v = true;
          break;
        case -1:
          break loop;
        default:
          throwUnknownIndexException(elementIndex);
          break;
      }
    }
  }
  var result = Unit_instance;
  composite.lr(descriptor);
  if (!seen._v)
    throw MissingFieldException_init_$Create$('nanoseconds', this.xn().yo());
  return new TimeBased(nanoseconds._v);
};
var TimeBasedDateTimeUnitSerializer_instance;
function TimeBasedDateTimeUnitSerializer_getInstance() {
  if (TimeBasedDateTimeUnitSerializer_instance == null)
    new TimeBasedDateTimeUnitSerializer();
  return TimeBasedDateTimeUnitSerializer_instance;
}
function _get_impl__d88w17($this) {
  var tmp0 = $this.w2r_1;
  // Inline function 'kotlin.getValue' call
  impl$factory();
  return tmp0.t();
}
function DateBasedDateTimeUnitSerializer$impl$delegate$lambda() {
  var tmp = getKClass(DateBased);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(DayBased), getKClass(MonthBased)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance()];
  return new SealedClassSerializer('kotlinx.datetime.DateTimeUnit.DateBased', tmp, tmp_0, tmp$ret$5);
}
function DateBasedDateTimeUnitSerializer() {
  DateBasedDateTimeUnitSerializer_instance = this;
  AbstractPolymorphicSerializer.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.w2r_1 = lazy_0(tmp_0, DateBasedDateTimeUnitSerializer$impl$delegate$lambda);
}
protoOf(DateBasedDateTimeUnitSerializer).oo = function (decoder, klassName) {
  return _get_impl__d88w17(this).oo(decoder, klassName);
};
protoOf(DateBasedDateTimeUnitSerializer).x2r = function (encoder, value) {
  return _get_impl__d88w17(this).po(encoder, value);
};
protoOf(DateBasedDateTimeUnitSerializer).po = function (encoder, value) {
  return this.x2r(encoder, value instanceof DateBased ? value : THROW_CCE());
};
protoOf(DateBasedDateTimeUnitSerializer).mo = function () {
  return getKClass(DateBased);
};
protoOf(DateBasedDateTimeUnitSerializer).xn = function () {
  return _get_impl__d88w17(this).xn();
};
var DateBasedDateTimeUnitSerializer_instance;
function DateBasedDateTimeUnitSerializer_getInstance() {
  if (DateBasedDateTimeUnitSerializer_instance == null)
    new DateBasedDateTimeUnitSerializer();
  return DateBasedDateTimeUnitSerializer_instance;
}
function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.DayBased', [], DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().rb(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).xn();
  $this$buildClassSerialDescriptor.gq('days', descriptor, annotations, false);
  return Unit_instance;
}
function DayBasedDateTimeUnitSerializer() {
  DayBasedDateTimeUnitSerializer_instance = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.y2r_1 = lazy_0(tmp_0, DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
}
protoOf(DayBasedDateTimeUnitSerializer).xn = function () {
  var tmp0 = this.y2r_1;
  // Inline function 'kotlin.getValue' call
  descriptor$factory_0();
  return tmp0.t();
};
protoOf(DayBasedDateTimeUnitSerializer).z2r = function (encoder, value) {
  // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
  var descriptor = this.xn();
  var composite = encoder.kr(descriptor);
  composite.us(DayBasedDateTimeUnitSerializer_getInstance().xn(), 0, value.h2c_1);
  composite.lr(descriptor);
};
protoOf(DayBasedDateTimeUnitSerializer).yn = function (encoder, value) {
  return this.z2r(encoder, value instanceof DayBased ? value : THROW_CCE());
};
protoOf(DayBasedDateTimeUnitSerializer).zn = function (decoder) {
  var seen = {_v: false};
  var days = {_v: 0};
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.xn();
  var composite = decoder.kr(descriptor);
  if (composite.as()) {
    days._v = composite.pr(DayBasedDateTimeUnitSerializer_getInstance().xn(), 0);
    seen._v = true;
  } else {
    loop: while (true) {
      var elementIndex = composite.bs(DayBasedDateTimeUnitSerializer_getInstance().xn());
      switch (elementIndex) {
        case 0:
          days._v = composite.pr(DayBasedDateTimeUnitSerializer_getInstance().xn(), 0);
          seen._v = true;
          break;
        case -1:
          break loop;
        default:
          throwUnknownIndexException(elementIndex);
          break;
      }
    }
  }
  var result = Unit_instance;
  composite.lr(descriptor);
  if (!seen._v)
    throw MissingFieldException_init_$Create$('days', this.xn().yo());
  return new DayBased(days._v);
};
var DayBasedDateTimeUnitSerializer_instance;
function DayBasedDateTimeUnitSerializer_getInstance() {
  if (DayBasedDateTimeUnitSerializer_instance == null)
    new DayBasedDateTimeUnitSerializer();
  return DayBasedDateTimeUnitSerializer_instance;
}
function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.MonthBased', [], MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().rb(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).xn();
  $this$buildClassSerialDescriptor.gq('months', descriptor, annotations, false);
  return Unit_instance;
}
function MonthBasedDateTimeUnitSerializer() {
  MonthBasedDateTimeUnitSerializer_instance = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.a2s_1 = lazy_0(tmp_0, MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
}
protoOf(MonthBasedDateTimeUnitSerializer).xn = function () {
  var tmp0 = this.a2s_1;
  // Inline function 'kotlin.getValue' call
  descriptor$factory_1();
  return tmp0.t();
};
protoOf(MonthBasedDateTimeUnitSerializer).b2s = function (encoder, value) {
  // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
  var descriptor = this.xn();
  var composite = encoder.kr(descriptor);
  composite.us(MonthBasedDateTimeUnitSerializer_getInstance().xn(), 0, value.i2c_1);
  composite.lr(descriptor);
};
protoOf(MonthBasedDateTimeUnitSerializer).yn = function (encoder, value) {
  return this.b2s(encoder, value instanceof MonthBased ? value : THROW_CCE());
};
protoOf(MonthBasedDateTimeUnitSerializer).zn = function (decoder) {
  var seen = {_v: false};
  var months = {_v: 0};
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.xn();
  var composite = decoder.kr(descriptor);
  if (composite.as()) {
    months._v = composite.pr(MonthBasedDateTimeUnitSerializer_getInstance().xn(), 0);
    seen._v = true;
  } else {
    loop: while (true) {
      var elementIndex = composite.bs(MonthBasedDateTimeUnitSerializer_getInstance().xn());
      switch (elementIndex) {
        case 0:
          months._v = composite.pr(MonthBasedDateTimeUnitSerializer_getInstance().xn(), 0);
          seen._v = true;
          break;
        case -1:
          break loop;
        default:
          throwUnknownIndexException(elementIndex);
          break;
      }
    }
  }
  var result = Unit_instance;
  composite.lr(descriptor);
  if (!seen._v)
    throw MissingFieldException_init_$Create$('months', this.xn().yo());
  return new MonthBased(months._v);
};
var MonthBasedDateTimeUnitSerializer_instance;
function MonthBasedDateTimeUnitSerializer_getInstance() {
  if (MonthBasedDateTimeUnitSerializer_instance == null)
    new MonthBasedDateTimeUnitSerializer();
  return MonthBasedDateTimeUnitSerializer_instance;
}
function _get_impl__d88w17_0($this) {
  var tmp0 = $this.c2s_1;
  // Inline function 'kotlin.getValue' call
  impl$factory_0();
  return tmp0.t();
}
function DateTimeUnitSerializer$impl$delegate$lambda() {
  var tmp = getKClass(DateTimeUnit);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(DayBased), getKClass(MonthBased), getKClass(TimeBased)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance(), TimeBasedDateTimeUnitSerializer_getInstance()];
  return new SealedClassSerializer('kotlinx.datetime.DateTimeUnit', tmp, tmp_0, tmp$ret$5);
}
function DateTimeUnitSerializer() {
  DateTimeUnitSerializer_instance = this;
  AbstractPolymorphicSerializer.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.c2s_1 = lazy_0(tmp_0, DateTimeUnitSerializer$impl$delegate$lambda);
}
protoOf(DateTimeUnitSerializer).oo = function (decoder, klassName) {
  return _get_impl__d88w17_0(this).oo(decoder, klassName);
};
protoOf(DateTimeUnitSerializer).d2s = function (encoder, value) {
  return _get_impl__d88w17_0(this).po(encoder, value);
};
protoOf(DateTimeUnitSerializer).po = function (encoder, value) {
  return this.d2s(encoder, value instanceof DateTimeUnit ? value : THROW_CCE());
};
protoOf(DateTimeUnitSerializer).mo = function () {
  return getKClass(DateTimeUnit);
};
protoOf(DateTimeUnitSerializer).xn = function () {
  return _get_impl__d88w17_0(this).xn();
};
var DateTimeUnitSerializer_instance;
function DateTimeUnitSerializer_getInstance() {
  if (DateTimeUnitSerializer_instance == null)
    new DateTimeUnitSerializer();
  return DateTimeUnitSerializer_instance;
}
function throwUnknownIndexException(index) {
  throw SerializationException_init_$Create$('An unknown field for index ' + index);
}
function descriptor$factory() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.xn();
  }, null);
}
function impl$factory() {
  return getPropertyCallableRef('impl', 1, KProperty1, function (receiver) {
    return _get_impl__d88w17(receiver);
  }, null);
}
function descriptor$factory_0() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.xn();
  }, null);
}
function descriptor$factory_1() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.xn();
  }, null);
}
function impl$factory_0() {
  return getPropertyCallableRef('impl', 1, KProperty1, function (receiver) {
    return _get_impl__d88w17_0(receiver);
  }, null);
}
function InstantIso8601Serializer() {
  InstantIso8601Serializer_instance = this;
  this.e2s_1 = PrimitiveSerialDescriptor('kotlinx.datetime.Instant', STRING_getInstance());
}
protoOf(InstantIso8601Serializer).xn = function () {
  return this.e2s_1;
};
protoOf(InstantIso8601Serializer).zn = function (decoder) {
  return Companion_getInstance_14().f2s(decoder.fr());
};
protoOf(InstantIso8601Serializer).g2s = function (encoder, value) {
  encoder.os(value.toString());
};
protoOf(InstantIso8601Serializer).yn = function (encoder, value) {
  return this.g2s(encoder, value instanceof Instant_0 ? value : THROW_CCE());
};
var InstantIso8601Serializer_instance;
function InstantIso8601Serializer_getInstance() {
  if (InstantIso8601Serializer_instance == null)
    new InstantIso8601Serializer();
  return InstantIso8601Serializer_instance;
}
function LocalDateIso8601Serializer() {
  LocalDateIso8601Serializer_instance = this;
  this.h2s_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDate', STRING_getInstance());
}
protoOf(LocalDateIso8601Serializer).xn = function () {
  return this.h2s_1;
};
protoOf(LocalDateIso8601Serializer).zn = function (decoder) {
  return Companion_getInstance_15().k2s(decoder.fr());
};
protoOf(LocalDateIso8601Serializer).l2s = function (encoder, value) {
  encoder.os(value.toString());
};
protoOf(LocalDateIso8601Serializer).yn = function (encoder, value) {
  return this.l2s(encoder, value instanceof LocalDate_0 ? value : THROW_CCE());
};
var LocalDateIso8601Serializer_instance;
function LocalDateIso8601Serializer_getInstance() {
  if (LocalDateIso8601Serializer_instance == null)
    new LocalDateIso8601Serializer();
  return LocalDateIso8601Serializer_instance;
}
function LocalDateTimeIso8601Serializer() {
  LocalDateTimeIso8601Serializer_instance = this;
  this.m2s_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDateTime', STRING_getInstance());
}
protoOf(LocalDateTimeIso8601Serializer).xn = function () {
  return this.m2s_1;
};
protoOf(LocalDateTimeIso8601Serializer).zn = function (decoder) {
  return Companion_getInstance_16().p2s(decoder.fr());
};
protoOf(LocalDateTimeIso8601Serializer).q2s = function (encoder, value) {
  encoder.os(value.toString());
};
protoOf(LocalDateTimeIso8601Serializer).yn = function (encoder, value) {
  return this.q2s(encoder, value instanceof LocalDateTime_0 ? value : THROW_CCE());
};
var LocalDateTimeIso8601Serializer_instance;
function LocalDateTimeIso8601Serializer_getInstance() {
  if (LocalDateTimeIso8601Serializer_instance == null)
    new LocalDateTimeIso8601Serializer();
  return LocalDateTimeIso8601Serializer_instance;
}
function LocalTimeIso8601Serializer() {
  LocalTimeIso8601Serializer_instance = this;
  this.r2s_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalTime', STRING_getInstance());
}
protoOf(LocalTimeIso8601Serializer).xn = function () {
  return this.r2s_1;
};
protoOf(LocalTimeIso8601Serializer).zn = function (decoder) {
  return Companion_getInstance_17().u2s(decoder.fr());
};
protoOf(LocalTimeIso8601Serializer).v2s = function (encoder, value) {
  encoder.os(value.toString());
};
protoOf(LocalTimeIso8601Serializer).yn = function (encoder, value) {
  return this.v2s(encoder, value instanceof LocalTime_0 ? value : THROW_CCE());
};
var LocalTimeIso8601Serializer_instance;
function LocalTimeIso8601Serializer_getInstance() {
  if (LocalTimeIso8601Serializer_instance == null)
    new LocalTimeIso8601Serializer();
  return LocalTimeIso8601Serializer_instance;
}
function UtcOffsetSerializer() {
  UtcOffsetSerializer_instance = this;
  this.w2s_1 = PrimitiveSerialDescriptor('kotlinx.datetime.UtcOffset', STRING_getInstance());
}
protoOf(UtcOffsetSerializer).xn = function () {
  return this.w2s_1;
};
protoOf(UtcOffsetSerializer).zn = function (decoder) {
  return Companion_getInstance_20().y2s(decoder.fr());
};
protoOf(UtcOffsetSerializer).z2s = function (encoder, value) {
  encoder.os(value.toString());
};
protoOf(UtcOffsetSerializer).yn = function (encoder, value) {
  return this.z2s(encoder, value instanceof UtcOffset ? value : THROW_CCE());
};
var UtcOffsetSerializer_instance;
function UtcOffsetSerializer_getInstance() {
  if (UtcOffsetSerializer_instance == null)
    new UtcOffsetSerializer();
  return UtcOffsetSerializer_instance;
}
function TimeZoneSerializer() {
  TimeZoneSerializer_instance = this;
  this.a2t_1 = PrimitiveSerialDescriptor('kotlinx.datetime.TimeZone', STRING_getInstance());
}
protoOf(TimeZoneSerializer).xn = function () {
  return this.a2t_1;
};
protoOf(TimeZoneSerializer).zn = function (decoder) {
  return Companion_getInstance_18().c2t(decoder.fr());
};
protoOf(TimeZoneSerializer).d2t = function (encoder, value) {
  encoder.os(value.f2t());
};
protoOf(TimeZoneSerializer).yn = function (encoder, value) {
  return this.d2t(encoder, value instanceof TimeZone ? value : THROW_CCE());
};
var TimeZoneSerializer_instance;
function TimeZoneSerializer_getInstance() {
  if (TimeZoneSerializer_instance == null)
    new TimeZoneSerializer();
  return TimeZoneSerializer_instance;
}
function FixedOffsetTimeZoneSerializer() {
  FixedOffsetTimeZoneSerializer_instance = this;
  this.g2t_1 = PrimitiveSerialDescriptor('kotlinx.datetime.FixedOffsetTimeZone', STRING_getInstance());
}
protoOf(FixedOffsetTimeZoneSerializer).xn = function () {
  return this.g2t_1;
};
protoOf(FixedOffsetTimeZoneSerializer).zn = function (decoder) {
  var zone = Companion_getInstance_18().c2t(decoder.fr());
  if (zone instanceof FixedOffsetTimeZone) {
    return zone;
  } else {
    throw SerializationException_init_$Create$("Timezone identifier '" + zone.toString() + "' does not correspond to a fixed-offset timezone");
  }
};
protoOf(FixedOffsetTimeZoneSerializer).h2t = function (encoder, value) {
  encoder.os(value.f2t());
};
protoOf(FixedOffsetTimeZoneSerializer).yn = function (encoder, value) {
  return this.h2t(encoder, value instanceof FixedOffsetTimeZone ? value : THROW_CCE());
};
var FixedOffsetTimeZoneSerializer_instance;
function FixedOffsetTimeZoneSerializer_getInstance() {
  if (FixedOffsetTimeZoneSerializer_instance == null)
    new FixedOffsetTimeZoneSerializer();
  return FixedOffsetTimeZoneSerializer_instance;
}
var DayOfWeek_MONDAY_instance;
var DayOfWeek_TUESDAY_instance;
var DayOfWeek_WEDNESDAY_instance;
var DayOfWeek_THURSDAY_instance;
var DayOfWeek_FRIDAY_instance;
var DayOfWeek_SATURDAY_instance;
var DayOfWeek_SUNDAY_instance;
function values() {
  return [DayOfWeek_MONDAY_getInstance(), DayOfWeek_TUESDAY_getInstance(), DayOfWeek_WEDNESDAY_getInstance(), DayOfWeek_THURSDAY_getInstance(), DayOfWeek_FRIDAY_getInstance(), DayOfWeek_SATURDAY_getInstance(), DayOfWeek_SUNDAY_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var DayOfWeek_entriesInitialized;
function DayOfWeek_initEntries() {
  if (DayOfWeek_entriesInitialized)
    return Unit_instance;
  DayOfWeek_entriesInitialized = true;
  DayOfWeek_MONDAY_instance = new DayOfWeek_0('MONDAY', 0);
  DayOfWeek_TUESDAY_instance = new DayOfWeek_0('TUESDAY', 1);
  DayOfWeek_WEDNESDAY_instance = new DayOfWeek_0('WEDNESDAY', 2);
  DayOfWeek_THURSDAY_instance = new DayOfWeek_0('THURSDAY', 3);
  DayOfWeek_FRIDAY_instance = new DayOfWeek_0('FRIDAY', 4);
  DayOfWeek_SATURDAY_instance = new DayOfWeek_0('SATURDAY', 5);
  DayOfWeek_SUNDAY_instance = new DayOfWeek_0('SUNDAY', 6);
}
var $ENTRIES;
function DayOfWeek_0(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function toDayOfWeek(_this__u8e3s4) {
  return DayOfWeek(_this__u8e3s4.value());
}
function DayOfWeek_MONDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_MONDAY_instance;
}
function DayOfWeek_TUESDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_TUESDAY_instance;
}
function DayOfWeek_WEDNESDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_WEDNESDAY_instance;
}
function DayOfWeek_THURSDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_THURSDAY_instance;
}
function DayOfWeek_FRIDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_FRIDAY_instance;
}
function DayOfWeek_SATURDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_SATURDAY_instance;
}
function DayOfWeek_SUNDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_SUNDAY_instance;
}
function Companion_14() {
  Companion_instance_14 = this;
  var tmp = this;
  // Inline function 'kotlinx.datetime.jsTry' call
  var tmp$ret$1 = Instant.ofEpochSecond((new Long(-931914497, -750)).j3(), 999999999);
  tmp.x2b_1 = new Instant_0(tmp$ret$1);
  var tmp_0 = this;
  // Inline function 'kotlinx.datetime.jsTry' call
  var tmp$ret$3 = Instant.ofEpochSecond((new Long(1151527680, 720)).j3(), 0);
  tmp_0.y2b_1 = new Instant_0(tmp$ret$3);
  this.z2b_1 = new Instant_0(Instant.MIN);
  this.a2c_1 = new Instant_0(Instant.MAX);
}
protoOf(Companion_14).w2b = function () {
  return new Instant_0(Clock.systemUTC().instant());
};
protoOf(Companion_14).i2t = function (input, format) {
  var tmp;
  try {
    tmp = format.b2i(input).l2g();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof IllegalArgumentException) {
      var e = $p;
      throw DateTimeFormatException_init_$Create$_2("Failed to parse an instant from '" + toString(input) + "'", e);
    } else {
      throw $p;
    }
  }
  return tmp;
};
protoOf(Companion_14).f2s = function (input, format, $super) {
  format = format === VOID ? Formats_getInstance().s2f_1 : format;
  return $super === VOID ? this.i2t(input, format) : $super.i2t.call(this, input, format);
};
protoOf(Companion_14).v2g = function (epochSeconds, nanosecondAdjustment) {
  var tmp;
  try {
    // Inline function 'kotlinx.datetime.jsTry' call
    var tmp$ret$1 = Instant.ofEpochSecond(epochSeconds.j3(), nanosecondAdjustment);
    tmp = new Instant_0(tmp$ret$1);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (!isJodaDateTimeException(e))
        throw e;
      tmp_0 = epochSeconds.b1(new Long(0, 0)) > 0 ? this.a2c_1 : this.z2b_1;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
};
var Companion_instance_14;
function Companion_getInstance_14() {
  if (Companion_instance_14 == null)
    new Companion_14();
  return Companion_instance_14;
}
function Instant_0(value) {
  Companion_getInstance_14();
  this.t2g_1 = value;
}
protoOf(Instant_0).u2g = function () {
  return numberToLong(this.t2g_1.epochSecond());
};
protoOf(Instant_0).j2t = function (duration) {
  // Inline function 'kotlin.time.Duration.toComponents' call
  var tmp1 = _Duration___get_inWholeSeconds__impl__hpy7b3(duration);
  var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(duration);
  var tmp;
  try {
    tmp = new Instant_0(this.k2t(tmp1.j3(), nanoseconds));
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (!isJodaDateTimeException(e))
        throw e;
      tmp_0 = Duration__isPositive_impl_tvkkt2(duration) ? Companion_getInstance_14().a2c_1 : Companion_getInstance_14().z2b_1;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(Instant_0).k2t = function (seconds, nanos) {
  var newSeconds = this.t2g_1.epochSecond() + seconds;
  var newNanos = this.t2g_1.nano() + nanos;
  // Inline function 'kotlinx.datetime.jsTry' call
  return Instant.ofEpochSecond(newSeconds, numberToInt(newNanos));
};
protoOf(Instant_0).l2t = function (other) {
  return this.t2g_1.compareTo(other.t2g_1);
};
protoOf(Instant_0).d = function (other) {
  return this.l2t(other instanceof Instant_0 ? other : THROW_CCE());
};
protoOf(Instant_0).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof Instant_0) {
      tmp_0 = this.t2g_1 === other.t2g_1 || this.t2g_1.equals(other.t2g_1);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(Instant_0).hashCode = function () {
  return this.t2g_1.hashCode();
};
protoOf(Instant_0).toString = function () {
  return this.t2g_1.toString();
};
function isJodaDateTimeParseException(_this__u8e3s4) {
  return hasJsExceptionName(_this__u8e3s4, 'DateTimeParseException');
}
function isJodaDateTimeException(_this__u8e3s4) {
  return hasJsExceptionName(_this__u8e3s4, 'DateTimeException');
}
function isJodaArithmeticException(_this__u8e3s4) {
  return hasJsExceptionName(_this__u8e3s4, 'ArithmeticException');
}
function Companion_15() {
  Companion_instance_15 = this;
  this.i2s_1 = new LocalDate_0(LocalDate.MIN);
  this.j2s_1 = new LocalDate_0(LocalDate.MAX);
}
protoOf(Companion_15).m2t = function (input, format) {
  var tmp;
  if (format === Formats_getInstance_0().w2c()) {
    var tmp_0;
    try {
      var sanitizedInput = removeLeadingZerosFromLongYearFormLocalDate(toString(input));
      // Inline function 'kotlinx.datetime.jsTry' call
      // Inline function 'kotlin.let' call
      var p0 = LocalDate.parse(toString(sanitizedInput));
      tmp_0 = new LocalDate_0(p0);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        if (isJodaDateTimeParseException(e))
          throw DateTimeFormatException_init_$Create$_1(e);
        throw e;
      } else {
        throw $p;
      }
    }
    tmp = tmp_0;
  } else {
    tmp = format.b2i(input);
  }
  return tmp;
};
protoOf(Companion_15).k2s = function (input, format, $super) {
  format = format === VOID ? getIsoDateFormat() : format;
  return $super === VOID ? this.m2t(input, format) : $super.m2t.call(this, input, format);
};
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 == null)
    new Companion_15();
  return Companion_instance_15;
}
function Formats_0() {
  Formats_instance_0 = this;
  this.v2c_1 = get_ISO_DATE_BASIC();
}
protoOf(Formats_0).w2c = function () {
  return get_ISO_DATE();
};
var Formats_instance_0;
function Formats_getInstance_0() {
  if (Formats_instance_0 == null)
    new Formats_0();
  return Formats_instance_0;
}
function LocalDate_init_$Init$(year, monthNumber, dayOfMonth, $this) {
  var tmp;
  try {
    // Inline function 'kotlinx.datetime.jsTry' call
    tmp = LocalDate.of(year, monthNumber, dayOfMonth);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (isJodaDateTimeException(e))
        throw IllegalArgumentException_init_$Create$_0(e);
      throw e;
    } else {
      throw $p;
    }
  }
  LocalDate_0.call($this, tmp);
  return $this;
}
function LocalDate_init_$Create$(year, monthNumber, dayOfMonth) {
  return LocalDate_init_$Init$(year, monthNumber, dayOfMonth, objectCreate(protoOf(LocalDate_0)));
}
function LocalDate_0(value) {
  Companion_getInstance_15();
  this.n2g_1 = value;
}
protoOf(LocalDate_0).r2d = function () {
  return this.n2g_1.year();
};
protoOf(LocalDate_0).p2d = function () {
  return this.n2g_1.monthValue();
};
protoOf(LocalDate_0).l2i = function () {
  return toMonth(this.n2g_1.month());
};
protoOf(LocalDate_0).j2d = function () {
  return this.n2g_1.dayOfMonth();
};
protoOf(LocalDate_0).m2i = function () {
  return toDayOfWeek(this.n2g_1.dayOfWeek());
};
protoOf(LocalDate_0).l2d = function () {
  return this.n2g_1.dayOfYear();
};
protoOf(LocalDate_0).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof LocalDate_0) {
      tmp_0 = this.n2g_1 === other.n2g_1 || this.n2g_1.equals(other.n2g_1);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(LocalDate_0).hashCode = function () {
  return this.n2g_1.hashCode();
};
protoOf(LocalDate_0).toString = function () {
  return this.n2g_1.toString();
};
protoOf(LocalDate_0).n2t = function (other) {
  return this.n2g_1.compareTo(other.n2g_1);
};
protoOf(LocalDate_0).d = function (other) {
  return this.n2t(other instanceof LocalDate_0 ? other : THROW_CCE());
};
protoOf(LocalDate_0).o2g = function () {
  return numberToInt(this.n2g_1.toEpochDay());
};
function plus_0(_this__u8e3s4, value, unit) {
  return plusNumber(_this__u8e3s4, value, unit);
}
function plusNumber(_this__u8e3s4, value, unit) {
  var tmp;
  try {
    var tmp_0;
    if (unit instanceof DayBased) {
      // Inline function 'kotlinx.datetime.jsTry' call
      tmp_0 = _this__u8e3s4.n2g_1.plusDays(numberToInt(numberToDouble(value) * unit.h2c_1));
    } else {
      if (unit instanceof MonthBased) {
        // Inline function 'kotlinx.datetime.jsTry' call
        tmp_0 = _this__u8e3s4.n2g_1.plusMonths(numberToInt(numberToDouble(value) * unit.i2c_1));
      } else {
        noWhenBranchMatchedException();
      }
    }
    // Inline function 'kotlin.let' call
    var p0 = tmp_0;
    tmp = new LocalDate_0(p0);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      if (!isJodaDateTimeException(e) && !isJodaArithmeticException(e))
        throw e;
      throw DateTimeArithmeticException_init_$Create$_1('The result of adding ' + toString(value) + ' of ' + toString(unit) + ' to ' + _this__u8e3s4.toString() + ' is out of LocalDate range.', e);
    } else {
      throw $p;
    }
  }
  return tmp;
}
function LocalDateTime_init_$Init$(date, time, $this) {
  // Inline function 'kotlinx.datetime.jsTry' call
  var tmp$ret$1 = LocalDateTime.of(date.n2g_1, time.p2g_1);
  LocalDateTime_0.call($this, tmp$ret$1);
  return $this;
}
function LocalDateTime_init_$Create$(date, time) {
  return LocalDateTime_init_$Init$(date, time, objectCreate(protoOf(LocalDateTime_0)));
}
function Companion_16() {
  Companion_instance_16 = this;
  this.n2s_1 = new LocalDateTime_0(LocalDateTime.MIN);
  this.o2s_1 = new LocalDateTime_0(LocalDateTime.MAX);
}
protoOf(Companion_16).o2t = function (input, format) {
  var tmp;
  if (format === Formats_getInstance_1().y2c_1) {
    var tmp_0;
    try {
      var sanitizedInput = removeLeadingZerosFromLongYearFormLocalDateTime(toString(input));
      // Inline function 'kotlinx.datetime.jsTry' call
      // Inline function 'kotlin.let' call
      var p0 = LocalDateTime.parse(toString(sanitizedInput));
      tmp_0 = new LocalDateTime_0(p0);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        if (isJodaDateTimeParseException(e))
          throw DateTimeFormatException_init_$Create$_1(e);
        throw e;
      } else {
        throw $p;
      }
    }
    tmp = tmp_0;
  } else {
    tmp = format.b2i(input);
  }
  return tmp;
};
protoOf(Companion_16).p2s = function (input, format, $super) {
  format = format === VOID ? getIsoDateTimeFormat() : format;
  return $super === VOID ? this.o2t(input, format) : $super.o2t.call(this, input, format);
};
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 == null)
    new Companion_16();
  return Companion_instance_16;
}
function Formats_1() {
  Formats_instance_1 = this;
  this.y2c_1 = get_ISO_DATETIME();
}
var Formats_instance_1;
function Formats_getInstance_1() {
  if (Formats_instance_1 == null)
    new Formats_1();
  return Formats_instance_1;
}
function LocalDateTime_0(value) {
  Companion_getInstance_16();
  this.v2k_1 = value;
}
protoOf(LocalDateTime_0).w2k = function () {
  return new LocalDate_0(this.v2k_1.toLocalDate());
};
protoOf(LocalDateTime_0).x2k = function () {
  return new LocalTime_0(this.v2k_1.toLocalTime());
};
protoOf(LocalDateTime_0).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof LocalDateTime_0) {
      tmp_0 = this.v2k_1 === other.v2k_1 || this.v2k_1.equals(other.v2k_1);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(LocalDateTime_0).hashCode = function () {
  return this.v2k_1.hashCode();
};
protoOf(LocalDateTime_0).toString = function () {
  return this.v2k_1.toString();
};
protoOf(LocalDateTime_0).p2t = function (other) {
  return this.v2k_1.compareTo(other.v2k_1);
};
protoOf(LocalDateTime_0).d = function (other) {
  return this.p2t(other instanceof LocalDateTime_0 ? other : THROW_CCE());
};
function LocalTime_init_$Init$(hour, minute, second, nanosecond, $this) {
  second = second === VOID ? 0 : second;
  nanosecond = nanosecond === VOID ? 0 : nanosecond;
  var tmp;
  try {
    // Inline function 'kotlinx.datetime.jsTry' call
    tmp = LocalTime.of(hour, minute, second, nanosecond);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (isJodaDateTimeException(e))
        throw IllegalArgumentException_init_$Create$_0(e);
      throw e;
    } else {
      throw $p;
    }
  }
  LocalTime_0.call($this, tmp);
  return $this;
}
function LocalTime_init_$Create$(hour, minute, second, nanosecond) {
  return LocalTime_init_$Init$(hour, minute, second, nanosecond, objectCreate(protoOf(LocalTime_0)));
}
function Companion_17() {
  Companion_instance_17 = this;
  this.s2s_1 = new LocalTime_0(LocalTime.MIN);
  this.t2s_1 = new LocalTime_0(LocalTime.MAX);
}
protoOf(Companion_17).q2t = function (input, format) {
  var tmp;
  if (format === Formats_instance_2.w2c()) {
    var tmp_0;
    try {
      // Inline function 'kotlinx.datetime.jsTry' call
      // Inline function 'kotlin.let' call
      var p0 = LocalTime.parse(toString(input));
      tmp_0 = new LocalTime_0(p0);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        if (isJodaDateTimeParseException(e))
          throw DateTimeFormatException_init_$Create$_1(e);
        throw e;
      } else {
        throw $p;
      }
    }
    tmp = tmp_0;
  } else {
    tmp = format.b2i(input);
  }
  return tmp;
};
protoOf(Companion_17).u2s = function (input, format, $super) {
  format = format === VOID ? getIsoTimeFormat() : format;
  return $super === VOID ? this.q2t(input, format) : $super.q2t.call(this, input, format);
};
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 == null)
    new Companion_17();
  return Companion_instance_17;
}
function Formats_2() {
}
protoOf(Formats_2).w2c = function () {
  return get_ISO_TIME();
};
var Formats_instance_2;
function Formats_getInstance_2() {
  return Formats_instance_2;
}
function LocalTime_0(value) {
  Companion_getInstance_17();
  this.p2g_1 = value;
}
protoOf(LocalTime_0).d2e = function () {
  return this.p2g_1.hour();
};
protoOf(LocalTime_0).h2e = function () {
  return this.p2g_1.minute();
};
protoOf(LocalTime_0).l2e = function () {
  return this.p2g_1.second();
};
protoOf(LocalTime_0).j2e = function () {
  return numberToInt(this.p2g_1.nano());
};
protoOf(LocalTime_0).q2g = function () {
  return this.p2g_1.toSecondOfDay();
};
protoOf(LocalTime_0).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof LocalTime_0) {
      tmp_0 = this.p2g_1 === other.p2g_1 || this.p2g_1.equals(other.p2g_1);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(LocalTime_0).hashCode = function () {
  return this.p2g_1.hashCode();
};
protoOf(LocalTime_0).toString = function () {
  return this.p2g_1.toString();
};
protoOf(LocalTime_0).r2t = function (other) {
  return this.p2g_1.compareTo(other.p2g_1);
};
protoOf(LocalTime_0).d = function (other) {
  return this.r2t(other instanceof LocalTime_0 ? other : THROW_CCE());
};
var Month_JANUARY_instance;
var Month_FEBRUARY_instance;
var Month_MARCH_instance;
var Month_APRIL_instance;
var Month_MAY_instance;
var Month_JUNE_instance;
var Month_JULY_instance;
var Month_AUGUST_instance;
var Month_SEPTEMBER_instance;
var Month_OCTOBER_instance;
var Month_NOVEMBER_instance;
var Month_DECEMBER_instance;
function values_0() {
  return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var Month_entriesInitialized;
function Month_initEntries() {
  if (Month_entriesInitialized)
    return Unit_instance;
  Month_entriesInitialized = true;
  Month_JANUARY_instance = new Month_0('JANUARY', 0);
  Month_FEBRUARY_instance = new Month_0('FEBRUARY', 1);
  Month_MARCH_instance = new Month_0('MARCH', 2);
  Month_APRIL_instance = new Month_0('APRIL', 3);
  Month_MAY_instance = new Month_0('MAY', 4);
  Month_JUNE_instance = new Month_0('JUNE', 5);
  Month_JULY_instance = new Month_0('JULY', 6);
  Month_AUGUST_instance = new Month_0('AUGUST', 7);
  Month_SEPTEMBER_instance = new Month_0('SEPTEMBER', 8);
  Month_OCTOBER_instance = new Month_0('OCTOBER', 9);
  Month_NOVEMBER_instance = new Month_0('NOVEMBER', 10);
  Month_DECEMBER_instance = new Month_0('DECEMBER', 11);
}
var $ENTRIES_0;
function Month_0(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function toMonth(_this__u8e3s4) {
  return Month(_this__u8e3s4.value());
}
function Month_JANUARY_getInstance() {
  Month_initEntries();
  return Month_JANUARY_instance;
}
function Month_FEBRUARY_getInstance() {
  Month_initEntries();
  return Month_FEBRUARY_instance;
}
function Month_MARCH_getInstance() {
  Month_initEntries();
  return Month_MARCH_instance;
}
function Month_APRIL_getInstance() {
  Month_initEntries();
  return Month_APRIL_instance;
}
function Month_MAY_getInstance() {
  Month_initEntries();
  return Month_MAY_instance;
}
function Month_JUNE_getInstance() {
  Month_initEntries();
  return Month_JUNE_instance;
}
function Month_JULY_getInstance() {
  Month_initEntries();
  return Month_JULY_instance;
}
function Month_AUGUST_getInstance() {
  Month_initEntries();
  return Month_AUGUST_instance;
}
function Month_SEPTEMBER_getInstance() {
  Month_initEntries();
  return Month_SEPTEMBER_instance;
}
function Month_OCTOBER_getInstance() {
  Month_initEntries();
  return Month_OCTOBER_instance;
}
function Month_NOVEMBER_getInstance() {
  Month_initEntries();
  return Month_NOVEMBER_instance;
}
function Month_DECEMBER_getInstance() {
  Month_initEntries();
  return Month_DECEMBER_instance;
}
function ofZone($this, zoneId) {
  var tmp;
  if (zoneId instanceof ZoneOffset) {
    tmp = FixedOffsetTimeZone_init_$Create$(new UtcOffset(zoneId));
  } else {
    if (zoneId.rules().isFixedOffset()) {
      var tmp_0 = zoneId.normalized();
      tmp = new FixedOffsetTimeZone(new UtcOffset(tmp_0 instanceof ZoneOffset ? tmp_0 : THROW_CCE()), zoneId);
    } else {
      tmp = new TimeZone(zoneId);
    }
  }
  return tmp;
}
function Companion_18() {
  Companion_instance_18 = this;
  this.b2t_1 = asTimeZone(new UtcOffset(ZoneOffset.UTC));
}
protoOf(Companion_18).s2t = function () {
  return ofZone(this, ZoneId.systemDefault());
};
protoOf(Companion_18).c2t = function (zoneId) {
  var tmp;
  try {
    // Inline function 'kotlinx.datetime.jsTry' call
    var tmp$ret$1 = ZoneId.of(zoneId);
    tmp = ofZone(this, tmp$ret$1);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (isJodaDateTimeException(e))
        throw IllegalTimeZoneException_init_$Create$_0(e);
      throw e;
    } else {
      throw $p;
    }
  }
  return tmp;
};
var Companion_instance_18;
function Companion_getInstance_18() {
  if (Companion_instance_18 == null)
    new Companion_18();
  return Companion_instance_18;
}
function TimeZone(zoneId) {
  Companion_getInstance_18();
  this.e2t_1 = zoneId;
}
protoOf(TimeZone).f2t = function () {
  return this.e2t_1.id();
};
protoOf(TimeZone).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof TimeZone) {
      tmp_0 = this.e2t_1 === other.e2t_1 || this.e2t_1.equals(other.e2t_1);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(TimeZone).hashCode = function () {
  return this.e2t_1.hashCode();
};
protoOf(TimeZone).toString = function () {
  return this.e2t_1.toString();
};
function toLocalDateTime(_this__u8e3s4, timeZone) {
  var tmp;
  try {
    // Inline function 'kotlinx.datetime.jsTry' call
    // Inline function 'kotlin.let' call
    var p0 = LocalDateTime.ofInstant(_this__u8e3s4.t2g_1, timeZone.e2t_1);
    tmp = new LocalDateTime_0(p0);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (isJodaDateTimeException(e))
        throw DateTimeArithmeticException_init_$Create$_0(e);
      throw e;
    } else {
      throw $p;
    }
  }
  return tmp;
}
function toInstant(_this__u8e3s4, timeZone) {
  // Inline function 'kotlin.let' call
  var p0 = _this__u8e3s4.v2k_1.atZone(timeZone.e2t_1).toInstant();
  return new Instant_0(p0);
}
function FixedOffsetTimeZone_init_$Init$(offset, $this) {
  FixedOffsetTimeZone.call($this, offset, offset.r2g_1);
  return $this;
}
function FixedOffsetTimeZone_init_$Create$(offset) {
  return FixedOffsetTimeZone_init_$Init$(offset, objectCreate(protoOf(FixedOffsetTimeZone)));
}
function Companion_19() {
}
var Companion_instance_19;
function Companion_getInstance_19() {
  return Companion_instance_19;
}
function FixedOffsetTimeZone(offset, zoneId) {
  TimeZone.call(this, zoneId);
  this.u2t_1 = offset;
}
function get_isoFormat() {
  _init_properties_UtcOffset_kt__93zod7();
  var tmp0 = isoFormat$delegate;
  // Inline function 'kotlin.getValue' call
  isoFormat$factory();
  return tmp0.t();
}
var isoFormat$delegate;
function get_isoBasicFormat() {
  _init_properties_UtcOffset_kt__93zod7();
  var tmp0 = isoBasicFormat$delegate;
  // Inline function 'kotlin.getValue' call
  isoBasicFormat$factory();
  return tmp0.t();
}
var isoBasicFormat$delegate;
function get_fourDigitsFormat() {
  _init_properties_UtcOffset_kt__93zod7();
  var tmp0 = fourDigitsFormat$delegate;
  // Inline function 'kotlin.getValue' call
  fourDigitsFormat$factory();
  return tmp0.t();
}
var fourDigitsFormat$delegate;
function Companion_20() {
  Companion_instance_20 = this;
  this.x2s_1 = new UtcOffset(ZoneOffset.UTC);
}
protoOf(Companion_20).v2t = function (input, format) {
  return format === Formats_instance_3.w2c() ? parseWithFormat(input, get_isoFormat()) : format === Formats_instance_3.w2t() ? parseWithFormat(input, get_isoBasicFormat()) : format === Formats_instance_3.p2f() ? parseWithFormat(input, get_fourDigitsFormat()) : format.b2i(input);
};
protoOf(Companion_20).y2s = function (input, format, $super) {
  format = format === VOID ? getIsoUtcOffsetFormat() : format;
  return $super === VOID ? this.v2t(input, format) : $super.v2t.call(this, input, format);
};
var Companion_instance_20;
function Companion_getInstance_20() {
  if (Companion_instance_20 == null)
    new Companion_20();
  return Companion_instance_20;
}
function Formats_3() {
}
protoOf(Formats_3).w2c = function () {
  return get_ISO_OFFSET();
};
protoOf(Formats_3).w2t = function () {
  return get_ISO_OFFSET_BASIC();
};
protoOf(Formats_3).p2f = function () {
  return get_FOUR_DIGIT_OFFSET();
};
var Formats_instance_3;
function Formats_getInstance_3() {
  return Formats_instance_3;
}
function UtcOffset(zoneOffset) {
  Companion_getInstance_20();
  this.r2g_1 = zoneOffset;
}
protoOf(UtcOffset).s2g = function () {
  return this.r2g_1.totalSeconds();
};
protoOf(UtcOffset).hashCode = function () {
  return this.r2g_1.hashCode();
};
protoOf(UtcOffset).equals = function (other) {
  var tmp;
  if (other instanceof UtcOffset) {
    tmp = this.r2g_1 === other.r2g_1 || this.r2g_1.equals(other.r2g_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(UtcOffset).toString = function () {
  return this.r2g_1.toString();
};
function UtcOffset_0(hours, minutes, seconds) {
  hours = hours === VOID ? null : hours;
  minutes = minutes === VOID ? null : minutes;
  seconds = seconds === VOID ? null : seconds;
  _init_properties_UtcOffset_kt__93zod7();
  var tmp;
  try {
    var tmp_0;
    if (!(hours == null)) {
      // Inline function 'kotlinx.datetime.jsTry' call
      var tmp_1 = ZoneOffset;
      var tmp_2 = minutes == null ? 0 : minutes;
      var tmp$ret$1 = tmp_1.ofHoursMinutesSeconds(hours, tmp_2, seconds == null ? 0 : seconds);
      tmp_0 = new UtcOffset(tmp$ret$1);
    } else if (!(minutes == null)) {
      // Inline function 'kotlinx.datetime.jsTry' call
      var tmp_3 = ZoneOffset;
      var tmp_4 = minutes / 60 | 0;
      var tmp_5 = minutes % 60 | 0;
      var tmp$ret$3 = tmp_3.ofHoursMinutesSeconds(tmp_4, tmp_5, seconds == null ? 0 : seconds);
      tmp_0 = new UtcOffset(tmp$ret$3);
    } else {
      // Inline function 'kotlinx.datetime.jsTry' call
      var tmp_6 = ZoneOffset;
      var tmp$ret$5 = tmp_6.ofTotalSeconds(seconds == null ? 0 : seconds);
      tmp_0 = new UtcOffset(tmp$ret$5);
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_7;
    if ($p instanceof Error) {
      var e = $p;
      var tmp_8;
      if (isJodaDateTimeException(e)) {
        throw IllegalArgumentException_init_$Create$_0(e);
      } else {
        throw e;
      }
    } else {
      throw $p;
    }
  }
  return tmp;
}
function parseWithFormat(input, format) {
  _init_properties_UtcOffset_kt__93zod7();
  var tmp;
  try {
    // Inline function 'kotlinx.datetime.jsTry' call
    tmp = format.parse(toString(input)).get(ChronoField.OFFSET_SECONDS);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (isJodaDateTimeParseException(e))
        throw DateTimeFormatException_init_$Create$_1(e);
      if (isJodaDateTimeException(e))
        throw DateTimeFormatException_init_$Create$_1(e);
      throw e;
    } else {
      throw $p;
    }
  }
  return UtcOffset_0(VOID, VOID, tmp);
}
function isoFormat$delegate$lambda() {
  _init_properties_UtcOffset_kt__93zod7();
  return (new DateTimeFormatterBuilder()).parseCaseInsensitive().appendOffsetId().toFormatter(ResolverStyle.STRICT);
}
function isoBasicFormat$delegate$lambda() {
  _init_properties_UtcOffset_kt__93zod7();
  return (new DateTimeFormatterBuilder()).parseCaseInsensitive().appendOffset('+HHmmss', 'Z').toFormatter(ResolverStyle.STRICT);
}
function fourDigitsFormat$delegate$lambda() {
  _init_properties_UtcOffset_kt__93zod7();
  return (new DateTimeFormatterBuilder()).parseCaseInsensitive().appendOffset('+HHMM', '+0000').toFormatter(ResolverStyle.STRICT);
}
function isoFormat$factory() {
  return getPropertyCallableRef('isoFormat', 0, KProperty0, function () {
    return get_isoFormat();
  }, null);
}
function isoBasicFormat$factory() {
  return getPropertyCallableRef('isoBasicFormat', 0, KProperty0, function () {
    return get_isoBasicFormat();
  }, null);
}
function fourDigitsFormat$factory() {
  return getPropertyCallableRef('fourDigitsFormat', 0, KProperty0, function () {
    return get_fourDigitsFormat();
  }, null);
}
var properties_initialized_UtcOffset_kt_4gxffr;
function _init_properties_UtcOffset_kt__93zod7() {
  if (!properties_initialized_UtcOffset_kt_4gxffr) {
    properties_initialized_UtcOffset_kt_4gxffr = true;
    isoFormat$delegate = lazy(isoFormat$delegate$lambda);
    isoBasicFormat$delegate = lazy(isoBasicFormat$delegate$lambda);
    fourDigitsFormat$delegate = lazy(fourDigitsFormat$delegate$lambda);
  }
}
function safeMultiply(a, b) {
  if (b.equals(new Long(-1, -1))) {
    if (a.equals(new Long(0, -2147483648))) {
      throw ArithmeticException_init_$Create$('Multiplication overflows a long: ' + a.toString() + ' * ' + b.toString());
    }
    return a.y2();
  } else if (b.equals(new Long(0, 0)))
    return new Long(0, 0);
  else if (b.equals(new Long(1, 0)))
    return a;
  var total = a.t2(b);
  if (!total.u2(b).equals(a)) {
    throw ArithmeticException_init_$Create$('Multiplication overflows a long: ' + a.toString() + ' * ' + b.toString());
  }
  return total;
}
function safeAdd(a, b) {
  var sum = a.r2(b);
  if (a.g3(sum).b1(new Long(0, 0)) < 0 && a.g3(b).b1(new Long(0, 0)) >= 0) {
    throw ArithmeticException_init_$Create$('Addition overflows a long: ' + a.toString() + ' + ' + b.toString());
  }
  return sum;
}
function safeMultiply_0(a, b) {
  // Inline function 'kotlin.Long.times' call
  var result = toLong(a).t2(toLong(b));
  if (result.b1(new Long(2147483647, 0)) > 0 || result.b1(new Long(-2147483648, -1)) < 0)
    throw ArithmeticException_init_$Create$('Multiplication overflows Int range: ' + a + ' * ' + b + '.');
  return result.d1();
}
function hasJsExceptionName(_this__u8e3s4, name) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.name == name;
}
//region block: post-declaration
protoOf(Builder).d2h = appendAlternativeParsingImpl;
protoOf(Builder).e2h = appendOptionalImpl;
protoOf(Builder).l2f = chars;
protoOf(Builder).r2f = build;
protoOf(Builder).f2h = addFormatStructureForDate;
protoOf(Builder).g2h = addFormatStructureForTime;
protoOf(Builder).h2h = year;
protoOf(Builder).k2f = year$default;
protoOf(Builder).i2h = monthNumber;
protoOf(Builder).j2h = monthNumber$default;
protoOf(Builder).j2f = monthName;
protoOf(Builder).g2f = dayOfMonth;
protoOf(Builder).k2h = dayOfMonth$default;
protoOf(Builder).o2f = dayOfWeek;
protoOf(Builder).z2e = date;
protoOf(Builder).l2h = hour;
protoOf(Builder).a2f = hour$default;
protoOf(Builder).m2h = minute;
protoOf(Builder).b2f = minute$default;
protoOf(Builder).n2h = second;
protoOf(Builder).c2f = second$default;
protoOf(Builder).d2f = secondFraction;
protoOf(Builder).o2h = time;
protoOf(Builder).p2h = offsetHours;
protoOf(Builder).e2f = offsetHours$default;
protoOf(Builder).q2h = offsetMinutesOfHour;
protoOf(Builder).r2h = offsetMinutesOfHour$default;
protoOf(Builder).s2h = offsetSecondsOfMinute;
protoOf(Builder).t2h = offsetSecondsOfMinute$default;
protoOf(Builder).f2f = offset;
protoOf(Builder_0).d2h = appendAlternativeParsingImpl;
protoOf(Builder_0).e2h = appendOptionalImpl;
protoOf(Builder_0).l2f = chars;
protoOf(Builder_0).r2f = build;
protoOf(Builder_0).h2h = year;
protoOf(Builder_0).k2f = year$default;
protoOf(Builder_0).i2h = monthNumber;
protoOf(Builder_0).j2h = monthNumber$default;
protoOf(Builder_0).g2f = dayOfMonth;
protoOf(Builder_0).k2h = dayOfMonth$default;
protoOf(Builder_1).d2h = appendAlternativeParsingImpl;
protoOf(Builder_1).e2h = appendOptionalImpl;
protoOf(Builder_1).l2f = chars;
protoOf(Builder_1).r2f = build;
protoOf(Builder_1).f2h = addFormatStructureForDate;
protoOf(Builder_1).g2h = addFormatStructureForTime;
protoOf(Builder_1).h2h = year;
protoOf(Builder_1).k2f = year$default;
protoOf(Builder_1).i2h = monthNumber;
protoOf(Builder_1).j2h = monthNumber$default;
protoOf(Builder_1).g2f = dayOfMonth;
protoOf(Builder_1).k2h = dayOfMonth$default;
protoOf(Builder_1).z2e = date;
protoOf(Builder_1).l2h = hour;
protoOf(Builder_1).a2f = hour$default;
protoOf(Builder_1).m2h = minute;
protoOf(Builder_1).b2f = minute$default;
protoOf(Builder_1).n2h = second;
protoOf(Builder_1).c2f = second$default;
protoOf(Builder_1).d2f = secondFraction;
protoOf(Builder_1).o2h = time;
protoOf(IncompleteLocalTime).a2e = set_fractionOfSecond;
protoOf(IncompleteLocalTime).b2e = get_fractionOfSecond;
protoOf(Builder_2).d2h = appendAlternativeParsingImpl;
protoOf(Builder_2).e2h = appendOptionalImpl;
protoOf(Builder_2).l2f = chars;
protoOf(Builder_2).r2f = build;
protoOf(Builder_2).l2h = hour;
protoOf(Builder_2).a2f = hour$default;
protoOf(Builder_2).m2h = minute;
protoOf(Builder_2).b2f = minute$default;
protoOf(Builder_2).n2h = second;
protoOf(Builder_2).c2f = second$default;
protoOf(Builder_2).d2f = secondFraction;
protoOf(Builder_3).d2h = appendAlternativeParsingImpl;
protoOf(Builder_3).e2h = appendOptionalImpl;
protoOf(Builder_3).l2f = chars;
protoOf(Builder_3).r2f = build;
protoOf(Builder_3).p2h = offsetHours;
protoOf(Builder_3).e2f = offsetHours$default;
protoOf(Builder_3).q2h = offsetMinutesOfHour;
protoOf(Builder_3).r2h = offsetMinutesOfHour$default;
protoOf(Builder_3).s2h = offsetSecondsOfMinute;
protoOf(Builder_3).t2h = offsetSecondsOfMinute$default;
protoOf(PropertyAccessor).q2n = getterNotNull;
protoOf(SpacePaddedFormatter).i2i = format$default;
protoOf(SignedFormatter).i2i = format$default;
protoOf(ConditionalFormatter).i2i = format$default;
protoOf(ConcatenatedFormatter).i2i = format$default;
protoOf(SignedIntFormatterStructure).i2i = format$default;
protoOf(UnsignedIntFormatterStructure).i2i = format$default;
protoOf(StringFormatterStructure).i2i = format$default;
protoOf(DecimalFractionFormatterStructure).i2i = format$default;
protoOf(ConstantStringFormatterStructure).i2i = format$default;
//endregion
//region block: init
System_instance = new System();
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Companion_instance_4 = new Companion_4();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Companion_instance_11 = new Companion_11();
Companion_instance_12 = new Companion_12();
Truth_instance = new Truth();
ExpectedInt_instance = new ExpectedInt();
Companion_instance_13 = new Companion_13();
Formats_instance_2 = new Formats_2();
Companion_instance_19 = new Companion_19();
Formats_instance_3 = new Formats_3();
//endregion
//region block: exports
export {
  InstantIso8601Serializer_getInstance as InstantIso8601Serializer_getInstancerozk8wbw256e,
  LocalDateIso8601Serializer_getInstance as LocalDateIso8601Serializer_getInstance3ex7tmain73il,
  System_instance as System_instance3bcuv0kn0rmcj,
  Formats_getInstance_0 as Formats_getInstance1irqalmffdr0o,
  Companion_getInstance_16 as Companion_getInstancevs8qhtsjhyer,
  Companion_getInstance_18 as Companion_getInstance2irhlaa79e82g,
  DayOfWeek as DayOfWeek2xlo40o03f5e,
  DayOfWeek_0 as DayOfWeek37vs35iepos46,
  Instant_0 as Instant3cn81rq2kpflk,
  format as format2n4cpzximuj7a,
  toInstant as toInstant2q17i3aluy6ks,
  toLocalDateTime as toLocalDateTime3u4c8ydzr4ubp,
};
//endregion

